/* eslint-disable no-console */
import React, { Component, Fragment } from 'react'
// import path from 'path'
import {
  Row, Col, Typography, Form, Table, Modal, Select, Tooltip, Input, InputNumber, Button, Checkbox, Space, Spin, Popconfirm, Switch, Popover, notification,
  Tag,
  Tabs,
  Card,
  Drawer,
  Radio,
  Upload,
} from 'antd'
import {
  SearchOutlined, CloseCircleFilled, /*SaveOutlined, PlusOutlined,*/ CheckCircleFilled, /* CheckCircleTwoTone,*/ InfoCircleFilled, /*PaperClipOutlined*/
  LoadingOutlined, CaretRightOutlined, CaretDownOutlined,
  FileExcelOutlined,
  // FilePdfOutlined,
  SnippetsOutlined,
  DownloadOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import addIcon from '../../../../assets/images/add.png'
import editIcon from '../../../../assets/images/edit.png'
import deleteIcon from '../../../../assets/images/delete.png'
import restoreIcon from '../../../../assets/images/restore.svg'
import Update from '../../../../assets/images/input-tick.svg'
import documentIcon from '../../../../assets/images/document.svg'
import ULDicon from '../../../../assets/images/uld_icon.png'
import SplitIcon from '../../../../assets/images/split.svg'
import RedirectIcon from '../../../../assets/images/open-external-link.svg'
import planeDarkIcon from '../../../../assets/images/plane-icon-dark.svg'
import planeLightIcon from '../../../../assets/images/plane-icon-light.svg'
import Cookies from 'universal-cookie'
import cssconstants from '../../../../constants/cssconstants'
import moment from 'moment'
import { constants, ch_wt_goals, /*station as org_stations*/ } from '../../../../constants/constants'
import '../../index.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import http from '../../../../utils/http'
import { cloneDeep } from 'lodash'
import WeightAndBalance from './weight-balance-planner'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import html2canvas from 'html2canvas'
const country = ['USA', 'U.S. VIRGIN ISLANDS', 'PUERTO RICO']
import get_bin_config from './bin_config'
import getAwbs from './getAwbs'
import getScrubData from './getScrubData'
import AppSyncEventManager from '../../../../utils/AppSyncEventManager'

const cookies = new Cookies()

const { Title, Text } = Typography
const { Option } = Select
const { Search } = Input
const { TabPane } = Tabs
const dateTimeFormat = 'DDMMMYY HH:mm'
const dateOnly = 'DDMMMYY'
const const_ulds = ['PMC', 'PAG', 'LD2', 'LD3', 'LD4', 'LD8', 'AKE', 'PLA', 'PLB', 'AKN', 'AKX', 'AKY', 'DPA', 'DPE', 'DPL', 'DPN', 'DQL', 'DQP', 'DQF', 'FQA']
const uld_colors = [
  {
    name: 'blue',
    code: '#0000FF'
  },
  {
    name: 'purple',
    code: '#800080'
  },
  {
    name: 'cyan',
    code: '#00FFFF'
  },
  {
    name: 'magenta',
    code: '#FF00FF'
  },
  {
    name: 'red',
    code: '#FF0000'
  },
  {
    name: 'green',
    code: '#00FF00'
  },
  {
    name: 'yellow',
    code: '#FFFF00'
  },
  {
    name: 'orange',
    code: '#FFA500'
  },
  {
    name: 'pink',
    code: '#FFC0CB'
  },
  {
    name: 'brown',
    code: '#A52A2A'
  },
  {
    name: 'indigo',
    code: '#4B0082'
  },
  {
    name: 'teal',
    code: '#008080'
  },
  {
    name: 'lavender',
    code: '#E6E6FA'
  },
  {
    name: 'gold',
    code: '#FFD700'
  },
  {
    name: 'silver',
    code: '#C0C0C0'
  },
  {
    name: 'gray',
    code: '#808080'
  },
  {
    name: 'maroon',
    code: '#800000'
  },
  {
    name: 'olive',
    code: '#808000'
  },
  {
    name: 'turquoise',
    code: '#40E0D0'
  },
  {
    name: 'slate blue',
    code: '#6A5ACD'
  }
]

const formatWeight = function (weight) {
  if(weight) return parseFloat(weight)?.toFixed(1)
  else return ''
}

const weightCalculator = function (weight, unit) {
  switch (unit) {
  case 'KGM':
    weight = weight * 2.204623
    break
  case 'LBS':
    weight = weight * 0.4535924
    break
  default:
    break
  }
  return weight
}

const volumnCalculator = function (vol, unit) {
  switch (unit) {
  case 'CBF':
    vol = vol / 35.3147
    break
  case 'CBM':
    vol = vol * 35.3147
    break
  default:
    break
  }
  return vol
}

const legendPopover = (
  <div className='width-250 fs-10'>
    <Row gutter={[8, 8]}>
      <Col span={7}>AS</Col>
      <Col span={17}>Cargo checked in at station</Col>

      <Col span={7}><img src={planeDarkIcon} width='12' height='12' alt='plane' /></Col>
      <Col span={17}>Cargo enroute to station</Col>

      <Col span={7}><Text type='success'>C</Text></Col>
      <Col span={17}>Cargo at station built up, ULD closed</Col>

      <Col span={7}><Text type='danger'>O</Text></Col>
      <Col span={17}>Cargo at station built up, ULD open</Col>

      <Col span={7}>1 | 111 | 1</Col>
      <Col span={17}>AWBS | WEIGHT | VOLUME</Col>
    </Row>
  </div>
)
class BuildPlan extends Component {
  constructor(props) {
    super(props)
    this.modalRef = React.createRef()
    this.emailPreviewRef = React.createRef()
    this.state = {
      modalLoading: false,
      loadplanvisible: false,
      awbSearch: '',
      station: new Cookies().get('station'),
      user_id: new Cookies().get('id'),
      timezone: new Cookies().get('timezone'),
      ext: moment().tz(new Cookies().get('timezone')).format('z'),
      userList: [],
      showAlloc: false,
      ccView: false,

      editRecord: null,
      editAllocRecord: null,
      deleteAllocID: null,
      mergeEditRecord: null,
      initmergeEditRecord: null,
      finalmergeEditRecord: null,

      editFcst: 0,
      editBagLD3: 0,
      editBagLD2: 0,
      editCargoP96: 0,
      editCargoP88: 0,
      editCargoLD3: 0,
      editCargoLD2: 0,
      editWgtValue: 0,
      editWgtUnit: new Cookies().get('weight') || 'LB',
      editBuPrio: false,
      editAllocArray: [],
      lastUpdatedAt: '',
      lastUpdatedBy: '',
      lastUpdatedPpr: '',

      editPos: '',
      editType: '',
      editWorkArea: '',
      editULDAWB: '',
      editProd: '',
      editComm1: '',
      editComm2: '',

      editTPos: '',
      editTType: '',
      editTWorkArea: '',
      editTULDAWB: '',
      editTProd: '',
      editTComm1: '',
      editTComm2: '',

      remainingP96: 0,
      remainingP88: 0,
      remainingLD3: 0,
      remainingLD2: 0,
      remainingMD: 0,

      isWideBody: false,
      hints: '',
      notes: '',
      editAwbs: {},
      editAwbsRecord: null,

      optiUld: {},
      editOptiUld: {},
      chblWgtGoal: null,
      optiLoader: false,
      assignLoader: false,
      clearLoader: false,
      switch: true,

      priority: true,

      activeTab: 'bp',
      showSaveIcon: false,

      weight_unit: new Cookies().get('weight') || 'LB',
      addULD: false,
      assignUld: null,

      buildPlanDrawerVisible: false,
      emailRadioValue: null,
      emailLogs: [],
      emailPreviewVisible: false,
      selectedEmail: null,
      priorityData: this.props.priorityData || [],
    }
    this._queue = []
    this._isBusy = false
    this.visibilityTimeout = null
    this.flightControlEvents = null
    this.eventManager = null
    this.assignUldFormRef = React.createRef()
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    this.fetchUserList()
    if(!this.props.flightId) return
    this.fetchFlight()
    this.startEvent()
    this.setState({ priorityData: this.props.priorityData || [] })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.flightId !== this.props.flightId && this.props.flightId != null) {
      this.fetchFlight()
      this.startEvent()
      this.setState({ priorityData: this.props.priorityData || [] })
    }
  }

  componentWillUnmount() {
    if (this.eventManager) {
      this.eventManager.unsubscribe()
    }
  }

  startEvent= () => {
    if (this.eventManager) {
      this.eventManager.unsubscribe()
    }
    this.eventManager = AppSyncEventManager.subscribe('/build-plan/'+this.state.station+'/'+this.props.flightId, (data) => {
      const myFakeAsyncJob = this.getFakeAsyncJob(data)
      this.enqueue(myFakeAsyncJob)
    })
  }

  enqueue = (job) => {
    // we'll wrap the job in a promise and include the resolve and reject functions in the job we'll enqueue, so we can control when we resolve and execute them sequentially
    new Promise((resolve, reject) => {
      this._queue.push({
        job,
        resolve,
        reject
      })
    })
    // we'll add a nextJob function and call it when we enqueue a new job; we'll use _isBusy to make sure we're executing the next job sequentially
    this.nextJob()
  }
  nextJob = () => {
    if (this._isBusy) return
    const next = this._queue.shift()
    // if the array is empty shift() will return undefined
    if (next) {
      this._isBusy = true
      next
        .job()
        .then((value) => {
          this.eventList(value)
          next.resolve(value)
          this._isBusy = false
          this.nextJob()
        })
        .catch((error) => {
          next.reject(error)
          this._isBusy = false
          this.nextJob()
        })
    }
  }
  getFakeAsyncJob = (item) => {
    return () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(item)
        }, 600)
      })
  }

  eventList = (parsedData) => {
    if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'UPDATE' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'DETAILS')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'PLAN' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'PLAN')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'wgt_bal_plan' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'wgt_bal_plan')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'build_plan_lock' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'build_plan_lock')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && (parsedData?.msg === 'BUILD_ULD' || parsedData?.msg === 'CREATE_ULD') && (parsedData?.Action === 'ADD' || parsedData?.Action === 'UPDATE' || parsedData?.Action === 'REMOVE')) {
      this.updateFlightDetails(parsedData?.DETAILS?.data, parsedData?.msg)
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'BUILD_AWB' && (parsedData?.Action === 'UPDATE' || parsedData?.Action === 'ADD')) {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'BUILD_AWB')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'BUILD_AWB' && parsedData?.Action === 'REMOVE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'BUILD_AWB_REMOVE')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'email_load_plan' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'email_load_plan')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'scrub_copy' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'scrub_copy')
    }
    // else if (parsedData?.TYPE === 'FLIGHT_EVENT') {
    //   this.updateFlight(parsedData?.DETAILS, 'DEPARTURE')
    // } else if (parsedData?.TYPE === 'FSU' && parsedData?.msg === 'MAN') {
    //   this.updateFlight(parsedData?.DETAILS?.data, 'BUILDUP')
    // } else if (parsedData?.TYPE === 'FSU' && parsedData?.msg === 'GATE') {
    //   this.updateFlight(parsedData?.DETAILS?.data, 'GATE')
    // } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'UPDATE') {
    //   this.updateFlight(parsedData?.DETAILS, 'BOOKING')
    // } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'ADD') {
    //   this.addAWB_segment(parsedData?.DETAILS)
    // } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'REMOVE') {
    //   this.removeAWB_segment(parsedData?.DETAILS)
    // } 
    // else if(parsedData?.TYPE === 'GLOBAL_DETAILS') {
    //   this.fetchGlobalDetails('EVENT')
    // }
  }

  updateFlightDetails = async (DETAILS, UPDATE_TYPE) => {
    let DATA = cloneDeep(this.state.editRecord)
  
    if (UPDATE_TYPE === 'wgt_bal_plan') {
      DATA = {
        ...DATA,
        ...DETAILS
      }
      this.setState({ editRecord: DATA })
    }
    if (UPDATE_TYPE === 'build_plan_lock') {
      if (DETAILS?.type && DETAILS?.type == 'Initial') {
        DATA.init_build_plan = DETAILS?.init_build_plan || false
        this.setState({ initmergeEditRecord: DETAILS?.init_build_plan?.data?.mergeEditRecord || null })
      } else if (DETAILS?.type && DETAILS?.type == 'Final') {
        DATA.final_build_plan = DETAILS?.final_build_plan || false
        this.setState({ finalmergeEditRecord: DETAILS?.final_build_plan?.data?.mergeEditRecord || null })
      }
      this.setState({ editRecord: DATA })
    }
    if (UPDATE_TYPE === 'email_load_plan') {
      DATA.dod_email = DETAILS?.dod_email || []
      this.setState({ flightData: DATA }, () => {
        if (this.state.editRecord && DETAILS?.id == this.state.editRecord?.id) {
          this.setState({ editRecord: DATA })
        }
      })
    }
  
    if (UPDATE_TYPE === 'BUILD_AWB' || UPDATE_TYPE === 'BUILD_ULD' || UPDATE_TYPE === 'BUILD_AWB_REMOVE') {
      if (UPDATE_TYPE === 'BUILD_ULD') {
        if (DETAILS && DETAILS?.ulds) {
          this.setState({ assignedUldsData: DETAILS?.ulds })
        }
      }
      let build_plan = cloneDeep(DATA.build_plan || [])
      let awb_index = DATA.build_plan?.findIndex(p => p?.id == DETAILS?.id)
      if (UPDATE_TYPE === 'BUILD_AWB_REMOVE') {
        console.log(DETAILS, 'DETAILS')
        if (awb_index > -1) {
          build_plan.splice(awb_index, 1)
        }
      } else {
        if (awb_index > -1) {
          build_plan[awb_index] = DETAILS
        }
        else {
          build_plan.push(DETAILS)
        }
      }
      DATA.build_plan = build_plan
      this.setState({ flightData: DATA }, () => {
        if (this.state.editRecord && DETAILS?.flights_id == this.state.editRecord?.id) {
          this.setState({ editRecord: DATA }, () => {
            this.bookedULD()
            if (this.state.flightDetails?.id == DETAILS?.id) {
              this.setState({
                flightDetails: {
                  ...this.state.flightDetails,
                  ...DETAILS
                }
              }, () => {
                this.fetchUlds()
              })
            }
          })
        }
      })
      
    }
    if (UPDATE_TYPE === 'scrub_copy') {
      DATA = {
        ...DATA,
        scrub_data: DETAILS?.scrub_data || {}
      }
      this.setState({ editRecord: DATA })
    }
  
    if (UPDATE_TYPE === 'CREATE_ULD') {
      let build_uld = cloneDeep(DATA.build_uld || [])
      if (DETAILS && DETAILS?.delete) {
        let uld_index = build_uld.findIndex(p => p?.id == DETAILS?.id)
        if (uld_index > -1) {
          build_uld.splice(uld_index, 1)
        }
      } else {
        let uld_index = build_uld.findIndex(p => p?.id == DETAILS?.id)
        if (uld_index > -1) {
          build_uld[uld_index] = DETAILS
        }
        else {
          build_uld.push(DETAILS)
        }
      }
      DATA.build_uld = build_uld
      this.setState({ flightData: DATA }, () => {
        if (this.state.editRecord && DETAILS?.flights_id == this.state.editRecord?.id) {
          this.setState({ editRecord: DATA }, () => {
            this.bookedULD()
            if (this.state.flightDetails?.id == DETAILS?.id) {
              this.setState({ flightDetails: DETAILS }, () => {
                this.fetchUlds()
              })
            }
          })
        }
      })
      
    }
  
    if (DETAILS?.flight_date) {

      if (UPDATE_TYPE === 'DETAILS') {
        DATA = { ...this.parseFlight(DATA, DETAILS) }
      } else if (UPDATE_TYPE === 'PLAN') {
        DATA.details = DETAILS?.details || []
      }
      if (DETAILS?.last_updated?.length > 0) {
        let user_obj = this.state.userList?.find((item) => item?.id === parseInt(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.user_id))
        DATA.last_updated = DETAILS?.last_updated
        DATA.last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
        DATA.last_updated_at = moment.utc(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
        DATA.last_updated_ppr = `${user_obj?.ppr}` || ''
      }
      let unit = DATA?.wgt?.unit
      let value = DATA?.wgt?.value
      if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
        DATA.weight_lbs = parseFloat(value) //ROUNDED TO NEAREST INTEGER
        DATA.weight_kg = weightCalculator(parseFloat(value), 'LBS')
      } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
        DATA.weight_kg = parseFloat(value) //ROUNDED TO NEAREST INTEGER
        DATA.weight_lbs = weightCalculator(parseFloat(value), 'KGM')
      }
      this.setState({ 
        editRecord: DATA,
        editFcst: DATA?.fcst || 0,
        editBagP96: DATA?.bag?.p96 || 0,
        editBagP88: DATA?.bag?.p88 || 0,
        editBagLD3: DATA?.bag?.ld3 || 0,
        editBagLD2: DATA?.bag?.ld2 || 0,
        editCargoMD: DATA?.cargo?.md || 0,
        editCargoP96: DATA?.cargo?.p96 || 0,
        editCargoP88: DATA?.cargo?.p88 || 0,
        editCargoLD3: DATA?.cargo?.ld3 || 0,
        editCargoLD2: DATA?.cargo?.ld2 || 0,
        notes: DATA?.cargo?.notes || '',
        hints: DATA?.cargo?.hints || '',
        editHints: '',
        editNotes: '',
        editWgtValue: this.state.weight_unit === 'KG' ? parseFloat(DATA?.weight_kg || 0)?.toFixed(2) : parseFloat(DATA?.weight_lbs || 0)?.toFixed(2),
        editWgtUnit: this.state.weight_unit === 'KG' ? 'KG' : 'LB',
        editBuPrio: DATA?.bu_prio || false,
        editIsExceeded: DATA?.load_plan || false,
        previewFwd: process.env.REACT_APP_API_URL+'get_file?key='+DATA?.fwd_conf?.path,
        previewAft: process.env.REACT_APP_API_URL+'get_file?key='+DATA?.aft_conf?.path,
        lastUpdatedBy: DATA?.last_updated_by,
        lastUpdatedAt: DATA?.last_updated_at,
        lastUpdatedPpr: DATA?.last_updated_ppr,
        editAllocArray: DATA?.details || [],
      })
    }
  }

  parseFlight = (flight, event_record) => {
    let flightObj = {
      bag: {},
      cargo: {},
      wgt: {},
    }

    flight.fcst = event_record?.fcst ? parseInt(event_record?.fcst) : 0
    flight.bu_prio = event_record?.bu_prio === 'true' || event_record?.bu_prio === true ? true : false
    flight.load_plan = event_record?.load_plan === 'true' || event_record?.load_plan === true ? true : false

    flightObj.bag.p96 = event_record?.bag?.p96 ? parseInt(event_record.bag.p96) : 0
    flightObj.bag.p88 = event_record?.bag?.p88 ? parseInt(event_record.bag.p88) : 0
    flightObj.bag.ld3 = event_record?.bag?.ld3 ? parseInt(event_record.bag.ld3) : 0
    flightObj.bag.ld2 = event_record?.bag?.ld2 ? parseInt(event_record.bag.ld2) : 0
    flight.bag = flightObj.bag

    flightObj.cargo.md = event_record?.cargo?.md ? parseInt(event_record.cargo.md) : 0
    flightObj.cargo.p96 = event_record?.cargo?.p96 ? parseInt(event_record.cargo.p96) : 0
    flightObj.cargo.p88 = event_record?.cargo?.p88 ? parseInt(event_record.cargo.p88) : 0
    flightObj.cargo.ld3 = event_record?.cargo?.ld3 ? parseInt(event_record.cargo.ld3) : 0
    flightObj.cargo.ld2 = event_record?.cargo?.ld2 ? parseInt(event_record.cargo.ld2) : 0
    flight.cargo = flightObj.cargo

    flightObj.wgt.value = event_record?.wgt?.value ? parseFloat(event_record.wgt.value) : 0
    flightObj.wgt.unit = event_record?.wgt?.unit
    flight.wgt = flightObj.wgt
    return flight
  }

  fetchFlight = () => {
    http.get('/bp_flight/' + this.props.flightId).then(({ data }) => {
      let unit = data?.data?.wgt?.unit
      let value = data?.data?.wgt?.value
      if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
        data.data.weight_lbs = parseFloat(value) //ROUNDED TO NEAREST INTEGER
        data.data.weight_kg = weightCalculator(parseFloat(value), 'LBS')
      } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
        data.data.weight_kg = parseFloat(value) //ROUNDED TO NEAREST INTEGER
        data.data.weight_lbs = weightCalculator(parseFloat(value), 'KGM')
      }

      let org_dst = data?.data?.org_stn + data?.data?.dest_stn
      let goal = ch_wt_goals.find((item) => item.lane == org_dst) || {
        lane: org_dst,
        kg: 500,
        lbs: 1100
      }
      data.data.last_updated_by = ''
      data.data.last_updated_at = ''
      data.data.last_updated_ppr = ''
      if (data?.data?.last_updated?.length > 0) {
        let user_obj = this.state.userList?.find((item) => item?.id === parseInt(data.data.last_updated[data.data.last_updated.length - 1]?.user_id))
        data.data.last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
        data.data.last_updated_at = moment.utc(data.data.last_updated[data.data.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
        data.data.last_updated_ppr = `${user_obj?.ppr}` || ''
      }
      this.setState({
        editRecord: {
          ...(this.props.flightData || {}),
          ...(data?.data || {}),
        },
        chblWgtGoal: goal,
        editFcst: data?.data?.fcst || 0,
        editBagP96: data?.data?.bag?.p96 || 0,
        editBagP88: data?.data?.bag?.p88 || 0,
        editBagLD3: data?.data?.bag?.ld3 || 0,
        editBagLD2: data?.data?.bag?.ld2 || 0,
        editCargoMD: data?.data?.cargo?.md || 0,
        editCargoP96: data?.data?.cargo?.p96 || 0,
        editCargoP88: data?.data?.cargo?.p88 || 0,
        editCargoLD3: data?.data?.cargo?.ld3 || 0,
        editCargoLD2: data?.data?.cargo?.ld2 || 0,
        notes: data?.data?.cargo?.notes || '',
        hints: data?.data?.cargo?.hints || '',
        editHints: '',
        editNotes: '',
        editWgtValue: this.state.weight_unit === 'KG' ? parseFloat(data?.data?.weight_kg || 0)?.toFixed(2) : parseFloat(data?.data?.weight_lbs || 0)?.toFixed(2),
        editWgtUnit: this.state.weight_unit === 'KG' ? 'KG' : 'LB',
        editBuPrio: data?.data?.bu_prio || false,
        editIsExceeded: data?.data?.load_plan || false,
        previewFwd: process.env.REACT_APP_API_URL+'get_file?key='+data?.data?.fwd_conf?.path,
        previewAft: process.env.REACT_APP_API_URL+'get_file?key='+data?.data?.aft_conf?.path,
        lastUpdatedBy: data?.data?.last_updated_by,
        lastUpdatedAt: data?.data?.last_updated_at,
        lastUpdatedPpr: data?.data?.last_updated_ppr,
        isWideBody: this.props.flightData?.acpt_body,
        editAllocArray: data?.data?.details || [],
      }, () => {
        this.bookedULD()
        this.fetchEmailLogs(this.state.editRecord.id)
      })
    })
  }

  fetchUserList = () => {
    http.get('/users?sa=true',{ headers: { station: this.state.station } }).then(({ data }) => {
      // eslint-disable-next-line no-console
      console.log('user list', data)
      this.setState({ userList: data?.data || [] })
    })
  }

  disableNote = (dept_time) => {
    return moment.tz(dept_time, this.state.timezone).diff(moment().tz(this.state.timezone), 'minutes') < 0
  }

  bookedULD = () => {
    let data = getAwbs(this.state.editRecord || {}, this.state.priorityData || [])
    this.setState({
      mergeEditRecord: data.mergeEditRecord,
      initmergeEditRecord: data.initmergeEditRecord,
      finalmergeEditRecord: data.finalmergeEditRecord,
    })
  }

  showACHistory = (history) => {
    if (this.state.flightACVisible && history?.length > 0) {
      return (
        <div>
          {history.map((item, index) => (
            <p
              key={index}>
              {'A/C change: ' + item?.old + ' -> ' + item?.ac + (item.pax ? ' (Pax File)' : (item.user? ' (User)': ' (Flight Event)'))}
            </p>
          ))}
        </div>
      )
    } else {
      return <div>No data found</div>
    }
  }

  showAwbs = (record, awbs) => {
    let a = []
    if (record?.type == 'SLU') {
      record?.awbs_in?.map(awb => {
        let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
        a.push({
          ...act || {},
          vol: awb?.vol?.value,
          wgt: awb?.wgt?.value,
          pcs: awb?.pcs,
          ch_wgt: (act?.wgt?.value / act?.pcs) * awb?.pcs
        })
      })
    } else {
      if (awbs?.length > 0) {
        awbs.map((awb) => {
          if (record.type == 'BULK') {
            if (awb?.data && awb?.data?.blk && parseInt(awb?.data?.blk) > 0) {
              let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
              a.push({
                ...act,
                t_pcs: act?.pcs,
                pcs: awb.data.blk,
                ch_wgt: awb.data.ch_wgt,
                pri: awb.data.pri,
                wgt: awb.data.blk_wgt,
                vol: awb.data.blk_vol,
                id: 0,
                uld_id: 0
              })
            }
          } else {
            const data = awb?.ulds.find((u) => record.id == u.id)
            if (data) {
              let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
              a.push({
                ...act,
                ...data,
                t_pcs: act?.pcs,
                pcs: data.pcs,
                t_wgt: act?.wgt,
                wgt: data.wgt,
                ch_wgt: data.ch_wgt,
                vol: data?.vol
              })
            }
          }
        })
      }
    }
    return a
  }

  updateOptiData = () => {
    let obj = {
      id: this.state.editOptiUld?.id,
      uld_no: this.state.editOptiUld?.uld_no,
      type: this.state.editOptiUld?.type,
      remark: this.state.editOptiUld?.remark,
      pallet_stacked: this.state.editOptiUld?.pallet_stacked,
      pallet_stack_count: this.state.editOptiUld?.pallet_stacked ? this.state.editOptiUld?.pallet_stack_count : null,
      wgt: this.state.editOptiUld?.wgt ? (this.state.editWgtUnit === 'KG') ? this.updateWeightVal('LB', this.state.editOptiUld?.wgt) : this.state.editOptiUld?.wgt : 0,
      stn: cookies.get('station')
    }
    if (obj.type && obj.id) {
      http.put(`/build_uld/${this.state.editRecord.id}`, obj).then(() => {
        this.setState({ editOptiUld: {} })
      })
    }
  }
  
  removeOptiData = (id) => {
    http.put(`/build_uld_delete/${this.state.editRecord.id}`, {
      id,
      stn: cookies.get('station')
    })
  }
  
  editOptiData = (record) => {
    this.setState({
      editOptiUld: { 
        ...record,
        wgt: record.wgt ? (this.state.editWgtUnit === 'KG' ? this.updateWeightVal('KG', record.wgt) : record.wgt) : null
      } 
    })
  }
  
  clearOptiData = () => {
    this.setState({ editOptiUld: {} })
  }

  clearTableForm = (record) => {
    this.setState({
      editAwbs: {},
      editAwbsRecord: {},
      editUlds: {}
    })
    if (record.init && record.id == 0) {
      let mergeEditRecord = this.state.mergeEditRecord.filter(item => item.awb_no !== record.awb_no)
      this.setState({ mergeEditRecord })
    }
  }

  getUnassignedAwbs = () => {
    let assigned_awbs = []
    this.state.mergeEditRecord?.map(item => {
      let bpIndex = this.state.editRecord.build_plan.findIndex((item2) => item2.awb_no === item.awb_no)
      if (bpIndex !== -1) {
        if (!this.state.editRecord.build_plan[bpIndex].ulds || this.state.editRecord.build_plan[bpIndex].ulds.length === 0) {
          assigned_awbs.push(item)
        } else {
          let { pcs, wgt, vol } = this.state.editRecord.build_plan[bpIndex].ulds.reduce((acc, curr) => {
            acc.pcs += curr.pcs || 0
            acc.wgt += curr.wgt || 0
            acc.vol += curr.vol || 0
            return acc
          }, {
            pcs: 0,
            wgt: 0,
            vol: 0
          })
          if (item.pcs != pcs) {
            assigned_awbs.push({
              ...item,
              asgn_pcs: pcs,
              asgn_wgt: wgt,
              asgn_vol: vol
            })
          }
        }
      } else {
        assigned_awbs.push(item)
      }
    })
    return assigned_awbs
  }

  handleAssignUldChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    let other_data = {}
    let flightDetails = this.state.flightDetails
    other_data = { ...this.state.assignUld }
    // }
    if (name == 'pcs') {
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      actual_wgt = Math.round((actual_wgt / flightDetails?.pcs) * value) != 0 ? Math.round((actual_wgt / flightDetails?.pcs) * value) : Math.round((actual_wgt / flightDetails?.pcs) * value * 10) / 10
      other_data.wgt = actual_wgt
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      actual_vol = Math.round(((actual_vol / flightDetails?.pcs) * value) * 10) / 10
      other_data.vol = actual_vol
      let actual_ch_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value
      actual_ch_wgt = Math.round((actual_ch_wgt / flightDetails?.pcs) * value) != 0 ? Math.round((actual_ch_wgt / flightDetails?.pcs) * value) : Math.round((actual_ch_wgt / flightDetails?.pcs) * value * 10) / 10
      other_data.ch_wgt = actual_ch_wgt
    }
    this.setState(() => ({
      assignUld: {
        ...other_data,
        [name]: value
      }
    }))
  }


  submitAssignUld = () => {
    let error = {}
    if (!this.state.assignUld?.pcs) {
      error.e_pcs = 'Please enter pcs'
    }
    if (!this.state.assignUld?.wgt) {
      error.e_wgt = 'Please enter wgt'
    }
    if (Object.keys(error).length > 0) {
      this.setState({
        assignUld: {
          ...this.state.assignUld,
          ...error
        },
      })
      return
    }
    let awb = this.state.mergeEditRecord?.find((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    let uld = this.state.editRecord?.build_uld?.find((item) => item?.id === this.state.assignUld?.id)
    if (uld && awb) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        pcs: this.state.assignUld?.pcs,
        remark: awb?.priority,
        uld_no: uld?.uld_no,
        uld_type: uld?.type,
        pri: awb?.pri,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.wgt || 0, 'KGM') : this.state.assignUld?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? this.state.assignUld?.vol : volumnCalculator(this.state.assignUld?.vol || 0, 'CBF'),
        id: uld?.id,
        ch_wgt: this.state.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.ch_wgt || 0, 'KGM') : this.state.assignUld?.ch_wgt,
      }
      http.post(`/build_plan_uld/${this.state.editRecord?.id}`, formData)
        .then((data) => {
          if (data && data?.status === 200) {
            this.setState({
              assignUld: {
                ...this.state.assignUld,
                pcs: '',
                wgt: '',
                vol: '',
                e_pcs: '',
                e_wgt: '',
                e_vol: '',
              }
            })
            // Reset form fields
            this.assignUldFormRef.current?.resetFields(['pcs', 'wgt', 'vol'])
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        }).catch(() => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
        })
    } else if (this.state.assignUld?.id == 0 && awb) {
      // let ch_wgt_lb = weightCalculator(awb?.ch_wgt || 0, 'KGM')
      let formData = {
        add: true,
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: this.state.assignUld?.pcs,
        blk_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.wgt || 0, 'KGM') : this.state.assignUld?.wgt,
        blk_vol: this.state?.editWgtUnit === 'KG' ? this.state.assignUld?.vol : volumnCalculator(this.state.assignUld?.vol || 0, 'CBF'),
        only_blk: true,
      }
      http.put(`/build_plan_awb/${this.state.editRecord?.id}`, formData).then((data) => {
        if (data && data?.status === 200) {
          this.setState({
            assignUld: {
              ...this.state.assignUld,
              pcs: '',
              wgt: '',
              vol: '',
              e_pcs: '',
              e_wgt: '',
              e_vol: '',
            }
          })
          // Reset form fields
          this.assignUldFormRef.current?.resetFields(['pcs', 'wgt', 'vol'])
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    }
    else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Please select correct ULD',
      })
    }
  }

  exportScrub = async (download_type = null) => {
    const scubData = getScrubData(this.state.editRecord, this.props.priorityData)
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet('Flight Plan')
    ws.columns = [
      { width: 15 },   // A
      { width: 20 },  // B
      { width: 14 },  // C
      { width: 12 },  // D
      { width: 10 },  // E
      { width: 12 },  // F
      { width: 10 },  // G
      { width: 12 },  // H
      { width: 22 },  // I
    ]
  
    const blue = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9EAF7' }
    }
    const yellow = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FEFEA2' }
    }
  
    const grey = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }
  
    const border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  
    const bold = { bold: true }
  
    /* ---------------- LEFT FLIGHT INFO ---------------- */
    ws.mergeCells('A1:A5')
    ws.getCell('A1').value = scubData.flightNo + ' ' + scubData.station
    ws.getCell('A1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    }  
    /* ---------------- CONTAINER CONFIG ---------------- */
    ws.mergeCells('B1:D1')
    ws.getCell('B1').value = 'Container Type:'
    ws.mergeCells('B2:D2')
    ws.getCell('B2').value = 'Max Config:'
    if (scubData.maxConfig) {
      ws.getCell('E2').value = scubData.maxConfig?.PMC
      ws.getCell('F2').value = scubData.maxConfig?.PAG
      ws.getCell('G2').value = scubData.maxConfig?.LD2
      ws.getCell('H2').value = scubData.maxConfig?.LD3
      ws.getCell('I2').value = scubData.maxConfig?.LD48FQA
    }
    ws.mergeCells('B3:D3')
    ws.getCell('B3').value = 'Planned Config:'
    if (scubData.plannedConfig) {
      ws.getCell('E3').value = scubData.plannedConfig?.PMC
      ws.getCell('F3').value = scubData.plannedConfig?.PAG
      ws.getCell('G3').value = scubData.plannedConfig?.LD2
      ws.getCell('H3').value = scubData.plannedConfig?.LD3
      ws.getCell('I3').value = scubData.plannedConfig?.LD48FQA
    }
    ws.mergeCells('B4:D5')
    ws.getCell('B4').value = 'Final Config:'
    ws.mergeCells('E4:E5')
    ws.mergeCells('F4:F5')
    ws.mergeCells('G4:G5')
    ws.mergeCells('H4:H5')
    ws.mergeCells('I4:I5')
    ws.mergeCells('J1:L1')
    ws.mergeCells('J2:L2')
    ws.mergeCells('J3:L3')
    ws.mergeCells('J4:L5')
    if(scubData.finalConfig) {
      ws.getCell('E4').value = scubData.finalConfig?.PMC
      ws.getCell('F4').value = scubData.finalConfig?.PAG
      ws.getCell('G4').value = scubData.finalConfig?.LD2
      ws.getCell('H4').value = scubData.finalConfig?.LD3
      ws.getCell('I4').value = scubData.finalConfig?.LD48FQA
    }
    ws.getCell('J4').value = '<---Scrub desk please update this count when replying'
    ws.getCell('J4').alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    }
  
  
    ws.getCell('E1').value = 'PMC'
    ws.getCell('F1').value = 'PAG'
    ws.getCell('G1').value = 'LD2'
    ws.getCell('H1').value = 'LD3'
    ws.getCell('I1').value = 'LD4/8/FQA'
  
    for (let row = 1; row <= 7; row++) {
      for (let col = 1; col <= 12; col++) { // A=1 to L=12
        const cell = ws.getRow(row).getCell(col)
        cell.fill = blue
        cell.font = bold
        cell.border = border
      }
    }
    ws.getCell('E4').fill = yellow
    ws.getCell('F4').fill = yellow
    ws.getCell('G4').fill = yellow
    ws.getCell('H4').fill = yellow
    ws.getCell('I4').fill = yellow
    ws.getCell('J4').font = { bold: false }
  
    /* ---------------- FLIGHT PLAN RESPONSE ---------------- */
    ws.mergeCells('A6:L6')
    ws.getCell('A6').value = 'Flight Plan Response'
    ws.getCell('A6').fill = blue
    ws.getCell('A6').font = bold
    ws.getCell('A6').alignment = { horizontal: 'center' }
    ws.getCell('A6').border = border
    ws.getCell('A7').value = 'Number'
    ws.getCell('B7').value = 'AWB/Conveyances'
    ws.getCell('C7').value = 'Location'
    ws.getCell('D7').value = 'Days Delayed'
    ws.getCell('E7').value = 'Priority'
    ws.getCell('F7').value = 'Product'
    ws.getCell('G7').value = 'Yes/No'
    ws.mergeCells('H7:I7')
    ws.getCell('H7').value = 'Built ULDs'
    ws.mergeCells('J7:L7')
    ws.getCell('J7').value = 'Scrub Desk Comments'
  
    let last_row = 7
    let counter = 1
    console.log('scubData', scubData)
    scubData?.workarea.forEach((index) => {
      const area = scubData.workareaData[index]
      last_row++
      ws.mergeCells(`A${last_row}:L${last_row}`)
      ws.getCell(`A${last_row}`).value = index == 'UNKNOWN' ? 'Miscellaneous' : index
      ws.getCell(`A${last_row}`).fill = yellow
      ws.getCell(`A${last_row}`).font = bold
      ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
      ws.getCell(`A${last_row}`).border = border
      if (area.loose) {
        last_row++
        ws.mergeCells(`A${last_row}:L${last_row}`)
        ws.getCell(`A${last_row}`).value = 'Loose'
        ws.getCell(`A${last_row}`).fill = grey
        ws.getCell(`A${last_row}`).font = bold
        ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
        ws.getCell(`A${last_row}`).border = border
        area.loose && (area.loose.forEach((awb) => {
          console.log('awb', awb)
          last_row++
          const row = ws.addRow([counter, awb.awb_no.replace(/(\d{3})(\d{8})/, '$1-$2'), awb.location || '', awb.delay, awb.pri || '', awb.prod_code || '', awb.yesNo || '', awb.builtUlds || '', awb.comments || ''])
          ws.mergeCells(`H${row.number}:I${row.number}`)
          ws.mergeCells(`J${row.number}:L${row.number}`)
          ws.getCell(`J${row.number}`).value = awb.comments || ''
          if (counter % 2 == 0) {
            row.eachCell((cell) => {
              cell.fill = blue
              cell.border = border
            })
          } else {
            row.eachCell((cell) => {
              cell.border = border
            })
          }
  
          if (awb.delay <= 1) {
            // green
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'C6EFCE' }
            }
          }
          if (awb.delay > 0) {
            // red
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC7CE' }
            }
          }
          counter++
        }))
      }
      if (area.uld) {
        last_row++
        ws.mergeCells(`A${last_row}:L${last_row}`)
        ws.getCell(`A${last_row}`).value = 'Pre-Built'
        ws.getCell(`A${last_row}`).fill = grey
        ws.getCell(`A${last_row}`).font = bold
        ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
        ws.getCell(`A${last_row}`).border = border
        area.uld && (area.uld.forEach((uld) => {
          last_row++
          const row = ws.addRow([counter, uld.awb_no, uld.location || '', uld.delay, uld.pri || '', uld.prod_code || '', uld.yesNo || '', uld.builtUlds || '', uld.comments || ''])
          ws.mergeCells(`H${row.number}:I${row.number}`)
          ws.mergeCells(`J${row.number}:L${row.number}`)
          ws.getCell(`J${row.number}`).value = uld.comments || ''
          if (counter % 2 == 0) {
            row.eachCell((cell) => {
              cell.fill = blue
              cell.border = border
            })
          } else {
            row.eachCell((cell) => {
              cell.border = border
            })
          }
          if (uld.delay <= 1) {
            // green
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'C6EFCE' }
            }
          }
          if (uld.delay > 1) {
            // red
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC7CE' }
            }
          }
          counter++
        }))
      }
    })
  
    /* ---------------- SUMMARY ---------------- */
    last_row++
    ws.mergeCells(`A${last_row}:L${last_row}`)
    ws.getCell(`A${last_row}`).value = 'Flight Summary: '+scubData?.summary
    ws.getCell(`A${last_row}`).fill = blue
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).border = border
  
    last_row++
    ws.mergeCells(`A${last_row}:L${last_row}`)
    ws.getCell(`A${last_row}`).value = 'MEF'
    ws.getCell(`A${last_row}`).fill = yellow
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
    ws.getCell(`A${last_row}`).border = border
  
    last_row++
    ws.getCell(`A${last_row}`).value = 'Number'
    ws.getCell(`A${last_row}`).fill = blue
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).border = border
    ws.getCell(`B${last_row}`).value = 'AWB/Conveyances'
    ws.getCell(`B${last_row}`).fill = blue
    ws.getCell(`B${last_row}`).font = bold
    ws.getCell(`B${last_row}`).border = border
    ws.getCell(`C${last_row}`).value = 'Location'
    ws.getCell(`C${last_row}`).fill = blue
    ws.getCell(`C${last_row}`).font = bold  
    ws.getCell(`C${last_row}`).border = border
    ws.getCell(`D${last_row}`).value = 'Days Delayed'
    ws.getCell(`D${last_row}`).fill = blue
    ws.getCell(`D${last_row}`).font = bold
    ws.getCell(`D${last_row}`).border = border
    ws.getCell(`E${last_row}`).value = 'Priority'
    ws.getCell(`E${last_row}`).fill = blue
    ws.getCell(`E${last_row}`).font = bold
    ws.getCell(`E${last_row}`).border = border
    ws.getCell(`F${last_row}`).value = 'Product'
    ws.getCell(`F${last_row}`).fill = blue
    ws.getCell(`F${last_row}`).font = bold
    ws.getCell(`F${last_row}`).border = border
    ws.getCell(`G${last_row}`).value = 'Yes/No'
    ws.getCell(`G${last_row}`).fill = blue
    ws.getCell(`G${last_row}`).font = bold
    ws.getCell(`G${last_row}`).border = border
    ws.mergeCells(`H${last_row}:I${last_row}`)
    ws.getCell(`H${last_row}`).value = 'Built ULDs'
    ws.getCell(`H${last_row}`).fill = blue
    ws.getCell(`H${last_row}`).font = bold
    ws.getCell(`H${last_row}`).border = border
    ws.mergeCells(`J${last_row}:L${last_row}`)
    ws.getCell(`J${last_row}`).value = 'Scrub Desk Comments'
    ws.getCell(`J${last_row}`).fill = blue
    ws.getCell(`J${last_row}`).font = bold
    ws.getCell(`J${last_row}`).border = border
    last_row++
    let summaryRows = scubData?.summaryRows || []
    summaryRows.forEach((r, index) => {
      if(!r.awb_no)
        return
      const row = ws.addRow([index+1, r.awb_no.replace(/(\d{3})(\d{8})/, '$1-$2'), r.location || '', r.delay, r.pri || '', r.prod_code || '', r.yesNo || '', r.builtUlds || '', r.comments || ''])
      ws.mergeCells(`H${row.number}:I${row.number}`)
      ws.mergeCells(`J${row.number}:L${row.number}`)
      ws.getCell(`J${row.number}`).value = r.comments || ''
      if ((index+1) % 2 == 0) {
        row.eachCell(c => c.fill = blue)
      }
      if (r.delay <= 1) {
        // green
        row.getCell(4).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'C6EFCE' }
        }
      }
      if (r.delay > 1) {
        // red
        row.getCell(4).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFC7CE' }
        }
      }
      // ws.mergeCells(`B${row.number}:L${row.number}`)
      row.eachCell(c => c.border = border)
    })
  
  
    /* -------------------- SAVE -------------------- */
    const buffer = await wb.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `SCRUB_COPY_${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `SCRUB_COPY_${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }

  generateLoadPlan = async (download_type = null) => {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet('Builder Copy', { properties: { defaultRowHeight: 18 } })
  
    for (let i = 1; i <= 100; i++) {
      for (let j = 1; j <= 50; j++) {
        const cell = sheet.getRow(i).getCell(j)
        cell.border = {
          top: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          left: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          bottom: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          right: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          }
        }
      }
    }
  
    const blue = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
  
    /* -------------------------------------------------
         COLUMN SETUP
      ------------------------------------------------- */
    sheet.columns = [
      { width: 2 },
      { width: 16 },
      { width: 18 },
      { width: 15 },
      { width: 8 },
      { width: 12 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
      { width: 15 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
    ]
    let columns = [
      { header: '', },
      { header: 'AWB', },
      { header: 'Location', },
      { header: 'Comments', },
      { header: 'Pcs', },
      { header: `GR Wt (${this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'})`, },
      { header: `Vol (${this.state.editWgtUnit === 'KG' ? 'cbm' : 'cft'})`, },
      { header: 'Prod', },
      { header: 'Dest', },
      { header: 'Days Delayed', },
      { header: 'Pri #', },
      { header: 'On Hand' },
    ]
  
  
    // trasnparent border for all cell
  
    /* -------------------------------------------------
         HELPERS
      ------------------------------------------------- */
    function setBorderForRange(r1, c1, r2, c2) {
      // Apply thin border to all cells first
      for (let r = r1; r <= r2; r++) {
        for (let c = c1; c <= c2; c++) {
          sheet.getCell(r, c).border = {
            top: {
              style: 'thin',
              color: { argb: '000000' }
            },
            left: {
              style: 'thin',
              color: { argb: '000000' }
            },
            bottom: {
              style: 'thin',
              color: { argb: '000000' }
            },
            right: {
              style: 'thin',
              color: { argb: '000000' }
            },
          }
          if (r == r2) {
            sheet.getCell(r + 1, c).border = {
              top: {
                style: 'thin',
                color: { argb: '000000' }
              },
              left: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
          if (c == c2) {
            sheet.getCell(r, c + 1).border = {
              top: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              left: {
                style: 'thin',
                color: { argb: '000000' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
        }
      }
    }
  
    const center = (cell) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
    }
  
    /* -------------------------------------------------
         FLIGHT INFO BOX (TOP LEFT)
      ------------------------------------------------- */
    const flightInfo = [
      ['', 'Flight #', this.state.editRecord.flight_no],
      ['', 'Date', moment(this.state.editRecord.flight_date).format('DD/MM/YYYY')],
      ['', 'Aircraft Type', this.state.editRecord.fleet || ''],
      ['', 'Departure Time', this.state.editRecord?.dept_time ? moment.tz(this.state.editRecord.dept_time, this.state.timezone).format('HH:mm')?.toUpperCase() : ''],
      ['', 'FPE Time', this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('HH:mm') : ''],
      ['', 'DOD Name', cookies.get('name')],
      ['', 'DOD Contact #', ''],
      ['', 'PPR No.', cookies.get('ppr')]
    ]
  
    flightInfo.forEach((row, i) => {
      const r = i + 2
      sheet.mergeCells(`C${r}:D${r}`)
      sheet.getCell(`B${r}`).value = row[1]
      sheet.getCell(`C${r}`).value = row[2]
      sheet.getCell(`B${r}`).font = { bold: true }
      sheet.getCell(`B${r}`).fill = blue
    })
  
    setBorderForRange(2, 2, 9, 4)
  
    /* -------------------------------------------------
         MAX ULD CONFIG BOX (TOP RIGHT)
      ------------------------------------------------- */
    sheet.mergeCells('M5:P6')
    sheet.getCell('M5').value = 'Max ULD Configuration'
    sheet.getCell('M5').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('M5').fill = blue
    center(sheet.getCell('M5'))
  
    sheet.mergeCells('M7:P8')
    sheet.getCell('M7').value = 'Planned Bin Configuration'
    sheet.getCell('M7').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('M7').fill = blue
    center(sheet.getCell('M7'))
  
  
    sheet.getCell('Q4').value = 'PMC'
    sheet.getCell('Q4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('Q4').fill = blue
    center(sheet.getCell('Q4'))
    // PAG
    sheet.getCell('R4').value = 'PAG'
    sheet.getCell('R4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('R4').fill = blue
    center(sheet.getCell('R4'))
    // LD2
    sheet.getCell('S4').value = 'LD2'
    sheet.getCell('S4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('S4').fill = blue
    center(sheet.getCell('S4'))
    // LD3
    sheet.getCell('T4').value = 'LD3'
    sheet.getCell('T4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('T4').fill = blue
    center(sheet.getCell('T4'))
    //LD4/8/FQA
    sheet.getCell('U4').value = 'LD4/8/FQA'
    sheet.getCell('U4').alignment = { wrapText: true }
    sheet.getCell('U4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('U4').fill = blue
    center(sheet.getCell('U4'))
  
    const bin_config = get_bin_config(false,this.state)
    sheet.mergeCells('Q5:Q6')
    sheet.getCell('Q5').value = bin_config[0]?.PMC || ''
    center(sheet.getCell('Q5'))
    sheet.mergeCells('R5:R6')
    sheet.getCell('R5').value = bin_config[0]?.PAG || ''
    center(sheet.getCell('R5'))
    sheet.mergeCells('S5:S6')
    sheet.getCell('S5').value = bin_config[0]?.LD2 || ''
    center(sheet.getCell('S5'))
    sheet.mergeCells('T5:T6')
    sheet.getCell('T5').value = bin_config[0]?.LD3 || ''
    center(sheet.getCell('T5'))
    sheet.mergeCells('U5:U6')
    sheet.getCell('U5').value = bin_config[0]?.LD4_8_FQA || ''
    center(sheet.getCell('U5'))
  
    sheet.mergeCells('Q7:Q8')
    sheet.getCell('Q7').value = bin_config[1]?.PMC || ''
    center(sheet.getCell('Q7'))
    sheet.mergeCells('R7:R8')
    sheet.getCell('R7').value = bin_config[1]?.PAG || ''
    center(sheet.getCell('R7'))
    sheet.mergeCells('S7:S8')
    sheet.getCell('S7').value = bin_config[1]?.LD2 || ''
    center(sheet.getCell('S7'))
    sheet.mergeCells('T7:T8')
    sheet.getCell('T7').value = bin_config[1]?.LD3 || ''
    center(sheet.getCell('T7'))
    sheet.mergeCells('U7:U8')
    sheet.getCell('U7').value = bin_config[1]?.LD4_8_FQA || ''
    center(sheet.getCell('U7'))
  
    setBorderForRange(4, 17, 4, 21)
    setBorderForRange(5, 13, 8, 21)
  
    /* -------------------------------------------------
         TABLE HEADER ROW
      ------------------------------------------------- */
    const headerRow = sheet.getRow(14)
    headerRow.values = columns.map(col => col.header)
  
    headerRow.eachCell((cell, c) => {
      if (c === 1) return // skip first col
      cell.font = { bold: true }
      center(cell)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDAE3F3' }
      }
    })
  
    for (let i = 13; i <= 33; i++) {
      const cell = sheet.getRow(11).getCell(i)
      cell.value = i == 13 ? 'BULK' : i - 13
      cell.font = {
        size: 10,
        color: { argb: 'FF808080' } // grey
      }
      center(cell)
    }
  
    let uld_col = 14
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = sheet.getRow(12).getCell(uld_col)
      cell.value = uld.type
      center(cell)
      uld_col++
    })
  
    uld_col = 14
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = sheet.getRow(13).getCell(uld_col)
      cell.value = uld.uld_no || '' + (uld.pallet_stacked ? ' (Pallet Stack)' : '')
      center(cell)
      uld_col++
    })
  
    setBorderForRange(12, 13, 13, 33)
    setBorderForRange(14, 2, 14, 33)
  
    /* -------------------------------------------------
         SAMPLE DATA ROWS
      ------------------------------------------------- */
    const dataRows = []
    this.state.mergeEditRecord?.map((awb) => {
      if (awb.is_deleted) {
        return
      }
      let unit = awb?.wgt?.unit
      let wgtValue = ''
      {
        if (this.state.editWgtUnit === 'KG') {
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
            wgtValue = Math.round(kg)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
        else if (this.state.editWgtUnit === 'LB') {
          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
            wgtValue = Math.round(lb)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
      }
  
      let vol = awb?.vol?.value
      let volValue = ''
      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
        let cbf = this.updateVolumeVal('CBF', vol)
        volValue = Math.round(cbf * 10) / 10
      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
        let cbm = this.updateVolumeVal('CBM', vol)
        volValue = Math.round(cbm * 10) / 10
      } else {
        volValue = (Math.round(vol * 10) / 10)
      }
  
      // let delay = awb?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(awb?.delay), 'days') * -1 : 0
      let delay = awb?.delay ? awb?.delay : 0
  
      let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === awb.awb_no)
      let priority = awb.pri
      let awb_data = [
        awb.spl_code || '',
        awb?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2') || '',
        awb?.location || '',
        awb?.comment || '',
        awb?.pcs || '',
        wgtValue || '',
        volValue || '',
        awb?.prod_code || '',
        awb?.dest || '',
        delay || '',
        priority || 999,
        awb?.on_hand ? 'Y' : 'N',
        bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.blk ? this.state.editRecord.build_plan[bpIndex]?.data?.blk : '']
      this.state.editRecord?.build_uld?.map((uld) => {
        let pcs = ''
        if (bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0) {
          let found = this.state.editRecord.build_plan[bpIndex]?.ulds.find((u) => u.id === uld.id)
          if (found) {
            pcs = found.pcs
          }
        }
        awb_data.push(pcs)
      })
      dataRows.push(awb_data)
    })
  
    // sort by priority and then delays
    dataRows.sort((a, b) => {
      let a_pri = a[10] != '' ? a[10] : 99
      let b_pri = b[10] != '' ? b[10] : 99
      if (a_pri != b_pri) {
        return a[10] - b[10] // sort by priority
      } else {
        return b[9] - a[9] // then sort by delays
      }
    })
  
  
    dataRows.forEach((rowData, i) => {
      const row = sheet.getRow(15 + i)
      let fData = [...rowData]
      let spl_code = fData[0]
      fData[0] = '',
      fData[10] = fData[10] == 999 ? '' : fData[10]
      row.values = fData
      row.eachCell((cell, colNumber) => {
        center(cell)
  
        // Days Delayed coloring
        if (colNumber === 10) {
          if (cell.value > 0) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFC7CE' }
            } // red
          } else if (cell.value < 0) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC6EFCE' }
            } // green
          }
        }
        if (colNumber == 2 && spl_code) {
          if (spl_code.includes('RDG') || spl_code.includes('ICE') || spl_code.includes('ICV')) {
            //  text color red
            cell.font = { color: { argb: 'FFFF0000' } }
          } else if (spl_code.includes('AMZ')) {
            // text color blue
            cell.font = { color: { argb: 'FF007BFF' } }
          }
        }
      })
    })
  
    setBorderForRange(15, 2, 14 + dataRows.length, 33)
  
    /* -------------------------------------------------
         ULD POSITION HEADER
      ------------------------------------------------- */
    // sheet.mergeCells('L8:S8')
    // const uldTitle = sheet.getCell('L8')
    // uldTitle.value = 'ULD POSITIONS'
    // uldTitle.font = { bold: true }
    // center(uldTitle)
    // borderAll(uldTitle)
  
    // Grey blocked area (like aircraft hold)
    for (let col = 13; col <= 33; col++) {
      const cell = sheet.getCell(14, col)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' }
      }
    }
  
    // set print area
    sheet.pageSetup = {
      orientation: 'landscape',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 1,
      horizontalCentered: true,
      verticalCentered: true,
    }
    sheet.pageSetup.printArea = 'B1:AG'+(14 + dataRows.length)
  
  
    const buffer = await workbook.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `LoadPlan${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `LoadPlan${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }
  
  generateLoadPlanLHR = async (download_type = null) => {
    const workbook = new ExcelJS.Workbook()
    const ws = workbook.addWorksheet('LHR Builder Copy', {
      pageSetup: {
        paperSize: 20,
        orientation: 'landscape',
        scale: 50
      }
    })
    // const borderAll = (cell) => {
    //   cell.border = {
    //     top: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     left: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     bottom: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     right: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     }
    //   }
    // }
  
    for (let i = 1; i <= 100; i++) {
      for (let j = 1; j <= 50; j++) {
        const cell = ws.getRow(i).getCell(j)
        cell.border = {
          top: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          left: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          bottom: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          right: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          }
        }
      }
    }
  
  
    const thin = {
      style: 'thin',
      color: { argb: '000000' }
    }
    const center = {
      vertical: 'middle',
      horizontal: 'center'
    }
    const bold = { bold: true }
  
    // Helper to draw borders around ANY range (fixes missing edges on merged cells)
    // function box(r1, c1, r2, c2) {
    //   for (let r = r1; r <= r2; r++) {
    //     for (let c = c1; c <= c2; c++) {
    //       const cell = ws.getCell(r, c)
    //       cell.border = {
    //         top: r === r1 ? thin : undefined,
    //         bottom: r === r2 ? thin : undefined,
    //         left: c === c1 ? thin : undefined,
    //         right: c === c2 ? thin : undefined,
    //       }
    //     }
    //   }
    // }
  
    function setBorderForRange(r1, c1, r2, c2) {
      // Apply thin border to all cells first
      for (let r = r1; r <= r2; r++) {
        for (let c = c1; c <= c2; c++) {
          ws.getCell(r, c).border = {
            top: {
              style: 'thin',
              color: { argb: '000000' }
            },
            left: {
              style: 'thin',
              color: { argb: '000000' }
            },
            bottom: {
              style: 'thin',
              color: { argb: '000000' }
            },
            right: {
              style: 'thin',
              color: { argb: '000000' }
            },
          }
          if (r == r2) {
            ws.getCell(r + 1, c).border = {
              top: {
                style: 'thin',
                color: { argb: '000000' }
              },
              left: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
          if (c == c2) {
            ws.getCell(r, c + 1).border = {
              top: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              left: {
                style: 'thin',
                color: { argb: '000000' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
        }
      }
    }
  
    // Column widths
    ws.columns = [
      { width: 2 }, // A
      { width: 28 }, // B
      { width: 4 }, // C
      { width: 7 }, // D
      { width: 7 }, // E
      { width: 7 }, // F
      { width: 7 }, // G
      { width: 7 }, // H
      { width: 7 }, // I
      { width: 15 }, // J
      { width: 15 }, // K
      { width: 15 }, // L
      { width: 17 }, // M
      { width: 17 }, // N  
      { width: 7 }, // O
      { width: 7 }, // P
      { width: 8 }, // Q
      { width: 8 }, // R
      { width: 8 }, // S
      { width: 8 }, // T
      { width: 8 }, // U
      { width: 8 }, // V
      { width: 8 }, // W
      { width: 8 }, // X
      { width: 8 }, // Y
      { width: 8 }, // Z
      { width: 8 }, // AA
      { width: 8 }, // AB
      { width: 8 }, // AC
      { width: 8 }, // AD
      { width: 8 }, // AE
      { width: 8 }, // AF
      { width: 8 }, // AG
      { width: 8 }, // AH
      { width: 8 }, // AI
      { width: 8 }, // AJ
      { width: 8 }, // AK
    ]
  
    function labelCell(r, c, text) {
      const cell = ws.getCell(r, c)
      cell.value = text
      cell.font = bold
      cell.alignment = center
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DAE3F3' }
      }
    }
  
    function valueCell(r, c1, c2, text = '') {
      ws.mergeCells(r, c1, r, c2)
      const cell = ws.getCell(r, c1)
      cell.value = text
      cell.alignment = center
    }
  
    // ==== TOP LEFT FLIGHT INFO ====
    labelCell(2, 2, 'Flight #:'); valueCell(2, 3, 7, this.state.editRecord.flight_no)
    labelCell(3, 2, 'Date:'); valueCell(3, 3, 7, moment(this.state.editRecord.flight_date).format('DD/MM/YYYY'))
    labelCell(4, 2, 'Destination:'); valueCell(4, 3, 7, this.state.editRecord.dest_stn)
    labelCell(5, 2, 'Aircraft Type:'); valueCell(5, 3, 7, this.state.editRecord.fleet)
    labelCell(6, 2, 'Departure Time:'); valueCell(6, 3, 7, this.state.editRecord?.dept_time ? moment.tz(this.state.editRecord.dept_time, this.state.timezone).format('h:mm A') : '')
    labelCell(7, 2, 'FPE Time:'); valueCell(7, 3, 7, this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('h:mm A') : '')
    labelCell(8, 2, 'DoD Name:'); valueCell(8, 3, 7, cookies.get('name'))
    labelCell(9, 2, 'DoD Contact #:'); valueCell(9, 3, 7, 'Enter Contact #')
    labelCell(10, 2, 'PPR No.:'); valueCell(10, 3, 7, cookies.get('ppr') || '')
    labelCell(11, 2, 'Baggage Bins:'); valueCell(11, 3, 7, '')
  
    // box(2, 2, 10, 3)
    setBorderForRange(2, 2, 11, 7)
  
    // ==== DRY ICE LIMITS ====
    ws.mergeCells('H2:J3')
    ws.getCell('H2').value = 'DRY ICE LIMITS'
    ws.getCell('H2').font = bold
    ws.getCell('H2').alignment = center
    ws.getCell('H2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F8CBAD' }
    }
    ws.mergeCells('H4:H5')
    ws.getCell('H4').value = 'FWD'
    ws.mergeCells('I4:J5')
    ws.getCell('I4').value = '2204 LBS (1000 KG)'
    ws.mergeCells('H6:H7')
    ws.getCell('H6').value = 'AFT'
    ws.mergeCells('I6:J7')
    ws.getCell('I6').value = 'FORBIDDEN'
    ws.mergeCells('H8:H9')
    ws.getCell('H8').value = 'BULK'
    ws.mergeCells('I8:J9')
    ws.getCell('I8').value = 'FORBIDDEN'
    for (let r = 4; r <= 9; r++) {
      for (let c = 8; c <= 10; c++) {
        ws.getCell(r, c).alignment = center
        ws.getCell(r, c).font = bold
        ws.getCell(r, c).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FCE4D6' }
        }
      }
    }
  
    // ==== MAG MATERIAL ====
    ws.mergeCells('K2:K3')
    ws.getCell('K2').value = 'MAG MATERIAL'
    ws.getCell('K2').font = bold
    ws.getCell('K2').alignment = {
      wrapText: true,
      ...center
    }
    ws.getCell('K2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F8CBAD' }
    }
  
    ws.mergeCells('K4:K9')
    ws.getCell('K4').value = 'NO WEIGHT RESTRICTION, BUT MUST BE LOADED AFT'
    ws.getCell('K4').alignment = {
      wrapText: true,
      ...center
    }
    ws.getCell('K4').font = bold
    ws.getCell('K4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FCE4D6' }
    }
    setBorderForRange(2, 8, 9, 11)
  
    // ==== MAX ULD SECTION ====
    ws.mergeCells('L3:N3')
    ws.getCell('L3').value = 'Max Available ULDs'
    ws.getCell('L3').alignment = center
    ws.getCell('L3').font = bold
    ws.getCell('L3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }
    ws.mergeCells('L4:N4')
    ws.getCell('L4').value = 'Shipper Built ULDs'
    ws.getCell('L4').alignment = center
    ws.getCell('L4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L5:N5')
    ws.getCell('L5').value = 'Built On Hand ULDs'
    ws.getCell('L5').alignment = center
    ws.getCell('L5').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L6:N6')
    ws.getCell('L6').value = 'To Be Built ULDs'
    ws.getCell('L6').alignment = center
    ws.getCell('L6').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L7:N7')
    ws.getCell('L7').value = 'Positions Available for MEP & Overflow'
    ws.getCell('L7').alignment = center
    ws.getCell('L7').font = bold
    ws.getCell('L7').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }
  
    // ['PMC','PAG','LD2','LD3','LD4/8/FQA'].forEach((t,i)=>{
    //   ws.getCell(2,15+i).value = t
    //   ws.getCell(2,15+i).font = bold
    //   ws.getCell(2,15+i).alignment = center
    // })
  
    ws.getCell('O2').value = 'PMC'
    ws.getCell('O2').font = bold
    ws.getCell('O2').alignment = center
    ws.getCell('O2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.getCell('P2').value = 'PAG'
    ws.getCell('P2').font = bold
    ws.getCell('P2').alignment = center
    ws.getCell('P2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('Q2:R2')
    ws.getCell('Q2').value = 'LD2'
    ws.getCell('Q2').font = bold
    ws.getCell('Q2').alignment = center
    ws.getCell('Q2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('S2:T2')
    ws.getCell('S2').value = 'LD3'
    ws.getCell('S2').font = bold
    ws.getCell('S2').alignment = center
    ws.getCell('S2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('U2:V2')
    ws.getCell('U2').value = 'LD4/8/FQA'
    ws.getCell('U2').font = bold
    ws.getCell('U2').alignment = center
    ws.getCell('U2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
  
    // box(1,9,5,14)
  
    // ==== HINTS BOX ====
    ws.mergeCells('W2:AD2')
    ws.getCell('W2').value = 'Hints'
    ws.getCell('W2').alignment = center
    ws.getCell('W2').font = bold
    ws.getCell('W2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W3:AD4')
    ws.getCell('W3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W5:AD5')
    ws.getCell('W5').value = 'Notes'
    ws.getCell('W5').alignment = center
    ws.getCell('W5').font = bold
    ws.getCell('W5').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W6:AD7')
    ws.getCell('W6').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
  
    const bin_config = get_bin_config(false,this.state)
    ws.getCell('O3').value = bin_config[0]?.PMC || ''
    ws.getCell('P3').value = bin_config[0]?.PAG || ''
    ws.getCell('Q3').value = bin_config[0]?.LD2 || ''
    ws.getCell('S3').value = bin_config[0]?.LD3 || ''
    ws.getCell('U3').value = bin_config[0]?.LD4_8_FQA || ''
  
    for (let r = 3; r <= 7; r++) {
      for (let c = 14; c <= 22; c++) {
        ws.getCell(r, c).alignment = center
        ws.getCell(r, c).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: r == 3 || r == 7 ? 'D9D9D9' : 'DAE3F3' }
        }
      }
    }
  
    setBorderForRange(2, 15, 2, 30)
    setBorderForRange(3, 12, 7, 30)
  
    ws.getCell('AE2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C5E0B4' }
    }
    ws.getCell('AE3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FAE395' }
    }
    ws.getCell('AE4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F2C7AB' }
    }
  
    ws.mergeCells('AF2:AI2')
    ws.getCell('AF2').value = 'Light: <= 1.5 t'
    ws.getCell('AF2').alignment = center
    ws.mergeCells('AF3:AI3')
    ws.getCell('AF3').value = 'Medium: > 1.5 t and <= 3 t'
    ws.getCell('AF3').alignment = center
    ws.mergeCells('AF4:AI4')
    ws.getCell('AF4').value = 'Heavy: > 3 t'
    ws.getCell('AF4').alignment = center
  
    setBorderForRange(2, 31, 4, 35)
  
    ws.mergeCells('AE6:AF6')
    ws.getCell('AE6').value = 'LOOSE:'
    ws.getCell('AE6').font = bold
    ws.getCell('AE6').alignment = center
    ws.mergeCells('AE7:AF7')
    ws.getCell('AE7').value = 'ULD:'
    ws.getCell('AE7').alignment = center
    ws.getCell('AE7').font = bold
    ws.mergeCells('AE8:AF8')
    ws.getCell('AE8').value = 'UWS:'
    ws.getCell('AE8').alignment = center
    ws.getCell('AE8').font = bold
    ws.mergeCells('AG6:AH6')
    ws.getCell('AG6').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(6, 'hours').format('h:mm A')
    ws.getCell('AG6').alignment = center
    ws.mergeCells('AG7:AH7')
    ws.getCell('AG7').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(4, 'hours').format('h:mm A')
    ws.getCell('AG7').alignment = center
    ws.mergeCells('AG8:AH8')
    ws.getCell('AG8').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(3.5, 'hours').format('h:mm A')
    ws.getCell('AG8').alignment = center
    // box(1,15,4,24)
  
    // ==== MAIN AWB HEADER ====
    const headers = ['AWB', 'Pri #', 'Pcs.', `GrWt. (${this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'})`, `Vol (${this.state.editWgtUnit === 'KG' ? 'cbm' : 'cft'})`, 'Orig', 'Dest', 'Prod', 'SPLs', 'Desc', 'Agent', 'DoD Remarks', 'CSO Remarks', 'Shipper-Built?', 'On Hand?']
  
    headers.forEach((h, i) => {
      const cell = ws.getCell(12, 2 + i)
      cell.value = h
      cell.font = bold
      cell.alignment = {
        textRotation: [1, 2, 3, 4, 5, 6, 7, 8, 13, 14].includes(i) ? -90 : 0,
        ...center
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DAE3F3' }
      }
      cell.border = {
        top: thin,
        left: thin,
        right: thin,
        bottom: thin
      }
    })
    for (let i = 17; i <= 37; i++) {
      const cell = ws.getRow(10).getCell(i)
      cell.value = i == 37 ? 'BULK' : i - 16
      cell.font = {
        size: 10,
        color: { argb: 'FF808080' } // grey
      }
      cell.alignment = center
    }
    let uld_col = 17
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = ws.getRow(11).getCell(uld_col)
      cell.value = uld.type
      cell.alignment = center
      uld_col++
    })
  
  
    uld_col = 17
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = ws.getRow(12).getCell(uld_col)
      cell.value = uld.uld_no || ''
      cell.alignment = center
      uld_col++
    })
  
    setBorderForRange(11, 17, 12, 37)
  
    const dataRows = []
    this.state.mergeEditRecord?.map((awb) => {
      let unit = awb?.wgt?.unit
      let wgtValue = ''
      {
        if (this.state.editWgtUnit === 'KG') {
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
            wgtValue = Math.round(kg)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
        else if (this.state.editWgtUnit === 'LB') {
          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
            wgtValue = Math.round(lb)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
      }
  
      let vol = awb?.vol?.value
      let volValue = ''
      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
        let cbf = this.updateVolumeVal('CBF', vol)
        volValue = Math.round(cbf * 10) / 10
      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
        let cbm = this.updateVolumeVal('CBM', vol)
        volValue = Math.round(cbm * 10) / 10
      } else {
        volValue = (Math.round(vol * 10) / 10)
      }
  
      let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === awb.awb_no)
      let priority = bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.pri != null ? this.state.editRecord.build_plan[bpIndex]?.data?.pri : awb.priority
      let awb_data = [
        '',
        awb?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2') || '',
        priority || 0,
        awb?.pcs || '',
        wgtValue || '',
        volValue || '',
        awb?.org || '',
        awb?.dest || '',
        awb?.prod_code || '',
        awb?.spl_code || '',
        '',
        '',
        '',
        '',
        '',
        awb?.on_hand ? 'Y' : 'N',
      ]
      this.state.editRecord?.build_uld?.map((uld) => {
        let pcs = ''
        if (bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0) {
          let found = this.state.editRecord.build_plan[bpIndex]?.ulds.find((u) => u.id === uld.id)
          if (found) {
            pcs = found.pcs
          }
        }
        awb_data.push(pcs)
      })
      awb_data[36] = bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.blk ? this.state.editRecord.build_plan[bpIndex]?.data?.blk : ''
      dataRows.push(awb_data)
    })
  
    dataRows.sort((a, b) => {
      if (a[3] != b[3]) {
        return b[3] - a[3] // sort by pieces desc
      }
    })
  
    dataRows.forEach((rowData, i) => {
      const row = ws.getRow(13 + i)
      // trim rowData till 36 index
      row.values = rowData
      row.eachCell((cell, colNumber) => {
        // prod_code if (['RDG', 'ICE', 'ICV'].includes(awb?.prod_code)) {
        if (colNumber == 9) {
          if (cell.value.includes('RDG') || cell.value.includes('ICE') || cell.value.includes('ICV')) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFC7CE' }
            }
          } else if (cell.value.includes('AMZ')) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFCCE5FF' }
            }
          }
        }
      })
    })
  
    setBorderForRange(13, 2, 13 + dataRows.length - 1, 37)
    // set print area
    ws.pageSetup = {
      orientation: 'landscape',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 1,
      horizontalCentered: true,
      verticalCentered: true,
    }
    ws.pageSetup.printArea = 'B1:AK' + (13 + dataRows.length - 1)
  
    const buffer = await workbook.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `LHR${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `LHR${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }
  

  callbackTabClicked = (key) => {
    this.setState({ activeTab: key })
  }

  onTabEdit = (targetKey, action) => {
    if (action === 'remove') {
      this.removeTab(targetKey)
    }
  }

  removeTab = (targetKey) => {
    const { visibleTabs } = this.state
    const newVisibleTabs = visibleTabs?.filter(key => key !== targetKey)
    let editRecord = this.state.editRecord
    // Call unlock function based on which tab is being removed
    if (targetKey === 'initial') {
      this.unlockBP({ init: true })
      editRecord.init_build_plan = null
    } else if (targetKey === 'final') {
      this.unlockBP({ final: true })
      editRecord.final_build_plan = null
    }

    this.setState({
      visibleTabs: newVisibleTabs,
      activeTab: 'bp',
      editRecord: editRecord
    })
  }

  submit = async (action) => {
    if (this.state.editRecord?.id) {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = {}
      let url = ''
  
      if (action == 'add' || action === 'edit') {
        url = `/flight_plan/${action}/${parseInt(this.state.editRecord.id)}`
        if (this.state.editAllocRecord) {
          formdata.id = this.state.editAllocRecord?.id
        }
        formdata.comm1 = this.state.editAllocRecord ? this.state.editTComm1 || '' : this.state.editComm1 || ''
        formdata.comm2 = this.state.editAllocRecord ? this.state.editTComm2 || '' : this.state.editComm2 || ''
      } else if (action == 'delete') {
        url = `/flight_plan/${action}/${parseInt(this.state.editRecord?.id)}/${parseInt(this.state.deleteAllocID)}`
      }
  
      let awaitMehod = action == 'add' || action === 'edit' ? http.post(url, formdata, { headers }) : http.delete(url, { headers })
      await awaitMehod.then((data) => {
        if (data && data?.status === 200) {
          //CLEAR LOAD PLAN FORM
          if (action == 'add') this.clearEditAllocForm()
          //CLEAR LOAD PLAN TABLE FORM
          if (this.state.editAllocRecord) this.clearAllocTableForm()
  
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      })
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Invalid Input',
      })
    }
  }

  //CLEAR ALLOCATIONS FORM
  clearEditAllocForm = () => {
    this.setState({
      editPos: '',
      editType: '',
      editWorkArea: '',
      editULDAWB: '',
      editProd: '',
      editComm1: '',
      editComm2: '',
    })
  }
  //CLEAR ALLOCATIONS TABLE FORM
  clearAllocTableForm = () => {
    this.setState({
      editAllocRecord: null,
      deleteAllocID: null,
      editTPos: '',
      editTType: '',
      editTWorkArea: '',
      editTULDAWB: '',
      editTProd: '',
      editTComm1: '',
      editTComm2: '',
    })
  }

  editAllocTableForm = (record) => {
    this.setState({
      editAllocRecord: record,
      editTPos: record?.pos,
      editTType: record?.type,
      editTWorkArea: record?.work_area,
      editTULDAWB: record?.uld_awb_no,
      editTProd: record?.prod_code,
      editTComm1: record?.comm1,
      editTComm2: record?.comm2,
    })
  }

  opti = () => {
    this.setState({ optiLoader: true })
    http.get(`/build_opti/${this.state.editRecord?.id}?priority=${this.state.priority || false}`)
      .then(() => {
        setTimeout(() => {
          this.setState({ optiLoader: false })
        }, 4000)
      })
  }
  opti_clear = () => {
    this.setState({ clearLoader: true })
    http.get(`/build_opti_clear/${this.state.editRecord?.id}?stn=${cookies.get('station')}`)
      .then(() => {
        setTimeout(() => {
          this.setState({ clearLoader: false })
        }, 4000)
      })
  }
  
  autoAssignUlds = () => {
    this.setState({ assignLoader: true })
    http.get(`/assign_ulds/${this.state.editRecord?.id}?stn=${cookies.get('station')}`).then((d) => {
      setTimeout(() => {
        this.setState({ assignLoader: false })
      }, 4000)
      if (d?.status !== 200) {
        notification.destroy()
        notification.error({
          message: 'Error',
          description: d?.data?.message || 'Something went wrong'
        })
      }
    }).catch((e) => {
      this.setState({ assignLoader: false })
      notification.destroy()
      notification.error({
        message: 'Error',
        description: e?.response?.data?.message || 'Something went wrong'
      })
    })
  }

  updateUlds = async () => {
    let awb = this.state.mergeEditRecord?.find((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    let uld = this.state.editRecord?.build_uld?.find((item) => item?.id === this.state.assignUld?.id)
    if (uld && awb) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        pcs: this.state.editUlds?.pcs,
        remark: awb?.priority,
        uld_no: uld?.uld_no,
        uld_type: uld?.type,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.wgt || 0, 'KGM') : this.state.editUlds?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? this.state.editUlds?.vol : volumnCalculator(this.state.editUlds?.vol || 0, 'CBF'),
        id: uld?.id,
        ch_wgt: this.state.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.ch_wgt || 0, 'KGM') : this.state.editUlds?.ch_wgt,
        uld_id: this.state.editUlds?.uld_id,
        pri: awb?.pri,
      }
      await http.put(`/build_plan_uld/${this.state.editRecord.id}`, formData)
        .then(async (data) => {
          if (data && data?.status === 200) {
            this.setState({ editUlds: {}, })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
          this.setState({ loading: false })
        }).catch(() => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
          this.setState({ servererror: true })
        })
    } else if (this.state.assignUld?.id == 0 && awb) {
      // let ch_wgt_lb = weightCalculator(awb?.ch_wgt || 0, 'KGM')
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: this.state.editUlds?.pcs,
        blk_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.wgt || 0, 'KGM') : this.state.editUlds?.wgt,
        blk_vol: this.state?.editWgtUnit === 'KG' ? this.state.editUlds?.vol : volumnCalculator(this.state.editUlds?.vol || 0, 'CBF'),
        // ch_wgt: awb?.ch_wgt ? ch_wgt_lb * this.state.editUlds.pcs : 0,
        only_blk: true,
      }
      http.put(`/build_plan_awb/${this.state.editRecord?.id}`, formData).then((data) => {
        if (data && data?.status === 200) {
          this.setState({ editUlds: {} })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Please select correct ULD',
      })
    }
  }

  fetchUlds = () => {
    let awbs = this.state.editRecord?.build_plan?.filter((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    if (awbs?.length > 0) {
      this.setState({ assignedUldsData: awbs[0]?.ulds || [] })
    }
    else {
      this.setState({ assignedUldsData: [] })
    }
  }

  handleEditUldChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    let other_data = {}
    let flightDetails = this.state.flightDetails
    if (name == 'pcs') {
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      actual_wgt = Math.round((actual_wgt / flightDetails?.pcs) * value)
      other_data.wgt = actual_wgt
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      actual_vol = Math.round(((actual_vol / flightDetails?.pcs) * value) * 10) / 10
      other_data.vol = actual_vol
      let actual_ch_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value
      actual_ch_wgt = Math.round((actual_ch_wgt / flightDetails?.pcs) * value)
      other_data.ch_wgt = actual_ch_wgt

    }
    this.setState(prevState => ({
      editUlds: {
        ...prevState.editUlds,
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        [name]: value,
        ...other_data
      }
    }))
  }

  handleOptiUldChange = (e) => {
    let optiUld = this.state.optiUld
    optiUld[e.target.name] = e.target.value
    this.setState({ optiUld })
  }
  
  handleEditOptiUldChange = (e) => {
    let editOptiUld = this.state.editOptiUld
    editOptiUld[e.target.name] = e.target.value
    this.setState({ editOptiUld })
  }
  
  lockBP = () => {
    let build_plan = this.state.editRecord?.build_plan || []
    let build_uld = this.state.editRecord?.build_uld || []
    let data = {
      build_plan: build_plan,
      build_uld: build_uld,
      mergeEditRecord: this.state.mergeEditRecord || []
    }
    let headers = { user_id: this.state.user_id, }
    if(!this.state.editRecord?.init_build_plan) {
      let scrub_data = getScrubData(this.state.editRecord, this.state.priorityData)
      const scrubCopyData = {
        flight_id: this.state.editRecord.id,
        station: this.state.station,
        scrub_data: { 
          ...scrub_data || {},
          user: {
            name: cookies.get('name') || '',
            username: cookies.get('username') || '',
          },
          date: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        }
      }
      http.post('/save_scrub_copy', scrubCopyData)
    }
    http.post(`/build_plan_lock/${this.state.editRecord.id}`, data, { headers })
      .then((resp) => {
        if (resp && resp.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: 'Build Plan locked successfully! \nPlease do not close the modal screenshot is being uploaded to Flight Audit.',
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
  }
  
  unlockBP = (data) => {
    http.post(`/build_plan_unlock/${this.state.editRecord.id}`, data)
  }

  emailLoadPlan = async () => {
    const builderCopy = await this.generateLoadPlan('email')
    const lhrCopy = this.state.editRecord?.org_stn === 'LHR' ? await this.generateLoadPlanLHR('email') : null
    const scrubCopy = await this.exportScrub('email')
  
    const attachments = [
      builderCopy,
      scrubCopy,
      ...(lhrCopy ? [lhrCopy] : [])
    ]
  
    const divContent = this.modalRef.current.innerHTML
    const formData = new FormData()
    formData.append('emailContent', divContent)
    formData.append('emailSubject', `Build Plan: ${this.state.editRecord?.flight_no || 'N/A'}/${this.state.editRecord?.org && this.state.editRecord?.dest ? (this.state.editRecord.org.origin) + '-' + (this.state.editRecord.dest.arriv) : 'N/A'} ${this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}`)
    formData.append('flightId', this.state.editRecord?.id)
    formData.append('name', cookies.get('name'))
    formData.append('userId', cookies.get('user'))
    attachments.forEach((att) => {
      formData.append('attachments', att.fileBlob, att.fileName)
    })
    let headers = { station: this.state.station, }
    http.post('/email_load_plan', formData, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
          // Refresh email logs after successful send
          if (this.state.editRecord?.id) {
            this.fetchEmailLogs(this.state.editRecord.id)
          }
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch((err) => {
        console.log('err', err)
      })
  }

  addOptiData = () => {
  
    let uld_no = this.state.optiUld?.uld_no || null
    if (!uld_no) {
      // If ULD number is not provided, get count of existing ULDs of the same type and generate a new ULD number, count + 1. if the number exists, increment by 1 till it doesn't match any existing ULD number
      let ulds = [
        ...(this.state.activeTab === 'initial'
          ? this.state.editRecord?.init_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
          : this.state.activeTab === 'final'
            ? this.state.editRecord?.final_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
            : this.state.editRecord?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
        ),
        ...(
          this.state.editRecord?.ulds_out?.filter(u => {
            if (u.info?.remark?.includes('SLU')) {
              return {
                id: u.id,
                type: u.uld_no,
                slu: true
              }
            }
          }) || []
        ),
        {
          id: 0,
          type: 'BULK'
        } || []
      ]
      let type = this.state.optiUld?.type || ''
      console.log('ulds.length', ulds.length)
      let filteredUlds = ulds.filter(u => u.type === type)
      console.log('filteredUlds.length', filteredUlds.length)
      let count = filteredUlds.length
      let newUldNo = count + 1
      while (filteredUlds.some(u => u.uld_no === newUldNo.toString())) {
        newUldNo++
      }
      uld_no = newUldNo.toString()
    }
    let obj = {
      uld_no: uld_no,
      type: this.state.optiUld?.type,
      remark: this.state.optiUld?.remark,
      stn: cookies.get('station'),
      pallet_stacked: this.state.optiUld?.pallet_stack ? true : false,
      pallet_stack_count: this.state.optiUld?.pallet_stack ? parseInt(this.state.optiUld?.pallet_stack_count) || 0 : 0,
    }
    if (obj.type) {
      http.post(`/build_uld/${this.state.editRecord.id}`, obj).then(({ data }) => {
        this.setState((prevState) => ({
          optiUld: {},
          switch: false,
          editRecord:{
            ...prevState.editRecord,
            build_uld: [...(prevState.editRecord.build_uld || []), data.data]
          }
        }))
      })
    }
  }
  addAwb = () => {
    let data = {
      id: 0,
      init: true,
      manual: true,
      awb_no: '',
      location: '',
      delay: moment().tz(this.state.timezone).format('YYYY-MM-DD HH:mm'),
      priority: '',
      prod_code: '',
      spl_code: '',
      wgt: { value: 0, },
      vol: { value: 0, },
      ch_wgt: { value: 0, }
    }
    const find = this.state.mergeEditRecord.find((item) => item.init === true)
    if (find) {
      return true
    }
    this.setState({ mergeEditRecord: [...this.state.mergeEditRecord, data] }, () => {
      this.setState({ editAwbsRecord: data })
    })
  }
  addULD = (record) => {
    let assignUld = {
      type: 'BULK',
      id: 0,
    }
    let bpIndex = this.state.editRecord?.build_plan?.findIndex(item => item.awb_no === record.awb_no)
    if (bpIndex != -1) {
      if (this.state.editRecord.build_plan[bpIndex].data?.blk > 0) {
        assignUld = {
          type: 'BULK',
          id: 0
        }
      } else if (this.state.editRecord.build_plan[bpIndex].ulds && this.state.editRecord.build_plan[bpIndex].ulds.length > 0) {
        assignUld = { id: this.state.editRecord.build_plan[bpIndex].ulds[0].id }
      }
    }
    this.setState({
      addULD: true,
      flightDetails: {
        ...record,
        editWgtUnit: this.state.editWgtUnit
      },
      assignUld: assignUld
    }
    , () => {
      this.fetchUlds()
    }
    )

  }
  editUlds = (record) => {
    this.setState({
      editUlds: {
        ...record,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(record?.wgt || 0, 'LBS') : record?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? record?.vol : volumnCalculator(record?.vol || 0, 'CBM'),
        ch_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(record?.ch_wgt || 0, 'LBS') : record?.ch_wgt,
      }
    })
  }

  deleteUlds = (record) => {
    let formdata = {
      awb_no: this.state.flightDetails?.awb_no,
      uld_id: record.uld_id,
      stn: cookies.get('station'),
    }
    if (record.id == 0) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: 0,
        blk_wgt: 0,
        blk_vol: 0,
        only_blk: true,
      }
      http.put(`/build_plan_awb/${this.state.editRecord?.id}`, formData).then((data) => {
        if (data && data?.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    } else {
      http.put(`/build_plan_uld_remove/${this.state.editRecord?.id}`, formdata)
        .then((data) => {
          if (data && data.status === 200) {
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }


  editAwbs = (record) => {
    let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === record.awb_no)
    let editAwbs = {
      pcs: record.pcs,
      location: record.location,
      dest: record.dest,
      prod_code: record.prod_code,
      spl_code: record.spl_code,
      delay: record.delay,
      pre_build: record.pre_build,
      on_hand: record.on_hand,
      pri: record.pri,
      comment: record.comment,
    }

    let wgt = this.state.editWgtUnit === 'LB' ?
      (['L', 'LB', 'LBR', 'LBS'].includes(record?.wgt?.unit) ?
        (record?.wgt?.value || 0)
        :
        this.updateWeightVal('LB', record?.wgt?.value || 0)
      ) :
      (['K', 'KG', 'KGM', 'KGS'].includes(record?.wgt?.unit) ?
        (record?.wgt?.value || 0)
        :
        this.updateWeightVal('KG', record?.wgt?.value || 0)
      )
    let vol = this.state.editWgtUnit === 'LB' ?
      (['CBF', 'CFT'].includes(record?.vol?.unit) ?
        (record?.vol?.value || 0)
        :
        this.updateVolumeVal('CBF', record?.vol?.value || 0)
      ) :
      (['CBM'].includes(record?.vol?.unit) ?
        (record?.vol?.value || 0)
        :
        this.updateVolumeVal('CBM', record?.vol?.value || 0)
      )
    let ch_wgt = this.state.editWgtUnit === 'LB' ?
      (['L', 'LB', 'LBR', 'LBS'].includes(record?.ch_wgt?.unit) ?
        (record?.ch_wgt?.value || 0)
        :
        this.updateWeightVal('LB', record?.ch_wgt?.value || 0)
      ) :
      (['K', 'KG', 'KGM', 'KGS'].includes(record?.ch_wgt?.unit) ?
        (record?.ch_wgt?.value || 0)
        :
        this.updateWeightVal('KG', record?.ch_wgt?.value || 0)
      )
    editAwbs.wgt = wgt
    editAwbs.vol = vol
    editAwbs.ch_wgt = ch_wgt

    if (bpIndex !== -1) {

      if (this.state.editRecord?.build_plan[bpIndex]?.data) {
        if (record.manual) {
          editAwbs = {
            ...editAwbs,
            ...this.state.editRecord?.build_plan[bpIndex]?.data
          }
        }
        editAwbs = {
          ...editAwbs,
          blk: this.state.editRecord?.build_plan[bpIndex]?.data?.blk || record?.blk || 0,
          blk_wgt: this.state.editRecord?.build_plan[bpIndex]?.data?.blk_wgt || record?.blk_wgt || 0,
          blk_vol: this.state.editRecord?.build_plan[bpIndex]?.data?.blk_vol || record?.blk_vol || 0,
        }
      }
      if (record?.manual) {
        // 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS'
        editAwbs = {
          ...this.state.editRecord?.build_plan[bpIndex]?.data,
          ...editAwbs,
          awb_no: record.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2'),
          manual: record.manual,
          id: this.state.editRecord?.build_plan[bpIndex]?.id,
        }
      }
    }
    this.setState({
      editAwbs,
      editAwbsRecord: record,
      bpIndex: bpIndex,
    })
  }

  handleEditAwb = (e, nameOverride) => {
    let name, value
    if (e && e.target) {
      name = e.target.name
      value = (name === 'location' || name === 'dest' || name === 'prod_code' || name === 'spl_code') ? e.target.value.toUpperCase() : e.target.value
    } else if (typeof nameOverride === 'string') {
      name = nameOverride
      value = e
    } else {
      // fallback: do nothing or handle error
      return
    }
    let other_data = {}
    if (name == 'blk') {
      let actual_wgt = ['K', 'KG', 'KGM', 'KGS'].includes(this.state.editAwbsRecord?.wgt.unit) ? this.updateWeightVal('LB', this.state.editAwbsRecord?.wgt.value || 0) : this.state.editAwbsRecord?.wgt.value || 0
      actual_wgt = Math.round((actual_wgt / this.state.editAwbsRecord?.pcs) * value)
      other_data.blk_wgt = actual_wgt
      let actual_vol = (['CBF', 'CFT'].includes(this.state.editAwbsRecord?.vol.unit) ? this.updateVolumeVal('CBM', this.state.editAwbsRecord?.vol.value || 0) : this.state.editAwbsRecord?.vol.value || 0)
      actual_vol = Math.round(((actual_vol / this.state.editAwbsRecord?.pcs) * value) * 10) / 10
      other_data.blk_vol = actual_vol
    }
    if (this.state.editAwbsRecord?.manual) {
      const calculateChargeableWeight = ({ grossWeight, volume, volumeUnit }) => {
        let dimensionalWeight = 0

        if (volumeUnit === 'CFT') {
          dimensionalWeight = volume * 10.4048682
        } else if (volumeUnit === 'CBM') {
          dimensionalWeight = volume * 166.67
        }

        return Math.max(grossWeight, dimensionalWeight)?.toFixed(2)
      }
      if (name == 'wgt' && value > 0 && this.state.editAwbs.vol && this.state.editAwbs.vol > 0) {
        other_data.ch_wgt = calculateChargeableWeight({
          grossWeight: value,
          volume: this.state.editAwbs.vol,
          volumeUnit: this.state.editWgtUnit === 'KG' ? 'CBM' : 'CFT'
        })
      }
      if (name == 'vol' && value > 0 && this.state.editAwbs.wgt && this.state.editAwbs.wgt > 0) {
        other_data.ch_wgt = calculateChargeableWeight({
          grossWeight: this.state.editAwbs.wgt,
          volume: value,
          volumeUnit: this.state.editWgtUnit === 'KG' ? 'CBM' : 'CFT'
        })
      }
    }
    this.setState(prevState => ({
      editAwbs: {
        ...prevState.editAwbs,
        stn: cookies.get('station'),
        ...other_data,
        [name]: value
      }
    }), async () => {
      if (name === 'awb_no' && this.state.editAwbsRecord?.manual && RegExp(/(\d{3})-?(\d{8})/).test(value)) {
        await http.get(`/awb_info/${value.replace(/(\d{3})-?(\d{8})/, '$1$2')}`).then((data) => {
          if (data && data?.status === 200) {
            let awbData = data?.data?.data
            let pcs = awbData?.pcs?.total?.value || 0
            let wgt_unit = awbData?.weight_unit
            let wgt = 0
            if (this.state.editWgtUnit === 'KG') {
              wgt = ['K', 'KG', 'KGM', 'KGS'].includes(wgt_unit) ? awbData?.wgt?.total?.value || 0 : this.updateWeightVal('KG', awbData?.wgt?.total?.value || 0)
            } else {
              wgt = ['L', 'LB', 'LBR', 'LBS'].includes(wgt_unit) ? awbData?.wgt?.total?.value || 0 : this.updateWeightVal('LB', awbData?.wgt?.total?.value || 0)
            }
            let vol = 0
            if (this.state.editWgtUnit === 'KG') {
              vol = ['CBF', 'CFT'].includes(awbData?.vol_unit) ? this.updateVolumeVal('CBM', awbData?.vol?.total?.value || 0) : awbData?.vol?.total?.value || 0
            } else {
              vol = ['CBM'].includes(awbData?.vol_unit) ? this.updateVolumeVal('CBF', awbData?.vol?.total?.value || 0) : awbData?.vol?.total?.value || 0
            }
            let ch_wgt = 0
            if (this.state.editWgtUnit === 'KG') {
              ch_wgt = ['K', 'KG', 'KGM', 'KGS'].includes(wgt_unit) ? awbData?.ch_pcs || 0 : this.updateWeightVal('KG', awbData?.ch_pcs || 0)
            } else {
              ch_wgt = ['L', 'LB', 'LBR', 'LBS'].includes(wgt_unit) ? awbData?.ch_pcs || 0 : this.updateWeightVal('LB', awbData?.ch_pcs || 0)
            }

            ch_wgt = ch_wgt * pcs

            this.setState(prevState => ({
              editAwbs: {
                ...prevState.editAwbs,
                pcs: pcs,
                wgt: wgt,
                vol: vol,
                pri: awbData?.prod_code ? this.state.priorityData?.find((item) => item.p_code === awbData?.prod_code)?.priority || null : null,
                sort_priority: awbData?.prod_code ? this.state.priorityData?.find((item) => item.p_code === awbData?.prod_code)?.sort_priority || null : null,
                ch_wgt: ch_wgt,
                dest: awbData?.dest,
                prod_code: awbData?.prod_code,
                spl_code: awbData?.spl_code,
                delay: awbData?.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment.utc(awbData?.time_of_avl).tz(this.state.timezone), 'days') : 0,
              }
            }))
          }
        })
      }
    })
  }

  mismatchPcs = (pcs, row) => {
    let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === row.awb_no)
    this.state.editRecord.build_plan && this.state.editRecord.build_plan.length > 0 && this.state.editRecord.build_plan[bpIndex] && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0 ?
      this.state.editRecord.build_plan[bpIndex]?.ulds?.map((uld) => {
        return pcs - uld.pcs !== 0 ? 'bg-red' : null
      }) : (row.slu_uld && row.slu_uld.length > 0 ? row.slu_uld.map((uld) => {
        return pcs - uld.pcs !== 0 ? 'bg-red' : null
      }) : null)
  }

  renderSplCodes = (splCode) => {
    if (!splCode) return '-'
    const dg = ['RDG', 'ICE', 'ICV']
    return splCode.toString().split(',').map((c) => c.trim()).filter(Boolean).map((code, index) => {
      const up = code.toUpperCase()
      const cls = dg.some((d) => up.includes(d)) ? 'color-red' : up.includes('AMZ') ? 'color-blue' : ''
      return <React.Fragment key={index}>{index > 0 && ', '}<span className={cls}>{code}</span></React.Fragment>
    })
  }

  updateWeightVal = (unit, value) => {
    value = parseFloat(value || 0)
    if (value > 0) {
      if (unit === 'LB') {
        return weightCalculator(value, 'KGM')?.toFixed(2)
      } else if (unit === 'KG') {
        return weightCalculator(value, 'LBS')?.toFixed(2)
      }
    } else {
      return 0
    }
  }

  updateVolumeVal = (unit, value) => {
    if (value > 0) {
      if (unit === 'CBM') {
        return volumnCalculator(parseFloat(value || 0), 'CBF')?.toFixed(2)
      } else if (unit === 'CBF' || unit === 'CFT') {
        return volumnCalculator(parseFloat(value || 0), 'CBM')?.toFixed(2)
      }
    } else {
      return 0
    }
  }

  updateAwbRecord = async () => {
    let formdata = {
      stn: cookies.get('station'),
      awb_no: this.state.editAwbsRecord?.manual ? this.state.editAwbs.awb_no : this.state.editAwbsRecord?.awb_no,
      ch_wgt: this.state.editAwbs?.ch_wgt,
      blk: this.state.editAwbs?.blk,
      blk_wgt: this.state.editAwbs?.blk_wgt,
      blk_vol: this.state.editAwbs?.blk_vol,
      pri: this.state.editAwbs?.pri,
      comment: this.state.editAwbs?.comment,
    }
    formdata.manual = this.state.editAwbsRecord?.manual
    formdata.location = this.state.editAwbs?.location
    formdata.pcs = this.state.editAwbs?.pcs
    formdata.wgt = this.state.editAwbs?.wgt
    formdata.wgt_unit = this.state.editWgtUnit === 'LB' ? 'LB' : 'KG'
    formdata.vol = this.state.editAwbs?.vol
    formdata.vol_unit = this.state.editWgtUnit === 'LB' ? 'CBF' : 'CBM'
    formdata.dest = this.state.editAwbs.dest
    formdata.prod_code = this.state.editAwbs.prod_code
    formdata.delay = this.state.editAwbs.delay
    formdata.spl_code = this.state.editAwbs.spl_code
    formdata.pre_build = this.state.editAwbs.pre_build
    formdata.on_hand = this.state.editAwbs.on_hand
    formdata.id = this.state.editAwbs?.id
    formdata.stn = cookies.get('station')
    await http.put(`/build_plan_awb/${this.state.editRecord?.id}`, formdata)
      .then(async (data) => {
        if (data && data?.status === 200) {
          this.setState({
            editAwbs: {},
            editAwbsRecord: {},
          })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
        this.setState({ servererror: true })
      })
  }

  blkAwbRecord = async (blk, record) => {
    let formdata = {
      stn: cookies.get('station'),
      awb_no: record?.awb_no,
      blk
    }
    await http.put(`/build_plan_awb/${this.state.editRecord?.id}`, formdata)
      .then(async (data) => {
        if (data && data?.status != 200) {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
        this.setState({ servererror: true })
      })
  }

  deleteAwbRecord = (record) => {
    let formdata = {
      awb_no: record?.awb_no,
      stn: cookies.get('station'),
    }
    http.put(`/build_plan_awb_remove/${this.state.editRecord?.id}`, formdata)
      .then((data) => {
        if (data && data.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data.data.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }

  //GENERATE SUMMARY URL
  summaryURL = () => {
    let contPresent = this.state.editRecord?.cont_type?.length > 0 ? this.state.editRecord?.cont_type : ''
    let selected = ''
    if (contPresent) {
      if (contPresent?.includes('LD2') && this.state.editBagLD2 > 0) {
        selected = 'LD2'
      } else if (contPresent?.includes('LD3') && this.state.editBagLD3 > 0) {
        selected = 'LD3'
      }
    }
  
    if (!selected) {
      if (this.state.editBagLD2 > 0) {
        selected = 'LD2'
      } else if (this.state.editBagLD3 > 0) {
        selected = 'LD3'
      }
    }
  
    let url = `summery?id=${this.state.editRecord?.id}&fleet=${this.state.editRecord?.fleet}`
    //if(selected === 'LD2') {
    url += `&ld2=${this.state.editBagLD2 || 0}`
    //}
    //else if(selected === 'LD3') {
    url += `&ld3=${this.state.editBagLD3 || 0}`
    //}
    return url
  }
  //FETCH FLIGHT SUMMARY
  fetchFlightSummary = async () => {
    await http.get(this.summaryURL()).then((resp) => {
      if (resp?.data?.data) {
        this.calcSummary(resp?.data?.data)
      } else {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: resp?.data?.message,
        })
      }
    }).catch((e) => {
      console.log('error', e)
      this.setState({ servererror: true }, () => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    })
  }

  checkULDType = (uld) => {
    let type = ''
    if (uld?.blk && (!uld?.uld_no?.startsWith('C') && !uld?.uld_no?.endsWith('#'))) {
      type = 'BLK'
    } else {
      if (uld?.info?.remark?.toUpperCase()?.includes('SLU')) {
        type = 'SLU'
      } else if (!uld?.info?.remark?.toUpperCase()?.includes('SLU') && uld?.dest && uld?.dest !== this.state.station && uld?.master) {
        type = 'PTU'
      } else if (uld?.uld_no?.startsWith('C') || uld?.uld_no?.endsWith('#')) {
        type = 'CART'
      }
    }
    return type
  }

  handleCheckboxChange = (selectedRow) => {
    this.setState({
      selected: [selectedRow[selectedRow?.length - 1]?.id] || [],
      bagSelected: selectedRow[selectedRow?.length - 1] || null,
      editHints: selectedRow[selectedRow?.length - 1]?.hint || null,
      editNotes: selectedRow[selectedRow?.length - 1]?.note || null,
    })
  }

  //CALULATE SUMMARY DATA
  calcSummary = (data) => {
    let SLU3CharArr = []
    let SLUAll = []
    let PTU3CharArr = []
    let PTUAll = []
    let Built3CharArr = []
    let BuiltAll = []
  
    let blkObj = {}
    let blk_count_IT = 0
    let blk_count_CI = 0
    let weight_lbs_IT = 0
    let weight_lbs_CI = 0
    let weight_kg_IT = 0
    let weight_kg_CI = 0
  
    let vol_IT = 0
    let vol_CI = 0
  
    data?.summery?.map((item) => {
      if (item?.ulds_in?.blk) {
        if (item?.location) {
          blk_count_CI += 1
          // vol_CI += parseFloat(item?.vol?.value || 0) || 0
          if (item?.vol?.unit === 'FTQ') {
            vol_CI += parseFloat(item?.vol?.value || 0)
          } else if (item?.vol?.unit === 'MTQ') {
            vol_CI += parseFloat((item?.vol?.value || 0) * 35.314667)
          } else if (item?.vol?.unit === 'CF') {
            vol_CI += parseFloat(item?.vol?.value || 0)
          }
  
          if (item.wgt.unit === 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS') {
            weight_lbs_CI += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_kg_CI += weightCalculator(parseFloat(item.wgt.value), 'LBS')
          } else if (item.wgt.unit === 'K' || item.wgt.unit === 'KG' || item.wgt.unit === 'KGM') {
            weight_kg_CI += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_lbs_CI += weightCalculator(parseFloat(item.wgt.value), 'KGM')
          }
        } else {
          blk_count_IT += 1
          // vol_IT += parseFloat(item?.vol?.value || 0) || 0
          if (item?.vol?.unit === 'FTQ') {
            vol_IT += parseFloat(item?.vol?.value || 0)
          } else if (item?.vol?.unit === 'MTQ') {
            vol_IT += parseFloat((item?.vol?.value || 0) * 35.314667)
          } else if (item?.vol?.unit === 'CF') {
            vol_IT += parseFloat(item?.vol?.value || 0)
          }
  
          if (item.wgt.unit === 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS') {
            weight_lbs_IT += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_kg_IT += weightCalculator(item.wgt.value, 'LBS')
          } else if (item.wgt.unit === 'K' || item.wgt.unit === 'KG' || item.wgt.unit === 'KGM') {
            weight_kg_IT += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_lbs_IT += weightCalculator(item.wgt.value, 'KGM')
          }
        }
        //ADD CART IN BUILD UP SUMMARY
        if (!item?.ulds_in?.master && this.checkULDType(item?.ulds_in) === 'CART') {
          if (!BuiltAll.includes(item?.ulds_in?.uld_no)) {
            BuiltAll.push(item?.ulds_in?.uld_no)
            Built3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              ready: item?.ulds_in?.rdy === true ? true : false,
            })
          }
        }
      } else {
        let uldType = this.checkULDType(item?.ulds_in)
        if (uldType === 'SLU') {
          if (!SLUAll?.includes(item?.ulds_in?.uld_no)) {
            SLUAll.push(item?.ulds_in?.uld_no)
            SLU3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              location: item?.ulds_in?.location,
            })
          }
        } else if (item?.ulds_in?.uld_dispo && item?.ulds_in?.master) {
          if (uldType === 'PTU') {
            if (!PTUAll?.includes(item?.ulds_in?.uld_no)) {
              PTUAll.push(item?.ulds_in?.uld_no)
              PTU3CharArr.push({
                uld_no: item?.ulds_in?.uld_no,
                location: item?.ulds_in?.location,
              })
            }
          }
        } else if (item?.ulds_in && !item?.ulds_in?.master) {
          if (!BuiltAll.includes(item?.ulds_in?.uld_no)) {
            BuiltAll.push(item?.ulds_in?.uld_no)
            Built3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              ready: item?.ulds_in?.rdy === true ? true : false,
            })
          }
        }
      }
    })
  
    blkObj.blk_count_CI = blk_count_CI
    blkObj.blk_count_IT = blk_count_IT
    blkObj.weight_lbs_CI = weight_lbs_CI
    blkObj.weight_lbs_IT = weight_lbs_IT
    blkObj.weight_kg_CI = weight_kg_CI
    blkObj.weight_kg_IT = weight_kg_IT
    blkObj.vol_CI = vol_CI?.toFixed(2) || 0
    blkObj.vol_IT = vol_IT?.toFixed(2) || 0
    this.sortSummary(data.bag)
  
    this.setState({
      SLUSummary: SLU3CharArr || [],
      PTUSummary: PTU3CharArr || [],
      BuiltSummary: Built3CharArr || [],
      BLKSummary: blkObj || null,
      bagSummary: data?.bag?.length > 0 ? data.bag : []
    }, () => this.setState({ optimalBuild: true }))
  }
  //SORT
  sortSummary = (array) => {
    array && array.sort(function (a, b) {
      // Compare the fields
      if (a?.pmc > b?.pmc) return -1
      if (a?.pmc < b?.pmc) return 1
      return 0
    })
  }
  //SEARCH MODAL
  searchModal = () => {
    let SLU = this.state.SLUSummary
    let PTU = this.state.PTUSummary
    let BUILT = this.state.BuiltSummary
    let BLK = this.state.BLKSummary
    let bagSummary = this.state.bagSummary
    let ship_no= this.state.editRecord?.wgt_bal_plan?.ship
    let subtract = 0
  
    if(ship_no === '3301' || ship_no === '3302' || ship_no === '3303' || ship_no === '3304' || ship_no === '3305' || ship_no === '3306' || ship_no === '3307' || ship_no === '3308') {
      subtract = 1
    }
    const obcolumns = [
      {
        title: 'MD',
        dataIndex: 'md',
        key: 'md',
        className: 'space-nowrap',
        render: (_, record) => <span>{record?.md || 0}</span>
      },
      {
        // title: 'P96',
        title: 'PMC',
        dataIndex: 'pmc',
        key: 'pmc',
        render: (_, record) => <span>{record?.pmc - this.state.editBagP96}</span>
      },
      {
        // title: 'P88',
        title: 'PAG',
        dataIndex: 'pag',
        key: 'pag',
        render: (_, record) => <span>{record?.pag - this.state.editBagP88}</span>
      },
      {
        title: 'LD3',
        dataIndex: 'ld3',
        key: 'ld3',
        render: (_, record) => <span>{record?.ld3 - this.state.editBagLD3 - subtract}</span>
      },
      {
        title: 'LD2',
        dataIndex: 'ld2',
        key: 'ld2',
        render: (_, record) => <span>{record?.ld2 - this.state.editBagLD2}</span>
      },
    ]
    return (
      <Modal
        title={`Optimal Build - ${this.state.editRecord?.flight_no}/${moment(this.state.editRecord?.flight_date).format(dateOnly)} - ${this.state.editRecord?.ac_type}`}
        open={this.state.optimalBuild}
        onCancel={() => this.setState({ optimalBuild: false })}
        footer={false}
        width={1160}
        centered
        className='curved-modal pb-0'
        destroyOnClose={true}
        closeIcon={<Text type='secondary'><CloseCircleFilled /></Text>}
      >
        <Card size='small' className='custom-card custom-padding mb-4'
          title={
            <Space>
              <span>Cargo Summary</span>
              <Popover content={legendPopover} title='Legend'><InfoCircleFilled /></Popover>
            </Space>}>
          <Row gutter={[{
            xs: 8,
            sm: 16,
            lg: 24
          }, {
            xs: 8,
            sm: 16,
            lg: 24
          }]}>
            <Col xs={24} lg={16}>
              <Card title='On Hand' size='small' bordered={false} className='curved-card custom-padding'>
                <Row gutter={[8, 8]} className='p-2'>
                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>SLU</p>
                      {SLU?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {!key?.location ?
                              <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' /> :
                              <span className='float-right'>AS</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>
  
                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Potential TUs</p>
                      {PTU?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {!key?.location ?
                              <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' /> :
                              <span className='float-right'>AS</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>
  
                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Built Up</p>
                      {BUILT?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {key?.ready === true ?
                              <span style={{ color: '#629d03' }} className='float-right'>C</span> :
                              <span style={{ color: '#D9001B' }} className='float-right'>O</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>
  
                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Loose</p>
                      {/* IN TRANSIT */}
                      {BLK?.blk_count_IT > 0 && <p>
                        <span className='dib-w90'>
                          {`${BLK?.blk_count_IT} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            BLK?.weight_kg_IT : this.state.weight_unit === 'LB' ? BLK?.weight_lbs_IT : 0) || 0}${this.state.weight_unit} | ${BLK?.vol_IT}CF`}
                        </span>
                        <span>
                          <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' />
                        </span>
                      </p>}
                      {/* CHECKED IN */}
                      {BLK?.blk_count_CI > 0 && <p>
                        <span className='dib-w90'>
                          {`${BLK?.blk_count_CI} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            BLK?.weight_kg_CI : this.state.weight_unit === 'LB' ? BLK?.weight_lbs_CI : 0) || 0} | ${BLK?.vol_CI}CF`}
                        </span>
                        <span>
                          <span className='float-right'>AS</span>
                        </span>
                      </p>}
                    </div>
                  </Col>
  
                </Row>
              </Card>
            </Col>
            <Col xs={24} lg={8}>
              <Card title='Booked, Not Tendered' size='small' bordered={false} className='curved-card custom-padding'>
                <Row gutter={[8, 8]} className='p-2'>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <div className='cargo-summary'>
                      <p>SLU</p>
                      <p><span className='dib-w90'>MD</span><span>0</span></p>
                      <p><span className='dib-w90'>PMC/PAG</span><span>{this.state.editRecord?.not_tendered?.udp || 0}</span></p>
                      <p><span className='dib-w90'>LD3</span><span>{this.state.editRecord?.not_tendered?.ldc || 0}</span></p>
                      <p><span className='dib-w90'>LD2</span><span>{this.state.editRecord?.not_tendered?.ldp || 0}</span></p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <div className='cargo-summary'>
                      <p>Loose</p>
                      <p>
                        <span className='dib-w90'>
                          {`${this.state.editRecord?.not_tendered?.blk_count || 0} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            this.state.editRecord?.not_tendered?.weight_kg || 0 :
                            this.state.weight_unit === 'LB' ? this.state.editRecord?.not_tendered?.weight_lbs || 0 :
                              0) || 0}${this.state.weight_unit} | ${this.state.editRecord?.not_tendered?.pcs || 0}CF`}
                        </span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Card>
        <Card size='small' className='custom-card custom-padding' title='Available Configurations'>
          <Row gutter={[{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12
          }, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12
          },]} className='p-12'>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className='table-overflow'
            >
              <Table
                className='custom-table w-100'
                dataSource={bagSummary}
                columns={obcolumns}
                pagination={false}
                rowKey='id'
                rowSelection={{
                  type: 'checkbox',
                  onChange: (_, rows) => this.handleCheckboxChange(rows),
                  hideSelectAll: true,
                  selectedRowKeys: this.state.selected
                }}
              />
            </Col>
            <Col xs={24}>
              <Form layout='vertical' >
                <Form.Item label='Hints' className='hint-form'>
                  <Input.TextArea placeholder='Enter hints'
                    value={this.state.editHints}
                    onChange={(e) => this.setState({ editHints: e.target.value })}
                    disabled
                  />
                </Form.Item>
                <Form.Item label='Notes'>
                  <Input.TextArea placeholder='Enter notes'
                    value={this.state.editNotes}
                    onChange={(e) => this.setState({ editNotes: e.target.value })}
                    disabled
                  />
                </Form.Item>
              </Form>
            </Col>
            <Col className='ml-auto'>
              <Button
                disabled={!this.state.bagSelected}
                type='primary'
                className='custom-button mr-4'
                onClick={this.updateBaggage}
              >Update
              </Button>
            </Col>
          </Row>
        </Card>
      </Modal>
    )
  }
  //UPDATE BAGGAGE POSITIONS
  updateBaggage = () => {
    this.setState({
      editCargoMD: this.state.bagSelected?.md,
      editCargoP96: this.state.editBagP96 > 0 ? this.state.bagSelected?.pmc - this.state.editBagP96 : this.state.bagSelected?.pmc,
      editCargoP88: this.state.editBagP88 > 0 ? this.state.bagSelected?.pag - this.state.editBagP88 : this.state.bagSelected?.pag,
      editCargoLD3: this.state.editBagLD3 > 0 ? this.state.bagSelected?.ld3 - this.state.editBagLD3 : this.state.bagSelected?.ld3,
      editCargoLD2: this.state.editBagLD2 > 0 ? this.state.bagSelected?.ld2 - this.state.editBagLD2 : this.state.bagSelected?.ld2,
      hints: this.state.editHints,
      notes: this.state.editNotes,
      selectedRow: this.state.bagSelected.id
      // remainingP96: 0,
      // remainingP88: 0,
      // remainingLD3: 0,
      // remainingLD2: 0,
      // remainingMD: 0,
    }, () => this.setState({
      selected: [],
      bagSelected: null,
      optimalBuild: false,
      //showAlloc: true,
    }, () => {
      this.submitData(false)
    }))
  }

  getCutoff = (cutoff, flight) => {
    let Hawaii = ['HNL', 'OGG', 'KOA', 'MKK']
    if (typeof cutoff === 'string' && cutoff.includes(',')) {
      let arr = cutoff.split(',')
      let details = this.state.stationsData?.find((stn) => stn?.code === flight?.dest?.arriv) || ''
      if (details) {
        if (Hawaii.includes(flight?.dest?.arriv?.toUpperCase()) && arr.length === 3) {
          return (parseInt(arr[2]) / 60).toFixed(2)
        } else if (country.includes(details?.country?.toUpperCase())) {
          return (parseInt(arr[1]) / 60).toFixed(2)
        } else {
          return (parseInt(arr[0]) / 60).toFixed(2)
        }
      }
    } else {
      return (parseInt(cutoff) / 60).toFixed(2)
    }
  }

  openWB = (value, record=null) => {
    this.setState({
      openPlanner: value,
      wbRecord: record
    })
  }

  handleBagInputChange = (field, value) => {
    this.setState({ [field]: value })
    // Reset the timer on every change
    this.startAutoSaveTimer()
  }

  handleBagInputBlur = () => {
    // Cancel any pending delayed notification
    if (this.state.autosave) {
      clearTimeout(this.state.autosave)
      this.setState({ autosave: null })
    }
    this.showAutoSaveNotification()
  }

  startAutoSaveTimer = () => {
    if (this.state.autosave) {
      clearTimeout(this.state.autosave)
    }
    const timer = setTimeout(() => {
      this.showAutoSaveNotification()
      this.setState({ autosave: null })
    }, 2000)
    this.setState({ autosave: timer })
  }

  showAutoSaveNotification = () => {
    console.log('Auto-save notification triggered')
    // Reset the timer if called again
    if (this.state.autosave) {
      clearTimeout(this.state.autosave)
      this.setState({ autosave: null })
    }
    this.setState({ showSaveIcon: true }, () => {
      this.submitData(false)
      const iconTimer = setTimeout(() => {
        this.setState({ showSaveIcon: false })
      }, 2000)
      this.setState({ autosave: iconTimer })
    })
  }

  submitData = async (autosave = null) => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    let formdata = {
      bag: {},
      cargo: {},
      wgt: {},
    }
    formdata.fcst = this.state.editFcst || 0
    formdata.bag.p96 = this.state.editBagP96 || 0
    formdata.bag.p88 = this.state.editBagP88 || 0
    formdata.bag.ld3 = this.state.editBagLD3 || 0
    formdata.bag.ld2 = this.state.editBagLD2 || 0
    formdata.cargo.md = this.state.editCargoMD || 0
    formdata.cargo.p96 = this.state.editCargoP96 || 0
    formdata.cargo.p88 = this.state.editCargoP88 || 0
    formdata.cargo.ld3 = this.state.editCargoLD3 || 0
    formdata.cargo.ld2 = this.state.editCargoLD2 || 0
    formdata.wgt.value = this.state.editWgtValue || 0
    formdata.wgt.unit = this.state.editWgtUnit
    formdata.bu_prio = this.state.editBuPrio
    formdata.load_plan = this.state.editIsExceeded
    formdata.cargo.hint = this.state.hints
    formdata.cargo.note = this.state.notes
    formdata.cargo.id = this.state.selectedRow
    formdata.autosave = autosave
    // formdata.details = this.state.editAllocArray
  
    await http.put(`/flight_control_update/${parseInt(this.state.editRecord.id)}`, formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200 && !autosave) {
          // this.setState({ showSuccess: true })
        } else if (data && data?.status === 200 && autosave) {
          // do nothing
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      })
  }

  openBuildPlanDrawer = () => {
    this.setState(prevState => ({ 
      buildPlanDrawerVisible: true,
      emailRadioValue: prevState.emailLogs && prevState.emailLogs[0]?.id || null
    }), () => {
      this.onOpenDrawer()
    })
  }
  onOpenDrawer=() => {
    console.log('in open drawer')
    const selectedLog = (this.state.emailLogs || []).find((log) => log.id === this.state.emailRadioValue)
    if (selectedLog) {
      this.openEmailPreview(selectedLog)
    }
  }
  closeBuildPlanDrawer = () => {
    this.setState({ buildPlanDrawerVisible: false })
  }
  fetchEmailLogs = async (flightId) => {
    try {
      console.log('Fetching email logs for flight ID:', flightId)
      let headers = { station: this.state.station }
      const response = await http.get(`/email_logs?flight_id=${flightId}&type=load_plan`, { headers })
      console.log('Email logs response:', response)
      if (response && response?.status === 200) {
        console.log('Email logs data:', response?.data?.data)
        this.setState({ emailLogs: response?.data?.data || [] })
      }
    } catch (err) {
      console.log('Error fetching email logs:', err)
    }
  }

  openEmailPreview = (email) => {
    console.log('Opening email preview for:', email)
    console.log('Email body length:', email?.body?.length)
    console.log('Email subject:', email?.sub)
    console.log('Email body starts with:', email?.body?.substring(0, 100))
    this.setState({
      selectedEmail: email,
      emailPreviewVisible: true
    }, () => {
      console.log('Modal opened, selectedEmail state:', this.state.selectedEmail)
      console.log('emailPreviewVisible state:', this.state.emailPreviewVisible)
      
      // Try to populate iframe after state update
      setTimeout(() => {
        const iframe = document.getElementById('email-preview-iframe')
        if (iframe && this.state.selectedEmail?.body) {
          console.log('Attempting to populate iframe')
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
          
          // Create email header with metadata
          
          iframeDoc.open()
          iframeDoc.write(this.state.selectedEmail.body)
          iframeDoc.close()
          console.log('Iframe populated with header and body')
        }
      }, 100)
    })
  }

  downloadEmailAsPDF = async () => {
    if (!this.state.selectedEmail) return
  
    try {
      // Get content from iframe first, fallback to div ref
      let emailContent = ''
      const iframe = document.getElementById('email-preview-iframe')
        
      if (iframe) {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
        emailContent = iframeDoc.body.innerHTML
        console.log('Using iframe content for PDF, length:', emailContent.length)
      } else if (this.emailPreviewRef.current) {
        emailContent = this.emailPreviewRef.current.innerHTML
        console.log('Using div ref content for PDF, length:', emailContent.length)
      } else {
        // Fallback to state
        emailContent = this.state.selectedEmail.body
        console.log('Using state body for PDF, length:', emailContent.length)
      }
        
      // Create a printable window with the email content
      const printWindow = window.open('', '', 'height=600,width=800')
        
      // Create email metadata header
      const emailMetadata = `
          <div style="background-color: #f5f5f5; border: 2px solid #d9d9d9; padding: 15px 20px; margin-bottom: 20px; border-radius: 4px;">
            <div style="margin-bottom: 8px;">
              <strong style="color: #333;">To:</strong>
              <span style="color: #555; margin-left: 10px;">
                ${this.state.selectedEmail.mailto?.join(', ')}
              </span>
            </div>
            <div style="margin-bottom: 8px;">
              <strong style="color: #333;">Subject:</strong>
              <span style="color: #555; margin-left: 10px;">${this.state.selectedEmail.sub}</span>
            </div>
            <div>
              <strong style="color: #333;">Date:</strong>
              <span style="color: #555; margin-left: 10px;">
                ${moment(this.state.selectedEmail.createdAt).format('DD MMM YYYY, HH:mm')}
              </span>
            </div>
          </div>
        `
        
      printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${this.state.selectedEmail.sub}</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  margin: 20px;
                  font-size: 13px;
                }
                table {
                  border-collapse: collapse;
                  width: 100%;
                }
                td, th {
                  border: 1px solid #ddd;
                  padding: 8px;
                  text-align: left;
                  font-size: 13px !important;
                }
                th {
                  background-color: #f2f2f2;
                  font-weight: bold;
                }
                /* Force all text to be visible */
                * {
                  font-size: 13px !important;
                }
                @media print {
                  button { display: none; }
                }
              </style>
            </head>
            <body>
              ${emailMetadata}
              ${emailContent}
            </body>
          </html>
        `)
        
      printWindow.document.close()
        
      // Wait for content to load then trigger print
      setTimeout(() => {
        printWindow.print()
      }, 500)
  
      notification.success({
        message: 'Success',
        description: 'Print dialog opened. You can save as PDF from the print dialog.'
      })
    } catch (err) {
      console.log('Error downloading PDF:', err)
      notification.error({
        message: 'Error',
        description: 'Failed to open print dialog'
      })
    }
  }

  handleLockAndScreenshot = () => {
    this.lockBP()  
    setTimeout(() => {
      let fieldName = 'load_trac_conf'
      let type = 'version_1_'
      if (!this.state.editRecord?.init_build_plan) {
        fieldName = 'load_trac_conf'
        type = 'version_1_'
      } else {
        fieldName = 'build_plan_conf'
        type = 'version_2_'
      }
      const node = this.modalContentRef.current
      if (node) {
        node.classList.add('wnb-modal-expanded')
        node.scrollTop = 0
        setTimeout(() => {
          html2canvas(node).then(canvas => {
            node.classList.remove('wnb-modal-expanded')
            canvas.toBlob(blob => {
              if (this.handleAuditScreenshotUpload) {
                const filename = `BuildPlan_${type}${this.state.editRecord?.flight_no || 'flight'}.png`
                this.handleAuditScreenshotUpload(blob, filename, fieldName)
              }
            }, 'image/png')
          })
        }, 100)
      }
    }, 500)
  }

  attachAudit = async (file, filename, fieldName) => {
    if (!file) return
    const headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    const formdata = new FormData()
    if (fieldName === 'wandb_conf') {
      formdata.append('wandb_conf', file, filename) //Weight & Balance Initial
    } else if (fieldName === 'load_trac_conf') {
      formdata.append('load_trac_conf', file, filename) //Proposed Build Plan
    } else if (fieldName === 'build_plan_conf') {
      formdata.append('build_plan_conf', file, filename) //Final Build Plan
    } else if (fieldName === 'wandb_conf2') {
      formdata.append('wandb_conf2', file, filename) //Weight & Balance Final
    }
    await http.put(`/attach_audit_file/${this.state.editRecord?.id}`, formdata, { headers })
      .then((resp) => {
        if (resp?.data?.data) {
          notification.success({
            message: 'Success',
            description: 'Audit files uploaded successfully!',
          })
        } else {
          notification.error({
            message: 'Failed',
            description: resp?.data?.message || 'Upload failed',
          })
        }
      })
      .catch(() => {
        notification.error({
          message: 'Failed',
          description: 'Upload failed',
        })
      })
  }


  handleAuditScreenshotUpload = (blob, filename, fieldName) => {
    if (!blob) return
    const file = new File([blob], filename, { type: 'image/png' })
    this.attachAudit(file, filename, fieldName)
  }


  render() {
    const planLoadColumns = [
      {
        title: '',
        dataIndex: 'pos',
        key: 'pos',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <InputNumber
              min={0}
              precision={0}
              controls={false}
              size='small'
              placeholder=''
              value={this.state.editTPos || ''}
              onChange={(e) => this.setState({ editTPos: e })}
            />
            : <span>{record?.pos}</span>)
      },
      {
        title: '',
        dataIndex: 'type',
        key: 'type',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Select size='small'
              placeholder='Select process'
              className='w-100'
              value={this.state.editTType || ''}
              onChange={(e) => this.setState({ editTType: e })}
            >
              <Option value='P96'>PMC</Option>
              <Option value='P88'>PAG</Option>
              <Option value='LD3'>LD3</Option>
              <Option value='LD2'>LD2</Option>
              <Option value='MD'>MD</Option>
            </Select>
            : <span>{record?.type}</span>)
      },
      {
        title: '',
        dataIndex: 'work_area',
        key: 'work_area',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Select size='small'
              placeholder='Select process'
              className='w-100'
              value={this.state.editTWorkArea || ''}
              onChange={(e) => this.setState({ editTWorkArea: e })}
            >
              <Option value='International'>International</Option>
              <Option value='Dash'>Dash</Option>
              <Option value='Breezeway'>Breezeway</Option>
              <Option value='T-Point'>T-Point</Option>
            </Select>
            : <span>{record?.work_area}</span>)
      },
      {
        title: '',
        dataIndex: 'uld_awb_no',
        key: 'uld_awb_no',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTULDAWB || ''}
              onChange={(e) => this.setState({ editTULDAWB: e.target.value?.toUpperCase() })}
            />
            : <span>{record?.uld_awb_no}</span>)
      },
      {
        title: '',
        dataIndex: 'prod_code',
        key: 'prod_code',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTProd || ''}
              onChange={(e) => this.setState({ editTProd: e.target.value?.toUpperCase() })}
            />
            : <span>{record?.prod_code}</span>)
      },
      {
        title: '',
        dataIndex: 'plan_comm',
        key: 'plan_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm1 || ''}
              onChange={(e) => this.setState({ editTComm1: e.target.value })}
            />
            : <span>{record?.comm1}</span>)
      },
      {
        title: '',
        dataIndex: 'dep_comm',
        key: 'dep_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm2 || ''}
              onChange={(e) => this.setState({ editTComm2: e.target.value })}
            />
            : <span>{record?.comm2}</span>)
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        width: '10%',
        render: (_, record) =>
          <div>
            {this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.submit('edit')} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearAllocTableForm()} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editAllocTableForm(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.setState({ deleteAllocID: record.id }, () => this.submit('delete'))} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      },
    ]

    const CCcolumns = [
      {
        title: 'DOD Team Comments',
        dataIndex: 'plan_comm',
        key: 'plan_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              disabled={this.disableNote(this.state.editRecord?.dept_time)}
              size='small'
              placeholder=''
              value={this.state.editTComm1 || ''}
              onChange={(e) => this.setState({ editTComm1: e.target.value })}
            />
            : <span>{record?.comm1}</span>)
      },
      {
        title: 'Warehouse Team Comments',
        dataIndex: 'dep_comm',
        key: 'dep_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm2 || ''}
              onChange={(e) => this.setState({ editTComm2: e.target.value })}
              disabled
            />
            : <span>{record?.comm2}</span>)
      },
      ...(!this.props.info ? [{
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <div className='action-column'>
              <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.submit('edit')} ><img src={Update} alt='Save' /></Tooltip>
              <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearAllocTableForm()} ><span className='form-clear'>x</span></Tooltip>
            </div>
            :
            <div className='action-column'>
              {/* <Tooltip title='Attachment'>
                    <Badge size='small' count={2}>
                      <Button type='text' shape='circle' className='clip' icon={<PaperClipOutlined />} />
                    </Badge>
                  </Tooltip> */}
              <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editAllocTableForm(record)} ><img src={editIcon} alt='edit' /></Tooltip>
              <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.setState({ deleteAllocID: record.id }, () => this.submit('delete'))} okText='Yes' cancelText='No'>
                <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
              </Popconfirm>
            </div>
        ),
      }] : []),
    ]

    const configColumns = [
      {
        title: '',
        dataIndex: 'empty',
        key: 'empty',
        className: 'min-width-80',
        width: '10%',
        // render: (_, record, index) => (
        //   <span>{index === 0? 'Optimal Configuration': 'Final Configuration'}</span>
        // )
      },
      {
        title: (<span className='test'>  PMC </span>),
        dataIndex: 'PMC',
        key: 'PMC',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.hint}</span>
        // )
      },
      {
        title: (<span className='test'>  PAG </span>),
        dataIndex: 'PAG',
        key: 'PAG',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.hint}</span>
        // )
      },
      {
        title: (<span className='test'>  LD2 </span>),
        dataIndex: 'LD2',
        key: 'LD2',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.ld2}</span>
        // )
      },
      {
        title: (<span className='test'>  LD3 </span>),
        dataIndex: 'LD3',
        key: 'LD3',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.ld3}</span>
        // )
      },
      //   {
      //     title: (<span className='test'>  LD4/8/FQA </span>),
      //     dataIndex: 'LD4',
      //     key: 'LD4',
      //     className: 'checklist-cols-1'
      //   },
      {
        title: (<span className='test'>  Hint </span>),
        // dataIndex: 'Hint',
        key: 'Hint',
        align: 'center',
        render: (_, record) => {
          const obj = {
            children: record.Hint,
            props: {},
          }
          if (record.key != 1) {
            obj.props.colSpan = 2
          }
          obj.children =
            record.key === '1' ?
              (record.Hint ?
                <Popover content={record.Hint || '-'} title='Hint'>
                  <SnippetsOutlined style={{ fontSize: '16px' }} />
                </Popover> :
                <div className={record.key != 1 ? 'col-hint' : ''}>
                  <SnippetsOutlined style={{
                    fontSize: '16px',
                    color: 'lightgray'
                  }} />
                </div>)
              : record.Hint
          return obj
        }
      },
      {
        title: (<span className='test'>  Notes </span>),
        dataIndex: 'Notes',
        // key: 'Notes',
        align: 'center',
        render: (_, record) => {
          const obj = {
            children: record.Notes,
            props: {},
          }
          if (record.key > 1) {
            obj.props.rowSpan = 0
          }
          obj.children = (
            record.Notes ?
              <Popover content={record.Notes} title='Notes'>
                <img src={documentIcon} alt='document' />
              </Popover> :
              <img src={documentIcon} alt='document' className='disabledImg' />
          )
          return obj
        }
      },
      ...(!this.props.info ? [{
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        width: '10%',
        render: (_, record) => {
          if (record.key === '1') {
            return (
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.fetchFlightSummary()} ><img src={editIcon} alt='edit' /></Tooltip>
              </div>
            )
          }
          return null
        },
      }] : []),
    ]

    const optiColumns = [
      {
        title: 'ULD Type',
        dataIndex: 'type',
        key: 'type',
        className: 'min-width-100',
        render: (_, record, index) => (
          this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
            <Select
              value={this.state.editOptiUld?.type}
              size='small'
              name='type'
              className='text-center w-100'
              onChange={(e) => this.handleEditOptiUldChange({
                target: {
                  name: 'type',
                  value: e
                }
              })}
            >
              {const_ulds?.map((c_u, index) => <Option key={index} value={c_u}>{c_u}</Option>)}
            </Select>
            :
            record.type ? <Tag className='bp-tag' color={uld_colors[index].name}>{record.type}</Tag> : '-'
        )
      },
      {
        title: 'ULD #',
        dataIndex: 'number',
        key: 'number',
        className: 'min-width-100',
        render: (_, record) => (
          this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
            <Input
              size='small'
              placeholder=''
              name='uld_no'
              value={this.state.editOptiUld?.uld_no}
              onChange={this.handleEditOptiUldChange}
            />
            :
            record.uld_no ? record.uld_no : '-'
        )
      },
      {
        title: 'Pallet Stack',
        dataIndex: 'pallet_stacked',
        key: 'pallet_stacked',
        className: 'min-width-100',
        render: (_, record) => {
          return this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
            <Space size='small'>
              <Checkbox
                checked={this.state.editOptiUld?.pallet_stacked}
                onChange={(e) => this.handleEditOptiUldChange({
                  target: {
                    name: 'pallet_stacked',
                    value: e.target.checked
                  }
                })}
              />
              {this.state.editOptiUld?.pallet_stacked && <Input
                disabled={!this.state.editOptiUld?.pallet_stacked}
                size='small'
                placeholder='Stack Count'
                name='pallet_stack_count'
                value={this.state.editOptiUld?.pallet_stack_count}
                onChange={(e) => this.handleEditOptiUldChange({
                  target: {
                    name: 'pallet_stack_count',
                    value: e.target.value
                  }
                })}
                className='stack-count-input'
              />}
            </Space>
            :
            record?.pallet_stacked ? 'Yes (' + record.pallet_stack_count + ')' : 'No'
        }
      },
      {
        title: 'Remarks/Pri #',
        dataIndex: 'remarks',
        key: 'remarks',
        className: 'min-width-100',
        width: '20%',
        render: (_, record) => {
          let pri = []
          let awbs = this.showAwbs(record, getCurrentPlan() || [])
          if (awbs && awbs?.length > 0) {
            awbs.map((awb) => {
              if (awb?.pri) {
                pri.push(awb.pri)
              }
            })
          }
          pri.sort((a, b) => a - b)
          return (
            <span>{pri && pri?.[0] ? pri[0] : ('')}</span>
          )
        }
      },
      {
        title: `Est. Vol.(${this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'})`,
        dataIndex: 'vol',
        key: 'vol',
        className: 'min-width-100',
        render: (_, record) => {
          let vol = 0
          if (record?.type === 'BULK') {
            let awbs = this.showAwbs(record, getCurrentPlan() || [])
            if (awbs && awbs?.length > 0) {
              awbs.map((awb) => {
                vol = vol + parseFloat(awb?.blk_vol || 0)
              })
            }
          } else {
            let build_plan = getCurrentPlan()
            if (build_plan && build_plan?.length > 0) {
              build_plan?.map((item) => {
                if (item?.ulds && item?.ulds?.length > 0) {
                  item?.ulds?.map((uld) => {
                    if (uld.id && uld.id == record.id) {
                      vol = vol + parseFloat(uld.vol || 0)
                    }
                  })
                }
              })
            }
          }
          if (this.state.editWgtUnit === 'LB') {
            vol = vol > 0 ? this.updateVolumeVal('CBF', vol) : 0
          }
          vol = (Math.round(vol * 10) / 10)
          return <span>{vol}</span>
        }
      },
      {
        title: `Est. Grs.Wgt(${this.state.editWgtUnit})`,
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          let wgt = (record?.data?.tare_wgt || 0)
          if (record?.type === 'BULK') {
            let awbs = this.showAwbs(record, getCurrentPlan() || [])
            if (awbs && awbs?.length > 0) {
              awbs.map((awb) => {
                wgt = wgt + parseFloat(awb?.blk_wgt || 0)
              })
            }
          } else {
            let build_plan = getCurrentPlan()
            if (build_plan && build_plan?.length > 0) {
              build_plan?.map((item) => {
                if (item?.ulds && item?.ulds?.length > 0) {
                  item?.ulds?.map((uld) => {
                    if (uld.id && uld.id == record.id) {
                      wgt = wgt + parseFloat(uld.wgt || 0)
                    }
                  }
                  )
                }
              })
            }
          }
          wgt = record.wgt ? record.wgt : wgt
          if (this.state.editWgtUnit === 'KG') {
            wgt = wgt > 0 ? this.updateWeightVal('KG', wgt) : 0
          }
          return (
            this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
              <Input
                size='small'
                placeholder=''
                name='wgt'
                value={this.state.editOptiUld?.wgt}
                onChange={this.handleEditOptiUldChange}
              />
              :
              <span>{Math.round(wgt)}</span>
          )
        }
      },
      {
        title: 'Postions Occupied',
        dataIndex: 'positions',
        key: 'positions',
        className: 'min-width-100',
        render: (_, record) => (
          <span>{record?.data?.ld3}</span>
        )
      },
      {
        title: `Chbl ${this.state?.editWgtUnit === 'KG' ? 'kgs' : 'lbs'} per LD3 position`,
        dataIndex: 'chbl',
        key: 'chbl',
        className: 'min-width-100',
        align: 'left',
        render: (_, record) => {
          let wgt = 0
          let org_dest = this.state.editRecord?.org_stn + this.state.editRecord?.dest_stn
          let goal = ch_wt_goals.find((item) => item.lane == org_dest) || {
            lane: org_dest,
            kg: 500,
            lbs: 1100
          }
          let build_plan = getCurrentPlan()
          if (build_plan && build_plan?.length > 0) {
            build_plan?.map((item) => {
              if (item?.ulds && item?.ulds?.length > 0) {
                item?.ulds?.map((uld) => {
                  if (uld.id && uld.id == record.id) {
                    wgt = wgt + (uld?.ch_wgt || 0)
                  }
                }
                )
              }
            })
          }
          let props = {}
          let value = ''
          if (wgt) {
            if (goal) {
              let wgtUnit = this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'
              let goal_wgt = wgtUnit === 'kgs' ? goal?.kg : goal?.lbs
              if (wgtUnit === 'kgs') {
                wgt = this.updateWeightVal('KG', wgt)
              }
              if (parseFloat(goal_wgt) <= (wgt / record?.data?.ld3)) {
                props.style = {
                  color: 'green',
                  marginRight: '2px',
                }
                value = (<> {Math.round(wgt / record?.data?.ld3)} <CheckCircleFilled twoToneColor='#52c41a' />  </>)
              } else {
                props.style = {
                  color: 'var(--redText)',
                  marginRight: '2px',
                }
                value = (<> {Math.round(wgt / record?.data?.ld3)} <CloseCircleFilled style={{ color: 'red' }} />  </>)
              }
            } else {
              value = Math.round(wgt / record?.data?.ld3)
            }
          } else {
            value = ('')
          }
          return {
            props,
            children: value
          }
        }
      },
      ...(!this.props.info ? [{
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        className: 'min-width-100',
        render: (_, record) =>
          this.state.activeTab != 'initial' && this.state.activeTab != 'final' && <>
            {record?.id === this.state.editOptiUld?.id ?
              <div className='action-column'>
                <Tooltip title='Save' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.updateOptiData()}><img src={Update} alt='Save' width='12' height='auto' /></Button>
                  </span>
                </Tooltip>
                <Tooltip title='Clear' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.clearOptiData()}><span className='form-clear'>x</span></Button>
                  </span>
                </Tooltip>
              </div>
              :
              (record.id > 0 && <div className='action-column'>
                <Tooltip title='Edit' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.editOptiData(record)}><img src={editIcon} alt='edit' width='18' /> </Button>
                  </span>
                </Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.removeOptiData(record?.id)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                    <span>
                      <Button className='image-btn awb-image-btn'><img src={deleteIcon} alt='delete' width='14' height='auto' /></Button>
                    </span>
                  </Tooltip>
                </Popconfirm>
              </div>)
            }
          </>
      }] : [])
    ]

    const awbSortFunction = (a, b) => {
      // sort by delay amd then priority
      // let a_delay = a?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(a?.delay), 'days') * -1 : 0
      // let b_delay = b?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(b?.delay), 'days') * -1 : 0
      let a_delay = a?.delay ? a?.delay : 0
      let b_delay = b?.delay ? b?.delay : 0
      let a_pri = a?.pri ? a?.pri : 999
      let b_pri = b?.pri ? b?.pri : 999
      let a_priority = a.sort_priority || 999
      let b_priority = b.sort_priority || 999
      if (a.init && !b.init) return -1
      if (!a.init && b.init) return 1
      if (a_pri !== b_pri) {
        return a_pri - b_pri
      } else {
        if (a_delay != b_delay) {
          return b_delay - a_delay
        } else {
          return a_priority - b_priority
        }
      }
    }


    const awbColumns = [
      {
        title: (<span className='test'>  Location </span>),
        dataIndex: 'location',
        key: 'location',
        className: 'min-width-80',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Location'
                name='location'
                value={this.state.editAwbs.location}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          } else {
            return <span>{record?.location?.split?.(',')?.join(', ') || '-'}</span>
          }
        }
      },
      {
        title: 'Assigned',
        dataIndex: 'assigned',
        key: 'assigned',
        align: 'center',
        render: (_, record) => {
          return <div>
            {record.is_booked && record.is_assigned ? <Tooltip title={'Assigned + Booked'}>
              <div className='d-flex gap-10'>
                <span className='assigned-tag'>ASD</span>
                <span className='booked-tag'>BKD</span>
              </div>
            </Tooltip> : (
              !record.is_booked && record.is_assigned ? <Tooltip title={'Assigned'} >
                <div className='d-flex gap-10'>
                  <span className='assigned-tag'>ASD</span>
                  <span className='booked-tag disabled-tag'>BKD</span>
                </div>
              </Tooltip> : (
                record.is_booked && !record.is_assigned ? <Tooltip title={'Booked'}>
                  <div className='d-flex gap-10'>
                    <span className='assigned-tag disabled-tag'>ASD</span>
                    <span className='booked-tag '>BKD</span>
                  </div>
                </Tooltip> : ''
              )
            )}
          </div>
        }
      },
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Space>
                {record.manual && <Input
                  size='small'
                  placeholder='AWB#'
                  name='awb_no'
                  value={this.state.editAwbs.awb_no}
                  onChange={(e) => this.handleEditAwb(e, record)}
                  className='min-width-100'
                />}
                {!record.manual && <b className={`${this.mismatchPcs(record?.pcs, record)} space-nowrap`}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</b>}
              </Space>
            )
          } else {
            return <Popover
              overlayClassName='awb-popover'
              content={
                <>
                  {record.at_stn && (
                    <>
                      <p className='at-stn-title'>On Hand</p>
                      {record.at_stn?.map((at, index) => (
                        <div key={index} className='at-stn-tag'>
                          <span className='awb-tag-label'>{at?.blk ? 'LOOSE' : at?.uld_no}</span>
                          <span>----------------</span>
                          <span className='min-width-80 text-right'>{at.pcs}Pcs</span>
                        </div>
                      ))}
                    </>
                  )}
                  {record.booked && (
                    <>
                      <p className='at-bkd-title'>Booked</p>
                      {record.booked?.map((bk, index) => (
                        <div key={index} className='at-stn-tag'>
                          <span className='awb-tag-label'>{bk.flight_no}</span>
                          <span>----------------</span>
                          <span className='min-width-80 text-right'>{bk.pcs}Pcs</span>
                        </div>
                      ))}
                    </>
                  )}
                </>
              }>
              <b className={`${this.mismatchPcs(record?.pcs, record)} space-nowrap`}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</b>
            </Popover>
          }
        }
      },
      {
        title: (<span className='test'> Comment </span>),
        dataIndex: 'comment',
        key: 'comment',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Comment'
                name='comment'
                value={this.state.editAwbs.comment}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-150'
              />
            )
          } else {
            return <span>{record?.comment || '-'}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Pcs'
                name='pcs'
                value={this.state.editAwbs.pcs}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-60'
              />
            )
          } else {
            return (<div className='pcs-column'>
              <span>{record?.pcs}Pcs</span>
              {record?.pcs != record?.total_pcs && <span className='split-icon'>
                <img src={SplitIcon} alt='Split' />
              </span>}
            </div>)
          }
        }
      },
      {
        title: (<span className='test'>  GrWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'grwt',
        key: 'grwt',
        render: (_, record) => {
          let unit = record?.wgt?.unit
          let wgtValue = ''
          {
            if (this.state.editWgtUnit === 'KG') {
              if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
                let kg = this.updateWeightVal('KG', record?.wgt?.value)
                wgtValue = Math.round(kg) != 0 ? Math.round(kg) : Math.round(kg * 10) / 10  
              }
              else {
                wgtValue = Math.round(record?.wgt?.value) != 0 ? Math.round(record?.wgt?.value) : (Math.round(record?.wgt?.value * 10) / 10)
              }
            }
            else if (this.state.editWgtUnit === 'LB') {
              if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
                let lb = this.updateWeightVal('LB', record?.wgt?.value)
                wgtValue = Math.round(lb) != 0 ? Math.round(lb) : Math.round(lb * 10) / 10
              }
              else {
                wgtValue = Math.round(record?.wgt?.value) != 0 ? Math.round(record?.wgt?.value) : (Math.round(record?.wgt?.value * 10) / 10)
              }
            }
          }
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='GrWt'
                name='wgt'
                defaultValue={wgtValue}
                value={this.state.editAwbs.wgt}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-80'
              />
            )
          } else {
            return <span>{wgtValue}{this.state.editWgtUnit === 'KG' ? 'KG' : 'LB'}</span>
          }
        }
      },
      {
        title: (<span className='test'>  ChblWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'chwt',
        key: 'chwt',
        render: (_, record) => {
          let unit = record?.ch_wgt?.unit
          let wgtValue = ''
          if (this.state.editWgtUnit === 'KG') {
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              let kg = this.updateWeightVal('KG', record?.ch_wgt?.value)
              wgtValue = kg
            }
            else {
              wgtValue = record?.wgt?.value
            }
          } else if (this.state.editWgtUnit === 'LB') {
            if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
              let lb = this.updateWeightVal('LB', record?.ch_wgt?.value)
              wgtValue = lb
            }
            else {
              wgtValue = record?.ch_wgt?.value
            }
          }
          wgtValue = Math.round(wgtValue) != 0 ? Math.round(wgtValue) : (Math.round(wgtValue * 10) / 10)
          if (record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id)) {
            return (
              <Input
                size='small'
                placeholder='Chbl Wgt'
                name='ch_wgt'
                defaultValue={wgtValue}
                value={this.state.editAwbs.ch_wgt || ''}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return <span>{wgtValue}{this.state.editWgtUnit}</span>
        }
      },
      {
        title: (<span className='test'>  Vol.({this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'}) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          let vol = record?.vol?.value || 0
          if (this.state.editWgtUnit === 'LB' && record?.vol?.unit === 'CBM') {
            vol = this.updateVolumeVal('CBF', vol)
          } else if (this.state.editWgtUnit === 'KG' && (record?.vol?.unit === 'CBF' || record?.vol?.unit === 'CFT')) {
            vol = this.updateVolumeVal('CBM', vol)
          }
          vol = (Math.round(vol * 10) / 10)

          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Vol'
                name='vol'
                defaultValue={vol}
                value={this.state.editAwbs.vol}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          } else {
            return <span>{vol}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pri# </span>),
        dataIndex: 'pri',
        key: 'pri',
        render: (_, record) => {
          if (record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id)) {
            return (
              <Input
                size='small'
                placeholder='Pri#'
                name='pri'
                value={this.state.editAwbs.pri}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          else {
            return (<span>{record.pri}</span>)
          }
        }

      },
      {
        title: (<span className='test'>  Dest </span>),
        dataIndex: 'dest',
        key: 'dest',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Dest'
                name='dest'
                value={this.state.editAwbs.dest}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return <span>{record?.dest}</span>
        }
      },
      {
        title: (<span className='test'>  Prod </span>),
        dataIndex: 'prod',
        key: 'prod',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Prod Code'
                name='prod_code'
                value={this.state.editAwbs.prod_code}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-60'
              />
            )
          }
          return <span>{record?.prod_code}</span>
        }
      },
      {
        title: (<span className='test text-wrap'>Days <br /> DLYD </span>),
        dataIndex: 'time_of_avl',
        key: 'time_of_avl',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <InputNumber
                size='small'
                placeholder='Delay'
                className='w-100'
                min={-10}
                max={10}
                precision={0}
                value={this.state.editAwbs.delay}
                onChange={(e) => this.handleEditAwb(e, 'delay')}
                name='delay'
              />
            )
          }
          let delay = record?.delay ? record?.delay : 0
          if (delay > 0) {
            return <span className='color-red'>{delay}</span>
          } else {
            return <span>{delay}</span>
          }
        }
      },
      {
        title: (<span className='test'>  SPL </span>),
        dataIndex: 'spl',
        key: 'spl',
        className: 'min-width-100',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='SPLs'
                name='spl_code'
                value={this.state.editAwbs.spl_code}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return this.renderSplCodes(record?.spl_code)
        }
      },
      {
        title: (<span className='test'>  Pre-Built? </span>),
        dataIndex: 'preBuilt',
        key: 'preBuilt',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Select
                size='small'
                name='pre_build'
                value={this.state.editAwbs.pre_build}
                onChange={(e) => this.handleEditAwb({
                  target: {
                    name: 'pre_build',
                    value: e
                  }
                }, record)}
              >
                <Option value={true}>Y</Option>
                <Option value={false}>N</Option>
              </Select>
            )
          }
          return <span>{record?.pre_build ? 'Y' : 'N'}</span>
        }
      },
      {
        title: (<span className='test'>  On Hand? </span>),
        dataIndex: 'onHand',
        key: 'onHand',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Select
                size='small'
                name='on_hand'
                value={this.state.editAwbs.on_hand}
                onChange={(e) => this.handleEditAwb({
                  target: {
                    name: 'on_hand',
                    value: e
                  }
                }, record)}
              >
                <Option value={true}>Y</Option>
                <Option value={false}>N</Option>
              </Select>
            )
          }
          return <span>{record?.on_hand ? 'Y' : 'N'}</span>
        }
      },
      {
        title: (<span className='test'>  Assigned ULD </span>),
        dataIndex: 'addUld',
        key: 'addUld',
        align: 'center',
        width: '10%',
        className: '',
        render: (_, row) => {
          // handle for initial, final and bp
          let bpIndex = null
          let build_plan = []
          let build_uld = []
          if (this.state.activeTab === 'initial') {
            bpIndex = this.state.editRecord?.init_build_plan?.data?.build_plan?.findIndex((item) => item.awb_no === row.awb_no)
            build_plan = this.state.editRecord?.init_build_plan?.data?.build_plan || []
            build_uld = this.state.editRecord?.init_build_plan?.data?.build_uld || []
          } else if (this.state.activeTab === 'final') {
            bpIndex = this.state.editRecord?.final_build_plan?.data?.build_plan?.findIndex((item) => item.awb_no === row.awb_no)
            build_plan = this.state.editRecord?.final_build_plan?.data?.build_plan || []
            build_uld = this.state.editRecord?.final_build_plan?.data?.build_uld || []
          } else {
            bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === row.awb_no)
            build_plan = this.state.editRecord.build_plan || []
            build_uld = this.state.editRecord.build_uld || []
          }
          return (
            <div>
              {row.uldAdded === false ?
                <p>-</p>
                :
                <Space size={[0, 8]} wrap className='tag-class' >
                  {build_plan && build_plan.length > 0 && build_plan[bpIndex] && build_plan[bpIndex]?.ulds?.length > 0 ?
                    build_plan[bpIndex]?.ulds?.map((uld) => {
                      let index = build_uld.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt).findIndex((item) => item.id === uld.id)
                      let color = index !== -1 ? uld_colors[index].name : ''
                      let uld_no = index !== -1 ? build_uld[index]?.type + build_uld[index]?.uld_no || '' : uld?.uld_type + (uld?.uld_no || '')
                      return <Fragment key={uld.id}><Tooltip title={`pcs: ${uld.pcs}, grs.wt: ${uld.wgt?.toFixed(2)}`} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                        <Tag className='bp-tag' color={color}>{uld_no}</Tag>
                      </Tooltip></Fragment>
                    }) : null
                  }
                </Space>
              }
            </div>
          )
        }
      },
      {
        title: (<span className='test'>  Bulk Pcs</span>),
        dataIndex: 'bulk',
        key: 'bulk',
        align: 'center',
        className: '',
        render: (_, row) => {
          let build_plan = []
          if (this.state.activeTab === 'initial') {
            build_plan = this.state.editRecord?.init_build_plan?.data?.build_plan || []
          } else if (this.state.activeTab === 'final') {
            build_plan = this.state.editRecord?.final_build_plan?.data?.build_plan || []
          } else {
            build_plan = this.state.editRecord.build_plan || []
          }
          let bpIndex = build_plan.findIndex((item) => item.awb_no === row.awb_no)
          let blk = bpIndex !== -1 ? build_plan[bpIndex]?.data?.blk : 0
          if (row?.awb_no === this.state.editAwbsRecord?.awb_no) {
            return !row.init && (
              <Input
                size='small'
                placeholder='Bulk Pcs'
                name='blk'
                value={this.state.editAwbs.blk}
                onChange={(e) => this.handleEditAwb(e, row)}
              />
            )
          }
          else {
            return (<span>{blk}</span>)
          }
        }
      },
      ...(!this.props.info ? [{
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        className: 'hide-printcol',
        render: (_, record) =>
          this.state.activeTab != 'initial' && this.state.activeTab != 'final' && (record.is_deleted ? (<div className='action-column'>
            <Popconfirm placement='top' title={constants.RestoreText} onConfirm={() => this.deleteAwbRecord(record)} okText='Yes' cancelText='No'>
              <Tooltip title='Restore' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={restoreIcon} alt='Restore' /></Tooltip>
            </Popconfirm>
          </div>) :
            (record?.awb_no === this.state.editAwbsRecord?.awb_no ?
              <div className='action-column'>
                <Tooltip title='Save' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.updateAwbRecord()}><img src={Update} alt='Save' width='12' height='auto' /></Button>
                  </span>
                </Tooltip>
                <Tooltip title='Clear' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.clearTableForm(record)}><span className='form-clear'>x</span></Button>
                  </span>
                </Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Assign to ULD' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.addULD(record)}><img src={ULDicon} alt='uld' width='22' height='13' /></Button>
                  </span>
                </Tooltip>
                <Tooltip title='Edit' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                  <span>
                    <Button className='image-btn awb-image-btn' onClick={() => this.editAwbs(record)}><img src={editIcon} alt='edit' width='18' /> </Button>
                  </span>
                </Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.deleteAwbRecord(record)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' trigger='hover' destroyOnHidden mouseLeaveDelay={0} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} >
                    <span>
                      <Button className='image-btn awb-image-btn'><img src={deleteIcon} alt='delete' width='14' height='auto' /></Button>
                    </span>
                  </Tooltip>
                </Popconfirm>
              </div>))
      }] : [])
    ]

    const nestedAwbColumns = [
      {
        title: (<span className='test'>  Location </span>),
        dataIndex: 'location',
        key: 'location',
        className: 'min-width-100',
        render: (_, record) => (
          <span>{record?.location || '-'}</span>
        )
        // render: (_, record) => {
        //   record && record.awbs_in && record?.locations &&
        //     record?.locations.map((loc, index) => {

        //       return <div key={index}>{loc?.fromLocation}</div>
        //     }) 
        // }
      },
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        className: 'space-nowrap',
        render: (_, record) => (
          // <span className={record?.showred ? 'bg-red' : null}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
          <span className={this.mismatchPcs(record?.pcs, record)}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
        )
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
      },
      {
        title: (<span className='test'>  GrWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          if (this.state.editWgtUnit === 'KG') {
            let kg = this.updateWeightVal('KG', record?.wgt)
            return <span>{Math.round(kg) !== 0 ? Math.round(kg) : Math.round(record?.wgt * 10) / 10} kG</span>
          }
          else {
            return <span>{Math.round(record?.wgt)} LB</span>
          }
        }
      },
      // {
      //   title: (<span className='test'>  ChblWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
      //   dataIndex: 'ch_wgt',
      //   key: 'ch_wgt',
      //   render: (_, record) => {
      //     if (this.state.editWgtUnit === 'KG') {
      //       let kg = this.updateWeightVal('KG', record?.ch_wgt)
      //       return <span>{Math.round(kg)} kG</span>
      //     }
      //     else {
      //       return <span>{Math.round(record?.ch_wgt)} LB</span>
      //     }
      //   }
      // },
      {
        title: (<span className='test'>  Vol.({this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'}) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          if (this.state.editWgtUnit === 'LB') {
            let cbf = record?.vol > 0 ? this.updateVolumeVal('CBF', record?.vol) : 0
            return <span>{Math.round(cbf * 10) / 10}</span>
          } else {
            return <span>{Math.round(record?.vol * 10) / 10}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pri # </span>),
        dataIndex: 'pri',
        key: 'pri',
      },
      {
        title: (<span className='test'>  Dest </span>),
        dataIndex: 'dest',
        key: 'dest',
        render: (_, record) => (
          <span>{record?.dest}</span>
        )
      },
      {
        title: (<span className='test'>  Prod </span>),
        dataIndex: 'prod',
        key: 'prod',
        render: (_, record) => (
          <span>{record?.prod_code}</span>
        )
      },
      {
        title: (<span className='test'>  SPL </span>),
        dataIndex: 'spl',
        key: 'spl',
        className: 'min-width-100',
        render: (_, record) => (
          this.renderSplCodes(record?.spl_code)
        )
      },
      {
        title: (<span className='test'>  Pre-Built? </span>),
        dataIndex: 'preBuilt',
        key: 'preBuilt',
        align: 'center',
        render: (_, record) => (
          <span>{record?.pre_build ? 'Y' : 'N'}</span>
        )
      },
      {
        title: (<span className='test'>  On Hand? </span>),
        dataIndex: 'onHand',
        key: 'onHand',
        align: 'center',
        render: (_, record) => (
          <span>{record?.on_hand ? 'Y' : 'N'}</span>
        )
      },
    ]

    const getCurrentPlan = () => {
      const { activeTab, editRecord } = this.state
      if (activeTab === 'initial') {
        return editRecord?.init_build_plan?.data?.build_plan
      } else if (activeTab === 'final') {
        return editRecord?.final_build_plan?.data?.build_plan
      } else {
        return editRecord?.build_plan || []
      }
    }
    
    const renderTabContent = () => (
      <div className='opti-input'>
        <Row gutter={[0, 0]}>
          <Col xs={24} className='switch print-uld'>
            <div className='awb-switch print-uld'>
              <Space align='start' className='f-spaceBtw'>
                <Title level={5} className='mb-0' xs={12}>
                  ULD Optimization
                </Title>
                <div className='awb-switch ml-5 print-uld'>
                  <Switch
                    checkedChildren='AWBs'
                    unCheckedChildren='ULDs'
                    checked={this.state.switch}
                    onChange={(e) => this.setState({ switch: e })}
                  // className='awb-switch'
                  />
                </div>
                {!this.props.info && (
                  <Upload
                    accept='.xlsx,.xls'
                    showUploadList={false}
                    beforeUpload={(file) => {
                      const formData = new FormData()
                      formData.append('file', file)
                      formData.append('stn', this.state.station)
                
                      http.post(
                        '/upload_icargo_awb/'+this.state.editRecord?.id,
                        formData,
                        {
                          headers: {
                            'Content-Type': 'multipart/form-data',
                            'station': this.state.station
                          }
                        }
                      ).then(({ data }) => {
                        if (data && data?.status === 'success') {
                          notification.destroy()
                          notification.success({
                            message: 'Success',
                            description: data?.message,
                          })
                        } else {
                          notification.destroy()
                          notification.error({
                            message: 'Failed',
                            description: data?.message,
                          })
                        }
                      }).catch((err) => {
                        notification.destroy()
                        notification.error({
                          message: 'Failed',
                          description: err?.toString() || 'Something went wrong',
                        })
                      })
                      return false // prevent default upload
                    }}
                  >
                    <Button type='link' className='link-btn-dod uld-upload' icon={<UploadOutlined style={{ fontSize: 16 }} />}>Upload AWBs from iCargo</Button>
                  </Upload>
                )}
              </Space>
            </div>
            <div className='ml-auto print-uld'>
              <div className='goal'>
                <p>Chbl Wgt Goal: {this.state.chblWgtGoal ? <b className='goal-wgt'> {this.state.editWgtUnit === 'KG' ? Math.round(this.state.chblWgtGoal.kg) : Math.round(this.state.chblWgtGoal.lbs)} {this.state.editWgtUnit}</b> : <b className='goal-wgt'>N/A</b>}</p>
              </div>
            </div>
          </Col>
          {!this.props.info && <Col xs={24}>
            <div className='print-uld'>
              <Row gutter={[24, 16]} className='add-uld-block'>
                <Col xs={24} sm={24} md={12} lg={6} xxl={4} className='uld-section-item'>
                  <label htmlFor='uld_type'>ULD Type</label>
                  <Select
                    id='uld_type'
                    value={this.state.optiUld?.type}
                    size='small'
                    name='type'
                    className='text-center w-100'
                    onChange={(e) => this.handleOptiUldChange({
                      target: {
                        name: 'type',
                        value: e
                      }
                    })}
                    disabled={this.state.activeTab !== 'bp'}
                  >
                    {const_ulds?.map((c_u, index) => <Option key={index} value={c_u}>{c_u}</Option>)}
                  </Select>
                </Col>
                <Col xs={24} sm={24} md={12} lg={6} xxl={4} className='uld-section-item'>
                  <label htmlFor='uld_no'>ULD Number (Optional)</label>
                  <Input
                    id='uld_no'
                    name='uld_no'
                    value={this.state.optiUld?.uld_no}
                    onChange={this.handleOptiUldChange}
                    disabled={this.state.activeTab !== 'bp'}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={7} xxl={5} className='uld-section-item'>
                  <div className='f-spacebtw'>
                    <label htmlFor='pallet_stack_count' className='mb-0'>Number of Pallets in Stack</label>
                    <Checkbox
                      name='pallet_stack'
                      checked={this.state.optiUld?.pallet_stack}
                      onChange={(e) => this.handleOptiUldChange({
                        target: {
                          name: 'pallet_stack',
                          value: e.target.checked
                        }
                      })}
                      disabled={this.state.activeTab !== 'bp'}
                    >Pallet Stack?</Checkbox>
                  </div>
                  <Input
                    id='pallet_stack_count'
                    name='pallet_stack_count'
                    value={this.state.optiUld?.pallet_stack_count}
                    onChange={this.handleOptiUldChange}
                    disabled={!this.state.optiUld?.pallet_stack || this.state.activeTab !== 'bp'}
                  />
                </Col>
                <Col flex='none' className='text-center p-0 uld-btn-container uld-section-item'>
                  <Tooltip title='Add ULD' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                    <span>
                      <Button type='ghost' className='image-btn'
                        disabled={this.state.activeTab !== 'bp'}
                        onClick={() => this.addOptiData()}>
                        <img src={addIcon} alt='add' />
                      </Button>
                    </span>
                  </Tooltip>
                </Col>
              </Row>
            </div>
          </Col>}
          {this.state.switch &&
            <Col flex='auto' className='awb-btn-container '>
              <Space size={'large'} align='start' className='ml-auto'>
                <Search allowClear className='search-input' placeholder='AWB Search'
                  onChange={(e) => this.setState({ awbSearch: e.target.value })}
                />
                {!this.props.info && <Button type='link' className='add-btn' title='Add AWB' icon={<img src={addIcon} alt='add' />} disabled={this.state.activeTab !== 'bp'} onClick={() => this.addAwb()} />}
              </Space>
            </Col>}
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
            <div className='table-outer buildplan-table-outer print-uld'>
              {this.state.switch ?
                <>
                  <Table
                    className='buildplan-table'
                    bordered
                    // className='custom-table w-100 ex-tabl buildup-table dod-bp-table bp-awb-table'
                    dataSource={this.state.activeTab === 'initial' ?
                      this.state.initmergeEditRecord?.sort(awbSortFunction)?.filter(awb => {
                        if (this.state.awbSearch != '') {
                          return awb.awb_no.includes(this.state.awbSearch.replace(/-/, ''))
                        } else {
                          return true
                        }
                      }) || []
                      : this.state.activeTab === 'final' ?
                        this.state.finalmergeEditRecord?.sort(awbSortFunction)?.filter(awb => {
                          if (this.state.awbSearch != '') {
                            return awb.awb_no.includes(this.state.awbSearch.replace(/-/, ''))
                          } else {
                            return true
                          }
                        }) || []
                        :
                        this.state.mergeEditRecord?.sort(awbSortFunction)?.filter(awb => {
                          if (this.state.awbSearch != '') {
                            return awb.awb_no.includes(this.state.awbSearch.replace(/-/, ''))
                          } else {
                            return true
                          }
                        }) || []}
                    columns={awbColumns}
                    pagination={false}
                    rowClassName={(record) => record.is_deleted ? 'strike-row' : ''}
                  />
                </> :
                <Table
                  className='buildplan-table'
                  bordered
                  // className='custom-table w-100 ex-tabl buildup-table bp-uld-table'
                  dataSource={[
                    ...(this.state.activeTab === 'initial'
                      ? this.state.editRecord?.init_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                      : this.state.activeTab === 'final'
                        ? this.state.editRecord?.final_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                        : this.state.editRecord?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                    ),
                    ...(
                      this.state.editRecord?.ulds_out?.filter(u => {
                        if (u.info?.remark?.includes('SLU')) {
                          return {
                            id: u.id,
                            type: u.uld_no,
                            slu: true
                          }
                        }
                      }) || []
                    ),
                    {
                      id: 0,
                      type: 'BULK'
                    } || []
                  ]}
                  columns={optiColumns}
                  pagination={false}
                  expandable={{
                    // rowExpandable: () => {
                    //   this.state.activeTab === 'initial' ? (this.state.editRecord?.init_build_plan?.data?.build_plan?.length > 0) :
                    //     this.state.activeTab === 'final' ? (this.state.editRecord?.final_build_plan?.data?.build_plan?.length > 0) :
                    //       true
                    // },
                    expandedRowRender: (record) => <Table
                      className='buildplan-table builplan-expanded-table'
                      bordered
                      // className='custom-table w-100 ex-tabl buildup-table nested'
                      // dataSource={this.showAwbs(record, this.state.editRecord?.build_plan || [])}
                      dataSource={this.showAwbs(record, getCurrentPlan() || [])}
                      columns={nestedAwbColumns}
                      pagination={false}
                    // rowKey={this.state.editRecord.id}
                    />,
                    expandIcon: ({ expanded, onExpand, record }) =>
                      expanded ?
                        <CaretDownOutlined onClick={e => onExpand(record, e)} />
                        :
                        <CaretRightOutlined onClick={e => onExpand(record, e)} />,
                  }}
                  rowKey='id'
                />
              }
            </div>

            {/* {JSON.stringify(this.state.mergeEditRecord)} */}
          </Col>
          {!this.props.info && <Col xs={24} className='text-right mt-2 print-uld'>
            <Space size={'middle'}>
              <Checkbox checked={this.state.priority} disabled={this.state.activeTab !== 'bp'} onChange={(e) => this.setState({ priority: e.target.checked })}>Include Delay Days & Booking Priority</Checkbox>
              <Button
                type='primary'
                className='custom-button bp-button'
                disabled={this.state.activeTab !== 'bp' || !this.state.switch}
                onClick={() => { this.handleLockAndScreenshot() }} >
                {this.state.optiLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Lock Build Plan'}
              </Button>
              {this.state.editRecord?.init_build_plan || this.state.editRecord?.final_build_plan ?
                <Popover content={
                  <div>
                    <p>Last Updated By: {
                      this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.last_name :
                        this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.last_name : 'N/A'
                    }</p>
                    <p>PPR#: {this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.ppr
                      : this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.ppr : 'N/A'}</p>
                  </div>
                }><InfoCircleFilled /></Popover> : null}
              <Button type='primary' className='custom-button' disabled={this.state.activeTab !== 'bp'} onClick={() => this.autoAssignUlds()}>
                {this.state.assignLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Auto-Assign ULDs'}
              </Button>
              <Space.Compact block>
                {/* <Button
                      type='primary'
                      className='custom-button bp-button opti-btn'
                      disabled={this.state.activeTab !== 'bp'}
                      onClick={() => this.opti()}>
                      {this.state.optiLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Run Optimization'}
                    </Button> */}
                <Tooltip title='Clear Build Plan' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <Button className='bp-icon-btn del-icon-btn'
                    type='primary'
                    disabled={this.state.activeTab !== 'bp'}
                    onClick={() => this.opti_clear()}
                    icon={this.state.clearLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> :
                      <img src={deleteIcon} alt='delete' />}
                  />
                </Tooltip>
              </Space.Compact>
            </Space>
          </Col>}
        </Row>
      </div>
    )

    const getRemaingWgt = (flightDetails) => {
      // {Math.round(['K', 'KGM', 'KG', 'KGS'].includes(this.state.flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', this.state.flightDetails?.wgt?.value) : this.state.flightDetails?.wgt?.value - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.wgt || 0) - this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0))}
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      let build_wgt = this.state.editWgtUnit === 'LB' ? (this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_wgt || 0) : this.updateWeightVal('KG', this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_wgt || 0)
      let assigned_wgt = this.state.editWgtUnit === 'LB' ? this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0) : this.updateWeightVal('KG', this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0))
      return Math.round(actual_wgt - (build_wgt || 0) - (assigned_wgt || 0)) != 0 ? Math.round(actual_wgt - (build_wgt || 0) - (assigned_wgt || 0)) : Math.round((actual_wgt - (build_wgt || 0) - (assigned_wgt || 0)) * 10) / 10
    }
    
    const getRemaingVol = (flightDetails) => {
      // Math.round((((this.state.flightDetails?.vol?.unit === 'CBF' || this.state.flightDetails?.vol?.unit === 'CFT') ? this.updateVolumeVal('CBM', this.state.flightDetails?.vol?.value) : this.state.flightDetails?.vol?.value) - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.vol || 0) - this.state.assignedUldsData?.map(item => item.vol).reduce((prev, curr) => Number(prev) + Number(curr), 0)) * 10) / 10
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      let build_vol = this.state.editWgtUnit === 'KG' ? (this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_vol || 0) : volumnCalculator(this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_vol || 0, 'CBM')
      let assigned_vol = this.state.editWgtUnit === 'KG' ? this.state.assignedUldsData?.map(item => item.vol).reduce((prev, curr) => Number(prev) + Number(curr), 0) : this.state.assignedUldsData?.map(item => volumnCalculator(item.vol, 'CBM')).reduce((prev, curr) => Number(prev) + Number(curr), 0)
      actual_vol = actual_vol - build_vol - assigned_vol
      return Math.round(actual_vol * 10) / 10
    }
    const CardAwbColumns = [
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        className: 'space-nowrap',
        render: (_, record) => (
          // <span className={record?.showred ? 'bg-red' : null}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
          <span className={this.mismatchPcs(record?.pcs, record)}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
        )
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
        render: (_, record) => (
          record?.uld_id === this.state.editUlds?.uld_id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editUlds?.pcs || ''}
              name='pcs'
              onChange={(e) => this.handleEditUldChange(e)}
            />
            : <span>{record?.pcs}</span>
        )
      },
      {
        title: (<span className='test'>GrWt.({this.state?.flightDetails?.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        // title: (<span className='test'>  GrWt.(lbs) </span>),
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          if (record?.uld_id === this.state.editUlds?.uld_id) {
            return <Input
              size='small'
              placeholder=''
              value={this.state.editUlds?.wgt || ''}
              name='wgt'
              onChange={(e) => this.handleEditUldChange(e)}
            />
          } else {
            let weight = this.state.editWgtUnit === 'KG' ? this.updateWeightVal('KG', record?.wgt) : record?.wgt
            return <span>{Math.round(weight) !== 0 ? Math.round(weight) : Math.round(record?.wgt * 10) / 10}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Vol.({this.state?.flightDetails?.editWgtUnit === 'KG' ? 'cbm' : 'cbf'}) </span>),
        // title: (<span className='test'>  Vol.(cbm) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          if (record?.uld_id === this.state.editUlds?.uld_id)
            return <Input
              size='small'
              placeholder=''
              value={this.state.editUlds?.vol || ''}
              name='vol'
              onChange={(e) => this.handleEditUldChange(e)}
            />
          else {
            let vol = this.state.editWgtUnit === 'KG' ? (Math.round(record?.vol * 10) / 10) : Math.round(volumnCalculator(record?.vol, 'CBM'))
            return <span>{vol}</span>
          }
        }
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (record) =>
          this.state.flightDetails.awb_no == record?.awb_no && <div>
            {record?.uld_id === this.state.editUlds?.uld_id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.updateUlds()} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearTableForm()} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editUlds(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.deleteUlds(record)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      }
    ]
    

    return (
      <div>
        {this.state.optimalBuild && this.searchModal()}
        {(this.state.openPlanner) && <WeightAndBalance
          onWandbImageReady={this.props.handleAuditScreenshotUpload}
          wgt_unit={this.state.editWgtUnit}
          openWB={this.openWB}
          openPlanner={this.state.openPlanner}
          // openWnbPlanner={this.state.openWnbPlanner}
          disableInputs={this.props.info || false}
          editRecordId={this.state.wbRecord?.id}
          editRecord={this.state.wbRecord}
        />
        }
        <Modal
          title={
            <>
              <div className='mb-2'>Assign to ULD</div>
              <Row gitter={[12, 12]}>
                <Col xs={6} className='awb-block'>
                  <span className='awb-block-label mr-2'>AWB:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.awb_no}</span>
                </Col>
        
                <Col xs={4} className='awb-block'>
                  <span className='awb-block-label mr-2'>Org:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.org}</span>
                </Col>
                <Col xs={4} className='awb-block'>
                  <span className='awb-block-label mr-2'>Dest:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.dest}</span>
                </Col>
              </Row>
            </>
          }
          open={this.state.addULD}
          closable={true}
          onCancel={() => {
            this.setState({
              addULD: false,
              assignUld: {}
            })
            // reset form fields when modal is closed
            this.assignUldFormRef.current?.resetFields(['pcs', 'wgt', 'vol'])
          }}
          footer={false}
          width={'50%'}
          centered
          className='custom-modal pb-0'
          zIndex={1001}
        >
          {/* // assignuld */}
          <div className='awb-section'>
            <p className='remaining-awb-title'>Remaining AWB</p>
            <Row gutter={[{
              xs: 12,
              sm: 12,
              md: 24,
              lg: 24
            }, {
              xs: 12,
              sm: 12,
              md: 24,
              lg: 24
            },]} >
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Pieces </p>
                  <p className='awb-card-data mb-0'>{this.state.flightDetails?.pcs - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.blk || 0) - this.state.assignedUldsData?.map(item => item.pcs).reduce((prev, curr) => Number(prev) + Number(curr), 0)}</p>
                </div>
              </Col>
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Weight {this.state?.editWgtUnit === 'KG' ? '(KG)' : '(LB)'} </p>
                  <p className='awb-card-data mb-0'>{getRemaingWgt(this.state.flightDetails)}</p>
                </div>
              </Col>
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Volume {this.state?.editWgtUnit === 'KG' ? '(CBM)' : '(CBF)'} </p>
                  <p className='awb-card-data mb-0'>{getRemaingVol(this.state.flightDetails)}</p>
                </div>
              </Col>
            </Row>
          </div>
          <Row className='select-uld-wrapper'>
            <Col xs={24} className='mb-2'>
              <p className='remaining-awb-title'>Select ULD to assign AWB</p>
            </Col>
            <Col xs={24} className=''>
              <div className='uld-tab-wrapper'>
                {(() => {
                  let yellow_flag = false
                  let bpIndex = this.state.editRecord?.build_plan?.findIndex(item => item.awb_no === this.state.flightDetails?.awb_no)
                  if (bpIndex > -1) {
                    if (this.state.editRecord?.build_plan[bpIndex]?.data.blk > 0) {
                      yellow_flag = true
                    }
                  }
        
                  return <div key={99} className={`tabs uld-tabs tab-indicator ${this.state.assignUld?.id == 0 ? 'active-tab' : ''} ${yellow_flag ? 'yellow-star' : ''}`} onClick={() => this.handleAssignUldChange({
                    target: {
                      name: 'id',
                      value: 0,
                    }
                  })}>
                    <span>BULK</span>
                  </div>
                })()}
                {this.state.editRecord?.build_uld?.map((option, i) => {
                  let yellow_flag = false
                  let wgt = 0
                  let org_dest = this.state.editRecord?.org_stn + this.state.editRecord?.dest_stn
                  let goal = ch_wt_goals.find((item) => item.lane == org_dest) || {
                    lane: org_dest,
                    kg: 500,
                    lbs: 1100
                  }
                  if (this.state.editRecord && this.state.editRecord?.build_plan && this.state.editRecord?.build_plan?.length > 0) {
                    this.state.editRecord?.build_plan?.map((item) => {
                      if (item?.ulds && item?.ulds?.length > 0) {
                        item?.ulds?.map((uld) => {
                          if (uld.id && uld.id == option.id) {
                            wgt = wgt + (uld?.ch_wgt || 0)
                            if (item.awb_no == this.state.flightDetails?.awb_no) {
                              if (uld.id == option.id) {
                                yellow_flag = true
                              }
                            }
                          }
                        })
                      }
                    })
                  }
                  let classname = ''
                  if (wgt) {
                    if (goal) {
                      if (parseFloat(goal?.lbs) <= (wgt / option?.data?.ld3)) {
                        classname = 'green-tab'
                      } else {
                        classname = 'red-tab'
                      }
                    }
                  }
        
                  return <div key={i} className={`tabs uld-tabs tab-indicator ${this.state.assignUld?.id == option.id ? 'active-tab' : ''} ${classname} ${yellow_flag ? 'yellow-star' : ''}`} onClick={() => this.handleAssignUldChange({
                    target: {
                      name: 'id',
                      value: option.id
                    }
                  })}>
                    <span>{option.type + ' ' + (option.uld_no || '')}</span>
                  </div>
                })}
              </div>
            </Col>
            {this.state.assignUld?.id > -1 && this.state.editWgtUnit &&
                      <Col xs={24} className=''>
                        <div className='table-outer'>
                          <Table
                            className='custom-table w-100 ex-tabl buildup-table'
                            dataSource={this.showAwbs(this.state.assignUld?.id == 0 ? {
                              id: 0,
                              type: 'BULK'
                            } : this.state.editRecord?.build_uld?.find(uld => uld.id === this.state.assignUld.id), this.state.editRecord?.build_plan || [])}
                            columns={CardAwbColumns}
                            summary={(record) => {
                              let data = this.showAwbs(this.state.assignUld?.id == 0 ? {
                                id: 0,
                                type: 'BULK'
                              } : this.state.editRecord?.build_uld?.find(uld => uld.id === this.state.assignUld.id), this.state.editRecord?.build_plan || [])
        
                              let wgt = 0
                              let vol = 0
                              data.map(item => {
                                wgt += Number(this.state.editWgtUnit === 'KG' ? this.updateWeightVal('KG', item?.wgt) : item?.wgt)
                                vol += Number(this.state.editWgtUnit === 'KG' ? item?.vol : volumnCalculator(item?.vol, 'CBM'))
                              })
        
                              return record.length > 0 && <Table.Summary fixed>
                                <Table.Summary.Row>
                                  <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                                  <Table.Summary.Cell index={1}>{data.map(item => item.pcs).reduce((prev, curr) => Number(prev) + Number(curr), 0)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={2}>{Math.round(wgt)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={3}>{this.state.editWgtUnit === 'KG' ? (Math.round(vol * 10) / 10) : Math.round(vol)}</Table.Summary.Cell>
                                  <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                </Table.Summary.Row>
                              </Table.Summary>
                            }}
                            pagination={false}
                            // rowKey={this.state.editRecord.id}
                          />
                        </div>
                      </Col>
            }
          </Row>
          <Row gutter={[{
            xs: 0,
            sm: 0,
            md: 8,
            lg: 8
          }, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8
          },]} className='with-table'>
            <Col xs={24} className='mt-4'>
              <p className='remaining-awb-title'>Assign AWB Details</p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
              <Form
                ref={this.assignUldFormRef}
                layout='vertical'
                className='position-relative'
                onFinish={() => this.submitAssignUld()}
              >
                <Row
                  gutter={[{
                    xs: 24,
                    sm: 24,
                    md: 24,
                    lg: 24
                  }, {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 0
                  },]} >
                  {/* <Col xs={24} sm={24} md={24} lg={6} xl={4} xxl={4} className=''>
                            <Form.Item label='Uld No.'>
                              <Select
                                size='small'
                                className='w-60'
                                value={this.state.assignUld.uld_no}
                                onChange={(e) => this.handleAssignUldChange({
                                  target:{
                                    name: 'uld_no',
                                    value: e
                                  } 
                                })}
                                // popupClassName='mcq-popup other-popup'
                              >
                                {this.state.editRecord?.build_uld?.map((option, index) => <Option key={index} value={option.uld_no}>{option.uld_no}</Option>)}
                              </Select>
                            </Form.Item>
                          </Col> */}
                  <Col xs={24} sm={24} md={12} lg={7} xl={7} className=''>
                    <Form.Item
                      label='Awb Pcs'
                      name='pcs'
                      rules={[{
                        required: true,
                        message: 'Please enter pieces'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='pcs'
                        value={this.state.assignUld?.pcs}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={6} xl={4} xxl={4} className=''>
                            <Form.Item label='Remarks/Pri#'>
                              <Input
                                size='small'
                                placeholder=''
                                name='remark'
                                value={this.state.assignUld.remark}
                                onChange={(e) => this.handleAssignUldChange(e)}
        
                              />
                            </Form.Item>
                          </Col> */}
                  <Col xs={24} sm={24} md={12} lg={6} xl={6} className=''>
                    <Form.Item
                      label={`Est. GrWt(${this.state?.editWgtUnit === 'KG' ? 'kg' : 'lbs'})`}
                      // name='wgt'
                      rules={[{
                        required: true,
                        message: 'Please enter weight'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='wgt'
                        value={this.state.assignUld?.wgt}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={6} xl={6} className=''>
                    <Form.Item
                      label={`Est. GrVol(${this.state?.editWgtUnit === 'KG' ? 'cbm' : 'cbf'})`}
                      // name='vol'
                      rules={[{
                        required: true,
                        message: 'Please enter volume'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='vol'
                        value={this.state.assignUld?.vol}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col flex='none' className='text-center ml-auto pl-0 assign-uld-btn-col'>
                    <Space size='middle'>
                      <Button type='primary' htmlType='submit' className='ml-auto custom-button'>
                                Add
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={
            <Row>
              <Col xs={24} md={6} className='my-auto'>
                <span className='print-uld'>Build Plan</span>
                {/* Title displayed on print */}
                <div className='print-uld-show'>
                  <div className='f-spacebtw'>
                    <span>Build Plan -{this.state.editRecord ? `${this.state.editRecord?.flight_no} / ${this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly) : ''}` : ''}</span>
                    <Space>
                      <Text>Last Updated by: {
                        this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.last_name :
                          this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.last_name : 'N/A'
                      }</Text>
                      <Text>PPR#:{this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.ppr
                        : this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.ppr : 'N/A'}</Text>
                    </Space>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={18}>
                <div className='print-uld'>
                  <div className='ml-auto d-flex'>
                    <Space size={'middle'} className='ml-auto'>
                      {/* <Button type='primary' disabled className='custom-button bp-button'>Run Optimization </Button> */}
                      <Button
                        type='link'
                        className='link-btn-dod'
                        icon={<img src={RedirectIcon} alt='redirect' width={14} />}
                        onClick={() => window.open('https://apps.powerapps.com/play/e/f7a9917a-c0f8-e704-b911-cd160be3bc02/a/025d57e5-a3f3-435f-906b-e392ab115a95?tenantId=45e6435d-dc1c-42e3-89be-e72e6c8f072d&sourcetime=1716317814249&source=portal&hidenavbar=true', '_blank')}
                      >
                        Dimension Check Tool
                      </Button>
                      {!this.props.info && <Button type='primary' className='custom-button mr-5 bp-button' onClick={() => this.openWB(true, this.state.editRecord)}
                      >WB Planner </Button>}
                      {/* <Button type='primary' className='custom-button mr-0 bp-button' onClick={() => this.openTruckPlanner(true)}
                      disabled={(ENV === 'stage' || ENV === 'production') && !users.includes(cookies.get('username'))}>Truck Planner </Button> */}
                    </Space>
                  </div>
                </div>
              </Col>
            </Row>
          }
          open={this.props.modal}
          onOk={() => this.setState({
            loadplanvisible: false,
            showAlloc: false,
            ccView: false,
            SLUSummary: [],
            PTUSummary: [],
            BuiltSummary: [],
            BLKSummary: null,
            selected: [],
            bagSummary: [],
            remainingP96: 0,
            remainingP88: 0,
            remainingLD3: 0,
            remainingLD2: 0,
            remainingMD: 0,
          }, () => {
            this.clearEditAllocForm()
            this.clearAllocTableForm()
          })}
          onCancel={() => {
            this.props.closeModal()
            // empty the state when modal is closed
            this.setState({
              loadplanvisible: false,
              showAlloc: false,
              ccView: false,
              SLUSummary: [],
              PTUSummary: [],
              BuiltSummary: [],
              BLKSummary: null,
              selected: [],
              bagSummary: [],
              remainingP96: 0,
              remainingP88: 0,
              remainingLD3: 0,
              remainingLD2: 0,
              remainingMD: 0,
            }, () => {
              this.clearEditAllocForm()
              this.clearAllocTableForm()
            })
          }}
          closable={true}
          footer={[
            <>
              <div className='print-uld'>
                <Space.Compact block className='bp-footer'>
                  {!this.props.info && <Button
                    onClick={this.emailLoadPlan}
                    type='primary'
                    className='custom-button bp-button'
                  >Send Email
                  </Button>}
                  <Tooltip title='View Email History' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                    <Button className='bp-icon-btn email-history-btn'
                      disabled={!this.state.emailLogs.length > 0}
                      onClick={this.openBuildPlanDrawer}
                      icon={<span className='compact-history-icon'> H </span>}
                    />
                  </Tooltip>
                </Space.Compact>
              </div>
            </>
          ]}
          width={'100%'}
          centered
          className='custom-modal pb-0 load-plan dod-bp-modal'
        >
          {this.state.modalLoading && (<div id='spinner' className='spinner-cont'>
            <Spin />
          </div>)}
          <Row gutter={[{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24
          }, {
            xs: 24,
            sm: 24,
            md: 32,
            lg: 32
          },]} className='with-table print-uld'
          // ref={this.modalRef}
          ref={this.modalContentRef}
          >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={14} className=''>
              <div className='cargo-cap-card bp print-uld'>
                <Row gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                }, {
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                },]}
                >
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Fight #</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.flight_no || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Date</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}</p>
                    </div>
                  </Col>
                  <Col flex='auto' className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>AC</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.ac_change?.length > 0 ?
                        <Popover
                          onVisibleChange={(e) => this.setState({ flightACVisible: e })}
                          placement='top'
                          content={() => this.showACHistory(this.state.editRecord?.ac_change)}
                          // title=''
                          trigger='click'
                          overlayClassName='status-popover'
                        // getPopupContainer={trigger => trigger.parentNode}
                        >
                          <Space>
                            <span className={this.state.editRecord?.ac_change && this.state.editRecord?.ac_change.length > 0 ? 'red-ac' : null}>
                              {this.state.editRecord?.ac_type ? this.state.editRecord.ac_type : 'N/A'}</span>
                          </Space>
                        </Popover> :
                        <Space>
                          <span className={this.state.editRecord?.ac_change && this.state.editRecord?.ac_change.length > 0 ? 'red-ac' : null}>
                            {this.state.editRecord?.ac_type ? this.state.editRecord.ac_type : 'N/A'}</span>
                        </Space>}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Seg</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={5} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Dept Time</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.dept_time && `${this.state.editRecord?.dept_prefix} ${moment.tz(this.state.editRecord.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>AWB Count</small>
                      <p className='info-data mb-2'>{this.state.mergeEditRecord?.sort(awbSortFunction)?.length || 0}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Ship #</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.editRecord?.wgt_bal_plan?.ship || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>FPE Time</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('HH:mm') : '-'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Plan Due</small>
                      <p className='info-data mb-2 space-nowrap'>
                        {this.props.milestoneData && this.props.milestoneData.length > 0 ? (
                          (() => {
                            let planDue = this.props.milestoneData.find(
                              (item) => item?.type === 'Dod' && item.title === 'Build Plan Submitted to Warehouse'
                            )
                            if (planDue) {
                              const cutoffTime = this.state.editRecord?.dept_date ? moment
                                .utc(this.state.editRecord?.dept_date)
                                .tz(this.state.timezone)
                                .subtract(this.getCutoff(planDue.cutoff, this.state.editRecord), 'hours') : null
                              return `SKD ${cutoffTime?.format('HH:mm')}`

                            } else {
                              return '-'
                            }
                          })()
                        ) : (
                          '-'
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={5} className='flight-info-text'>
                    <div className='sub-head'>
                      <div><small className='info-title'>Bag Pstns</small></div>
                      <Space size='middle'>
                        <div className=''>
                          <small className='info-title'>LD3</small>
                          <InputNumber
                            className='bp-info-ip'
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editBagLD3 || 0}
                            onChange={(e) => this.handleBagInputChange('editBagLD3', e)}
                            // onBlur={this.handleBagInputBlur}
                            disabled={!this.state.editRecord?.cont_type?.includes('LD3') || this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody || this.props.info}
                          />
                        </div>
                        <div className=''>
                          <small className='info-title'>LD2</small>
                          <InputNumber
                            className='bp-info-ip'
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editBagLD2 || 0}
                            onChange={(e) => this.handleBagInputChange('editBagLD2', e)}
                            // onBlur={this.handleBagInputBlur}
                            disabled={!this.state.editRecord?.cont_type?.includes('LD2') || this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody || this.props.info}
                          />
                        </div>
                        <Button
                          className='custom-icon-button mt-4 disabled-bg-none'
                          ghost
                          icon={<SearchOutlined />}
                          onClick={() => this.fetchFlightSummary()}
                          disabled={this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody || this.props.info}
                        />
                      </Space>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={5} className='flight-info-text'>
                    <div className='h-100'><small className='info-title'>PAX CAP / FCST</small>
                      <Space size='middle' direction='horizontal' className='mt-auto h-100'>
                        <p className='info-data text-right'>{this.state.editRecord?.pax_cap || 0} </p>
                        <span className='color-white'>/</span>
                        {<InputNumber
                          min={0}
                          precision={0}
                          controls={false}
                          size='small'
                          placeholder=''
                          value={this.state.editFcst || 0}
                          // onChange={(e) => this.setState({ editFcst: e })}
                          onChange={(e) => this.handleBagInputChange('editFcst', e)}
                          // onBlur={this.handleBagInputBlur}
                          disabled={this.disableNote(this.state.editRecord?.dept_time) || this.props.info}
                          className='bp-info-ip'
                        />}
                      </Space>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={3} xxl={4} className='sub-head flight-info-text'>
                    <small className='info-title space-nowrap'>Cargo Payload</small>
                    <div className=''>
                      <div className='weight-toggle'>
                        <Switch
                          checkedChildren='LB'
                          unCheckedChildren='KG'
                          size='small'
                          className='mx-1'
                          checked={this.state.editWgtUnit === 'KG' ? false : true}
                          onChange={((e) => this.setState({
                            editWgtUnit: e === false ? 'KG' : 'LB',
                            editWgtValue: this.updateWeightVal(e === false ? 'KG' : 'LB', this.state.editWgtValue)
                          }))}
                          disabled={this.props.info}
                        />
                      </div>
                      <div className='mt-2'>
                        <InputNumber
                          min={0}
                          controls={false}
                          size='small'
                          placeholder=''
                          value={this.state.editWgtValue || 0}
                          // onChange={(e) => this.setState({ editWgtValue: e })}
                          onChange={(e) => this.handleBagInputChange('editWgtValue', e)}
                          // onBlur={this.handleBagInputBlur}
                          disabled={this.disableNote(this.state.editRecord?.dept_time) || this.props.info}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title '>BU PRIO</small>
                      <Checkbox
                        className='light-checkbox mx-auto'
                        checked={this.state.editBuPrio}
                        // onChange={(e) => this.setState({ editBuPrio: e.target.checked })}
                        onChange={(e) => this.handleBagInputChange('editBuPrio', e.target.checked)}
                        // onBlur={this.handleBagInputBlur}
                        disabled={this.disableNote(this.state.editRecord?.dept_time) || this.props.info}
                      />
                    </div>
                  </Col>
                </Row>
                {this.state.showSaveIcon && (
                  <div className='auto-save-wrapper'>
                    <Spin indicator={<LoadingOutlined spin className='auto-save-icon' />} size='small' />
                    <Typography.Text italic className='auto-save-text pl-2'>Auto Saving...</Typography.Text>
                  </div>
                )}
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={10} className=''>
              <div className='print-uld h-100'>
                <Row className='opti-input h-100'>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                    <div className='table-outer print-uld'>
                      <Table
                        id='config-table'
                        className='custom-table w-100 checklist-table1'
                        // dataSource={this.processIndividualFlight([this.state.editRecord])}
                        // dataSource={[this.state.editRecord]}
                        dataSource={get_bin_config(false,this.state)?.slice(0, 2)}
                        columns={configColumns}
                        pagination={false}
                        rowClassName={(record, index) => index != 0 ? record.className : ''}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* <Col xs={24}>
                  <div className='opti-input'>
                    <Title level={5} className='' xs={12}>
                      Dry Ice
                    </Title>
                    <DryIce fleetType={this.state.editRecord?.fleet} ship_no={this.state.editRecord?.wgt_bal_plan?.ship} />
                  </div>
                </Col> */}

            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className='position-relative'>
              <Space align='center' className='download-doc-icon'>
                {/* <Tooltip title={'Builder Copy'}>
                      <Button className='download-icon-btn' icon={<FilePdfOutlined style={{
                        fontSize: '28px',
                        color: '#E02F2F',
                        backgroundColor: 'transparent'
                      }} />}
                      onClick={() => window.print()}
                      // onClick={this.generateLoadPlan}
                      />
                    </Tooltip> */}
                <Tooltip title={'Builder Copy'}>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  // onClick={() => window.print()}
                  onClick={this.generateLoadPlan}
                  />
                </Tooltip>
                {this.state.editRecord?.org_stn === 'LHR' && <Tooltip title={'LHR Builder Copy '}>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  // onClick={() => window.print()}
                  onClick={this.generateLoadPlanLHR}
                  />
                </Tooltip>}
                <Tooltip title='Scrub Copy'>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  onClick={this.exportScrub}
                  />
                </Tooltip>
              </Space>
              <Tabs
                activeKey={this.state.activeTab}
                onChange={this.callbackTabClicked}
                onEdit={this.onTabEdit}
                type='editable-card'
                hideAdd
                className='bp-tab position-relative'
              >
                <TabPane tab='Build Plan' key='bp' closable={false}>
                  {renderTabContent()}
                </TabPane>
                {this.state.editRecord?.init_build_plan &&
                  <TabPane tab='Proposed' key='initial' closable={!this.props.info}>{renderTabContent()}</TabPane>
                }
                {this.state.editRecord?.final_build_plan &&
                  <TabPane tab='Final' key='final' closable={!this.props.info}>{renderTabContent()}</TabPane>
                }
              </Tabs>
            </Col>
            {this.state.showAlloc && <>
              <Col xs={24} sm={24} md={24} lg={8} xl={12} className='opti-input'>
                <Title level={5} className='mb-0 print-uld'>Load Plan</Title>
              </Col>
              <Col xs={24} sm={24} md={24} lg={16} xl={12} className=''>
                <span className='rem-pos-title print-uld'>Remaining Positions: </span>
                <div className='d-flex f-wrap gap-10 rem_posn print-uld'>
                  <p className='fv-middle gap-10'>P96:
                    <InputNumber
                      size='small'
                      className={this.state.remainingP96 > 0 ? 'w-35px dis-blue' : this.state.remainingP96 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingP96 < 0 ? this.state.remainingP96?.toString()?.split('-')[1] : this.state.remainingP96 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>P88:
                    <InputNumber
                      size='small'
                      className={this.state.remainingP88 > 0 ? 'w-35px dis-blue' : this.state.remainingP88 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingP88 < 0 ? this.state.remainingP88?.toString()?.split('-')[1] : this.state.remainingP88 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>LD3:
                    <InputNumber
                      size='small'
                      className={this.state.remainingLD3 > 0 ? 'w-35px dis-blue' : this.state.remainingLD3 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingLD3 < 0 ? this.state.remainingLD3?.toString()?.split('-')[1] : this.state.remainingLD3 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>LD2:
                    <InputNumber
                      size='small'
                      className={this.state.remainingLD2 > 0 ? 'w-35px dis-blue' : this.state.remainingLD2 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingLD2 < 0 ? this.state.remainingLD2?.toString()?.split('-')[1] : this.state.remainingLD2 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>MD:
                    <InputNumber
                      size='small'
                      className={this.state.remainingMD > 0 ? 'w-35px dis-blue' : this.state.remainingMD < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingMD < 0 ? this.state.remainingMD?.toString()?.split('-')[1] : this.state.remainingMD || 0}
                      disabled
                    />
                  </p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className='px-0 p-12'>
                <div className='print-uld'>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]}
                      className='product-ht'>

                      <Col xs={24} sm={24} md={8} lg={6} xl={2} xxl={2} className=''>
                        <Form.Item label='# Of Posns'>
                          <InputNumber
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editPos || ''}
                            onChange={(e) => this.setState({ editPos: e })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={2} xxl={2} className=''>
                        <Form.Item label='Posn Type'>
                          <Select size='small'
                            placeholder='Select process'
                            className='w-100'
                            value={this.state.editType || []}
                            onChange={(e) => this.setState({ editType: e })}
                          >
                            <Option value='P96'>PMC</Option>
                            <Option value='P88'>PAG</Option>
                            <Option value='LD3'>LD3</Option>
                            <Option value='LD2'>LD2</Option>
                            <Option value='MD'>MD</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={4} xxl={3} className=''>
                        <Form.Item label='For Work Area'>
                          <Select size='small'
                            placeholder='Select process'
                            className='w-100'
                            value={this.state.editWorkArea || []}
                            onChange={(e) => this.setState({ editWorkArea: e })}
                          >
                            <Option value='International'>International</Option>
                            <Option value='Dash'>Dash</Option>
                            <Option value='Breezeway'>Breezeway</Option>
                            <Option value='T-Point'>T-Point</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={4} xxl={3} className=''>
                        <Form.Item label='ULD ID / AWB'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editULDAWB || ''}
                            onChange={(e) => this.setState({ editULDAWB: e.target.value?.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={3} xxl={3} className=''>
                        <Form.Item label='Prod'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editProd || []}
                            onChange={(e) => this.setState({ editProd: e.target.value?.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8} xl={4} xxl={5} className=''>
                        <Form.Item label='Planning Comments'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editComm1 || ''}
                            onChange={(e) => this.setState({ editComm1: e.target.value })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8} xl={4} xxl={5} className=''>
                        <Form.Item label='Post Departure Comments'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editComm2 || ''}
                            onChange={(e) => this.setState({ editComm2: e.target.value })}
                          />
                        </Form.Item>
                      </Col>

                      <Col flex='44px' className='text-center ml-auto p-0'>
                        <label className='custom-label transparent'>-</label>
                        <Button type='ghost' className='ml-auto image-btn' onClick={() => this.submit('add')}>
                          <Tooltip title={this.state.isEdit ? 'Update' : 'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                className='table-overflow'
              >
                <Table
                  className='custom-table w-100 no-header-table'
                  dataSource={this.state.editAllocArray}
                  columns={planLoadColumns}
                  pagination={false}
                />
              </Col>
            </>}
            <Col xs={24}>
              <div className='print-uld'>
                <Row className='opti-input last'>
                  <Col className='switch'>
                    <Title level={5} className='mb-0' xs={12}>
                      Load Planning Notes
                    </Title>
                    <div className='ml-auto'>
                      <Text type='secondary' strong>Last Update:</Text>
                      <Space size={[48, 0]} direction='horizontal'>
                        <Text strong>{this.state.lastUpdatedAt ? this.state.lastUpdatedAt + ' ' + this.state.ext : 'N/A'}</Text>
                        <Text strong>{this.state.lastUpdatedBy ? this.state.lastUpdatedBy : 'N/A'}</Text>
                        <Text strong>{this.state.lastUpdatedPpr ? this.state.lastUpdatedPpr : 'N/A'}</Text>
                      </Space>
                    </div>
                  </Col>
                  {!this.props.info && <Row className='mt-2'>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6} className='right-section'>
                      <label>Planning Comments</label>
                      <Input
                        disabled={this.disableNote(this.state.editRecord?.dept_time)}
                        size='small'
                        placeholder=''
                        value={this.state.editComm1 || ''}
                        onChange={(e) => this.setState({ editComm1: e.target.value })}
                      />
                    </Col>
                    <Col flex='154px' className='text-center p-0 right-section'>
                      <label className='custom-label transparent'>-</label>
                      <Button type='ghost' className='ml-auto image-btn' onClick={() => this.submit('add')}>
                        <Tooltip title={this.state.isEdit ? 'Update' : 'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                      </Button>
                    </Col>
                  </Row>}
                  <Col xs={24}>
                    <div className='table-outer'>
                      <Table
                        className='custom-table w-100'
                        dataSource={this.state.editAllocArray} columns={CCcolumns}
                        pagination={false}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* <Row className='opti-row'> */}
            {/* </Row> */}
          </Row>
          <div className='print-uld-show'>
            <Table
              className='print-uld-table'
              dataSource={this.state.mergeEditRecord?.sort(awbSortFunction) || []}
              columns={awbColumns}
              pagination={false}
            />
          </div>
        </Modal>

        <Drawer
          title='Build Plan Email History'
          placement='right'
          width={'80%'}
          open={this.state.buildPlanDrawerVisible}
          onClose={this.closeBuildPlanDrawer}
          // getContainer={false}
          // rootStyle={{ position: 'absolute' }}
          destroyOnClose
          zIndex={1100}
          className='email-drawer'
        >
          {/* {this.state.editRecord?.dod_email &&
                    <Typography.Text className='mb-0 sent-email'>Last Email Sent By: {this.state.editRecord?.dod_email?.from} </Typography.Text>
                  } */}

          {/* </Col> */}
          <Row gutter={[24, 24]} wrap={true}>
            <Col  xs={{
              span: 24,
              order: 2 
            }} xl={{
              span: 16,
              order: 1 
            }}>
              <Card className='custom-card'>
                <div className='doc-header'>
                  <Title level={5} className='drawer-card-title'>Document Viewer</Title>
                  <Button title='Download as PDF' key='download' type='text' onClick={this.downloadEmailAsPDF} icon={<DownloadOutlined />} />
                  {/* Download as PDF
                </Button> */}
                </div>
                {(() => {
                  return null
                })()}
                {this.state.selectedEmail ? (
                  this.state.selectedEmail.body ? (
                    <div>
                      {/* Email metadata header */}
                
                
                      {/* Method 2: iframe (more reliable for complex HTML) */}
                      <iframe
                        id='email-preview-iframe'
                        title='Email Preview'
                        className='email-preview-iframe'
                        onLoad={() => {
                          console.log('Iframe loaded')
                          const iframe = document.getElementById('email-preview-iframe')
                          if (iframe) {
                          // Adjust iframe height to content
                            setTimeout(() => {
                              try {
                                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
                                const height = iframeDoc.body.scrollHeight
                                iframe.style.height = (height + 40) + 'px'
                                console.log('Iframe height adjusted to:', height + 40)
                              } catch (e) {
                                console.log('Could not adjust iframe height:', e)
                              }
                            }, 200)
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <div className='email-preview-state'>
                      <p>No email content available</p>
                      <p className='email-preview-state-subtext'>Email body is empty</p>
                    </div>
                  )
                ) : (
                  <div className='email-preview-state'>
                    <Spin />
                    <p className='email-preview-loading-text'>Loading email preview...</p>
                  </div>
                )}
              </Card>
            </Col>
            <Col xs={{
              span: 24,
              order: 1 
            }} xl={{
              span: 8,
              order: 2 
            }}>
              <Card className='custom-card h-100'>
                <Title level={5} className='drawer-card-title'>Email History</Title>

                {this.state.emailLogs && this.state.emailLogs.length > 0 ?
                  (
                    <Radio.Group
                      value={this.state.emailRadioValue}
                      onChange={(e) => {
                        this.setState({ emailRadioValue: e.target.value })
                        this.onOpenDrawer()
                      }}
                      defaultValue={this.state.emailLogs[0]?.id}
                    >
                       
                      {this.state.emailLogs.map((item, index) => (
                        <Radio value={item.id} className='email-radio-item' size='small' key={index}>
                          <div className='email-history-item'>
                            <div className='email-history-item-header'>
                              <span className='email-history-item-date'>{item?.mailfrom} | {moment.utc(item?.createdAt).tz(this.state.timezone).format(dateTimeFormat).toUpperCase()}</span>
                              <span className='email-history-item-subject'>{item?.sub}</span>
                            </div>
                            <div className='email-history-item-body'>
                              <strong>To:</strong> {item.mailto?.join(', ') || 'N/A'}
                            </div>
                          </div>
                        </Radio>
                      ))}
                    </Radio.Group>

                  ) : (
                    <div style={{
                      padding: '20px',
                      textAlign: 'center',
                      color: '#999'
                    }}>
                          No email history available
                    </div>
                  )
                }
              </Card>
            </Col>
          </Row>
        </Drawer>

        <div ref={this.modalRef}>
          <div className='email-table' // class not applied to email
            style={{
              fontSize: '13px',
              textAlign: 'left',
              direction: 'ltr',
              verticalAlign: 'bottom',
              width: '100%'
            }}>

            <table align='center' border='0' cellPadding='0' cellSpacing='0' role='presentation'>
              <tbody>
                <tr>
                  <td
                    style={{
                      borderBottom: '#333957 solid 5px',
                      backgroundColor: '#f2f2f2',
                      direction: 'ltr',
                      fontSize: 0,
                      padding: '20px 0',
                      textAlign: 'center',
                      verticalAlign: 'top',
                    }}
                  ></td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '#dddddd solid 1px',
                      borderTop: '0px',
                      direction: 'ltr',
                      fontSize: 0,
                      padding: '20px 0',
                      textAlign: 'center',
                      verticalAlign: 'top',
                    }}
                  >
                    <table border='0' cellPadding='0' cellSpacing='0' role='presentation' style={{ verticalAlign: 'bottom' }}
                      width='100%'>

                      <tbody>

                        <tr>
                          <td align='center' style={{
                            padding: '25px',
                            paddingBottom: '40px',
                            wordBreak: 'break-word'
                          }}>

                            <div style={{
                              fontSize: '22px',
                              lineHeight: '1',
                              textAlign: 'center',
                              color: '#555',
                              borderBottom: '2px solid #df1931',
                              paddingBottom: '12px'
                            }}>
                              Build Plan: {this.state.editRecord?.flight_no || 'N/A'}/{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'} {this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td align='left' style={{
                            padding: '10px 25px',
                            paddingBottom: '30px',
                            wordBreak: 'break-word'
                          }}>
                            <p style={{
                              fontSize: '18px',
                              color: '#013466'
                            }}>Hello User,</p>
                            <div style={{
                              fontSize: '16px',
                              lineHeight: '1',
                              color: '#555'
                            }}>
                              Build Plan: {this.state.editRecord?.flight_no || 'N/A'}/{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'} {this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td style={{ verticalAlign: 'top' }}>
                            <div style={{
                              width: '100%',
                              padding: '25px',
                            }}>
                              <div style={{
                                minWidth: '240px',
                                borderRadius: '4px',
                                background: '#fff',
                                marginBottom: '30px',
                                marginRight: '20px',
                                width: '20%',
                                display: 'inline-block'
                              }}>
                                <table style={{
                                  borderCollapse: 'collapse',
                                  width: '100%'
                                }}>
                                  <tbody>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Flight #</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.flight_no || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Date</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left',
                                      }}>AC</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.ac_type || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Seg</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Ship #</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.wgt_bal_plan?.ship || 'N/A'}</td>
                                    </tr>

                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Departure Time</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.dept_time && `${this.state.editRecord?.dept_prefix} ${moment.tz(this.state.editRecord.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>FPE Time</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('HH:mm') : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Plan Due</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.props.milestoneData && this.props.milestoneData.length > 0 ? (
                                          (() => {
                                            let planDue = this.props.milestoneData.find(
                                              (item) => item?.type === 'Dod' && item.title === 'Build Plan Submitted to Warehouse'
                                            )
                                            if (planDue) {
                                              const cutoffTime = this.state.editRecord?.dept_date ? moment
                                                .utc(this.state.editRecord?.dept_date)
                                                .tz(this.state.timezone)
                                                .subtract(this.getCutoff(planDue.cutoff, this.state.editRecord), 'hours') : null

                                              // Return the formatted time value or render it within a JSX element
                                              // return `SKD ${cutoffTime.format('HH:mm')} ACT ${this.getAct(this.state.editRecord, planDue.id, 'HH:mm') || 'N/A'}`
                                              return `SKD ${cutoffTime?.format('HH:mm')}`

                                            } else {
                                              return '-'
                                            }
                                          })()
                                        ) : (
                                          '-'
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>P CAP / FCST</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.pax_cap || 0} / {this.state.editFcst || 0}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Bag Posns</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px'
                                      }}>
                                        <p style={{
                                          margin: 0,
                                          display: 'inline-block',
                                          marginRight: '20px'
                                        }}>LD3:&nbsp;&nbsp;{this.state.editBagLD3 || 0}</p>
                                        <p style={{
                                          margin: 0,
                                          display: 'inline-block'
                                        }}>LD2:&nbsp;&nbsp;{this.state.editBagLD2 || 0}</p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Cargo Payload</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editWgtValue || 0}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>BU PRIO</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editBuPrio === true ? 'Y' : 'N'}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div style={{
                                minWidth: '500px',
                                display: 'inline-block'
                              }}>
                                <table style={{
                                  borderCollapse: 'collapse',
                                  width: '100%',
                                  marginBottom: '30px'
                                }}>
                                  <thead>
                                    <tr>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}></th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>PMC</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>PAG</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>LD2</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>LD3</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>Hints</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>Notes</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td style={{
                                        background: '#eeeeee',
                                        fontWeight: 'bold',
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>Max ULD <br /> Configuration</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoP96 || this.state.editRecord?.cargo?.p96 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoP88 || this.state.editRecord?.cargo?.p88 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        maxWidth: '150px',
                                      }}>{this.state.hints || this.state.editRecord?.cargo?.hint}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        maxWidth: '150px',
                                      }}>{this.state.notes || this.state.editRecord?.cargo?.note}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        background: '#eeeeee',
                                        fontWeight: 'bold',
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>Planned Bin <br /> Configuration</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => u.type === 'PMC')))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => u.type === 'PAG')))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => (['LD2', 'DPA', 'DPE', 'DPL', 'DPN', 'LD4', 'LD8', 'FQA', 'DQL', 'DQP', 'DQF'].includes(u?.type))))?.length + this.state.editRecord?.build_uld?.filter((u => (['LD4', 'LD8', 'FQA', 'DQL', 'DQP', 'DQF'].includes(u?.type))))?.length) : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => ['LD3', 'AKE', 'AKN', 'AKX', 'AKY', 'RKN', 'PLA', 'FLA', 'PLB'].includes(u?.type))))?.length + (this.state.editRecord?.build_uld?.filter((u => ['PLA', 'FLA', 'PLB'].includes(u?.type))))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>-</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>-</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            paddingBottom: '30px',
                            wordBreak: 'break-word'
                          }}>

                            <div>
                              <table border='1' cellSpacing='0' cellPadding='4' style={{
                                fontSize: '12px',
                                borderCollapse: 'collapse',
                                width: '100%'
                              }}>
                                <thead>
                                  <tr>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>AWB Nb</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Dest</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Comment</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Days Delayed</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Pcs</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Gr.Wt ({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'})</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Vol ({this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'})</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>ULD Type</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>ULD Prio</th>

                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>On Hand?</th>
                                  </tr>

                                </thead>
                                <tbody>
                                  {(() => {

                                    const planUlds = [
                                      ...(this.state.activeTab === 'initial'
                                        ? this.state.editRecord?.init_build_plan?.data?.build_uld || []
                                        : this.state.activeTab === 'final'
                                          ? this.state.editRecord?.final_build_plan?.data?.build_uld || []
                                          : this.state.editRecord?.build_uld || []
                                      ).sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt),

                                      ...(this.state.editRecord?.ulds_out?.filter(u =>
                                        u.info?.remark?.includes('SLU')
                                      ) || []),

                                      {
                                        id: 0,
                                        type: 'BULK'
                                      }
                                    ]

                                    let awbAssigned = []
                                    const awbMap = {}

                                    return (
                                      <>
                                        {/* ================= ASSIGNED ================= */}
                                        {planUlds.map((uld) => {
                                          const awbs = this.showAwbs(uld, getCurrentPlan()) || []
                                          const filteredAwbs = awbs.filter((item) => !item.is_deleted && item?.awb_no)
                                          const totals = filteredAwbs.reduce((acc, a) => {
                                            let vol = this.state.editWgtUnit === 'LB'
                                              ? Math.round(this.updateVolumeVal('CBF', a.vol || 0) * 10) / 10
                                              : Math.round((a.vol || 0) * 10) / 10
                                            acc.pcs += a.pcs || 0
                                            acc.wgt += a.wgt || 0
                                            acc.vol += vol || 0

                                            // build assigned map
                                            awbAssigned.push({
                                              awb_no: a.awb_no,
                                              pcs: (awbAssigned.find(x => x.awb_no === a.awb_no)?.pcs || 0) + 1,
                                              // new
                                              wgt: (awbAssigned.find(x => x.awb_no === a.awb_no)?.wgt || 0) + Math.round(a.wgt),
                                              vol: (awbAssigned.find(x => x.awb_no === a.awb_no)?.vol || 0) + vol
                                            })

                                            if (acc.wgt < 0) acc.wgt = 0
                                            if (acc.vol < 0) acc.vol = 0

                                            return acc
                                          }, {
                                            pcs: 0,
                                            wgt: 0,
                                            vol: 0
                                          })

                                          filteredAwbs.forEach((a) => {
                                            let vol = this.state.editWgtUnit === 'LB'
                                              ? Math.round(this.updateVolumeVal('CBF', a.vol || 0) * 10) / 10
                                              : Math.round((a.vol || 0) * 10) / 10
                                            if (!a?.awb_no) return

                                            if (!awbMap[a.awb_no]) {
                                              awbMap[a.awb_no] = {
                                                awb_no: a.awb_no,
                                                pcs: 0,
                                                wgt: 0,
                                                vol: 0
                                              }
                                            }

                                            //  SUM pcs across ALL ULDs
                                            awbMap[a.awb_no].pcs += Number(a.pcs) || 0
                                            awbMap[a.awb_no].wgt += Math.round(Number(a.wgt) || 0)
                                            awbMap[a.awb_no].vol += vol || 0
                                          })

                                          return (
                                            <>
                                              {filteredAwbs.map((awb, i) => (
                                                <tr key={awb.awb_no + i}>
                                                  {/* <tr key={`${uld?.id || 'bulk'}-${awb.awb_no}-${i}`}> */}
                                                  <td style={{
                                                    textAlign: 'center',
                                                    color: awb.spl_code?.includes('RDG') || awb.spl_code?.includes('ICE') || awb.spl_code?.includes('ICV') ? 'red' : (awb.spl_code?.includes('AMZ') ? '#007bff' : 'inherit')
                                                  }}>
                                                    {awb.awb_no
                                                      ? awb.awb_no.slice(0, 3) + '-' + awb.awb_no.slice(3)
                                                      : ''}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>{awb.dest}</td>
                                                  <td style={{ textAlign: 'center' }}>{awb.comment}</td>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb?.delay > 0
                                                      ? <span className='color-red'>{awb.delay}</span>
                                                      : <span>{awb?.delay || 0}</span>}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>{awb.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(awb.wgt)}</td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {this.state.editWgtUnit === 'LB'
                                                      ? Math.round(this.updateVolumeVal('CBF', awb?.vol || 0) * 10) / 10
                                                      : Math.round((awb?.vol || 0) * 10) / 10}
                                                  </td>

                                                  {i === 0 && (
                                                    <>
                                                      <td rowSpan={filteredAwbs.length + 1} style={{
                                                        color: '#006bbe',
                                                        fontWeight: 'bold',
                                                        textAlign: 'center'
                                                      }}>
                                                        {awb.uld_id === 0 ? 'Bulk' : awb.uld_type}
                                                        <span style={{
                                                          color: 'grey',
                                                          display: 'block'
                                                        }}>{uld?.uld_no}{uld?.pallet_stacked ? ' (Pallet Stack)' : ''}</span>
                                                      </td>
                                                      <td rowSpan={filteredAwbs.length + 1} style={{ textAlign: 'center' }}>{awb.pri || '-'}</td>
                                                    </>
                                                  )}
                                                  <td style={{ textAlign: 'center' }}>{awb?.on_hand ? 'Y' : 'N'}</td>
                                                </tr>
                                              ))}

                                              {/* TOTAL ROW */}
                                              {filteredAwbs.length > 0 && (
                                                <tr style={{
                                                  fontWeight: 'bold',
                                                  color: '#006bbe'
                                                }}>
                                                  <td colSpan='4'></td>
                                                  <td style={{ textAlign: 'center' }}>{totals.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(totals.wgt)}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(totals.vol * 10) / 10}</td>
                                                  <td style={{ textAlign: 'center' }}></td>
                                                </tr>
                                              )}
                                              {filteredAwbs.length > 0 && (
                                                <tr><td colSpan='10' style={{
                                                  background: 'transparent',
                                                  height: '24px'
                                                }}></td></tr>)}
                                            </>
                                          )
                                        })}

                                        {/* ================= UNASSIGNED ================= */}
                                        {(() => {
                                          const unassigned = this.getUnassignedAwbs() || []
                                          const awbAssigned = Object.values(awbMap)
                                          const awbLookup = Object.fromEntries(
                                            awbAssigned.map(a => [a.awb_no, a])
                                          )
                                          // ================= TOTAL CALC =================
                                          const totals = unassigned.filter((item) => !item.is_deleted).reduce((acc, a) => {
                                            const lookup = awbLookup[a.awb_no] || {}

                                            // ---------- PCS ----------
                                            let pcs = (Number(a?.pcs) || 0) - (Number(lookup?.pcs) || 0)
                                            pcs = Math.max(0, pcs)

                                            // ---------- WGT ----------
                                            let unit = a?.wgt?.unit
                                            let wgtValue = Number(a?.wgt?.value) || 0

                                            if (this.state.editWgtUnit === 'KG') {
                                              if (['L', 'LB', 'LBS', 'LBR'].includes(unit)) {
                                                wgtValue = this.updateWeightVal('KG', wgtValue)
                                              }
                                            } else if (this.state.editWgtUnit === 'LB') {
                                              if (['K', 'KG', 'KGM', 'KGS'].includes(unit)) {
                                                wgtValue = this.updateWeightVal('LB', wgtValue)
                                              }
                                            }

                                            wgtValue = wgtValue - (Number(lookup?.wgt) || 0)
                                            wgtValue = Math.max(0, wgtValue)

                                            // ---------- VOL ----------
                                            let vol = Number(a?.vol?.value) || 0

                                            if (this.state.editWgtUnit === 'LB' && a?.vol?.unit === 'CBM') {
                                              vol = this.updateVolumeVal('CBF', vol)
                                            } else if (
                                              this.state.editWgtUnit === 'KG' &&
                                              ['CBF', 'CFT'].includes(a?.vol?.unit)
                                            ) {
                                              vol = this.updateVolumeVal('CBM', vol)
                                            }

                                            vol = vol - (Number(lookup?.vol) || 0)
                                            vol = Math.max(0, vol)

                                            // ---------- ACCUMULATE ----------
                                            acc.pcs += pcs
                                            acc.wgt += wgtValue
                                            acc.vol += vol

                                            return acc
                                          }, {
                                            pcs: 0,
                                            wgt: 0,
                                            vol: 0
                                          })

                                          let filtered_unassigned = unassigned.filter(awb => {
                                            let pcs = (Number(awb.pcs) || 0) - (Number(awbLookup[awb.awb_no]?.pcs) || 0)
                                            return pcs > 0
                                          })

                                          return (
                                            <>
                                              {filtered_unassigned.filter((item) => !item.is_deleted).map((awb, i) => (
                                                <tr key={awb.awb_no + i}>
                                                  <td style={{
                                                    textAlign: 'center',
                                                    color: awb.spl_code?.includes('RDG') || awb.spl_code?.includes('ICE') || awb.spl_code?.includes('ICV') ? 'red' : (awb.spl_code?.includes('AMZ') ? '#007bff' : 'inherit')
                                                  }}>
                                                    {awb.awb_no
                                                      ? awb.awb_no.slice(0, 3) + '-' + awb.awb_no.slice(3)
                                                      : ''}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>{awb.dest}</td>
                                                  <td style={{ textAlign: 'center' }}>{awb.comment}</td>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb?.delay > 0
                                                      ? <span className='color-red'>{awb.delay}</span>
                                                      : <span>{awb?.delay || 0}</span>}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      return <div>
                                                        {(Number(awb.pcs) || 0) - (Number(awbLookup[awb.awb_no]?.pcs) || 0)}
                                                      </div>
                                                    })()}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      let unit = awb?.wgt?.unit
                                                      let wgtValue = ''
                                                      {
                                                        if (this.state.editWgtUnit === 'KG') {
                                                          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
                                                            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
                                                            wgtValue = kg
                                                          }
                                                          else {
                                                            wgtValue = awb?.wgt?.value
                                                          }
                                                        }
                                                        else if (this.state.editWgtUnit === 'LB') {
                                                          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
                                                            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
                                                            wgtValue = lb
                                                          }
                                                          else {
                                                            wgtValue = awb?.wgt?.value
                                                          }
                                                        }
                                                      }
                                                      return <div>
                                                        {Math.round((Number(wgtValue) || 0) - (Number(awbLookup[awb.awb_no]?.wgt) || 0))}
                                                      </div>
                                                    })()}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      let vol = awb?.vol?.value || 0
                                                      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
                                                        vol = this.updateVolumeVal('CBF', vol)
                                                      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
                                                        vol = this.updateVolumeVal('CBM', vol)
                                                      }

                                                      return <div>
                                                        {Math.round((vol - (awbLookup[awb.awb_no]?.vol || 0)) * 10) / 10}
                                                      </div>
                                                    })()}
                                                  </td>

                                                  {i === 0 && (
                                                    <>
                                                      <td rowSpan={filtered_unassigned.length + 1} style={{
                                                        color: '#006bbe',
                                                        fontWeight: 'bold',
                                                        textAlign: 'center'
                                                      }}>
                                                        Not Assigned
                                                      </td>
                                                      <td rowSpan={filtered_unassigned.length + 1} style={{ textAlign: 'center' }}>{filtered_unassigned.length > 0 ? Math.max(...filtered_unassigned.map(u => Number(u.pri) ?? 0)) : ''}</td>
                                                    </>
                                                  )}
                                                  <td style={{ textAlign: 'center' }}>{awb?.on_hand ? 'Y' : 'N'}</td>
                                                </tr>
                                              ))}

                                              {/* TOTAL ROW */}
                                              {filtered_unassigned.length > 0 && (
                                                <tr style={{
                                                  fontWeight: 'bold',
                                                  color: '#006bbe'
                                                }}>
                                                  <td colSpan='4'></td>
                                                  <td style={{ textAlign: 'center' }}>{totals.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(totals.wgt)}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(totals.vol * 10) / 10}</td>
                                                  <td style={{ textAlign: 'center' }}></td>
                                                </tr>
                                              )}
                                            </>
                                          )
                                        })()}

                                      </>
                                    )
                                  })()}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>
                            <p style={{
                              fontSize: '16px',
                              textAlign: 'left',
                              display: 'inline-block',
                              width: '50%',
                              marginBottom: 0
                            }}>Load Planning Notes</p>
                            <div style={{
                              display: 'inline-block',
                              textAlign: 'right',
                              width: '50%'
                            }}>
                              <p style={{
                                fontSize: '16px',
                                display: 'inline-block',
                                marginBottom: 0
                              }}>Last Update: </p>
                              <div style={{
                                fontSize: '16px',
                                display: 'inline-block'
                              }}>
                                <b style={{
                                  display: 'inline-block',
                                  paddingRight: '10px'
                                }}>{this.state.lastUpdatedAt ? this.state.lastUpdatedAt + ' ' + this.state.ext : 'N/A'}</b>
                                <b style={{ display: 'inline-block', }}>{this.state.lastUpdatedBy ? this.state.lastUpdatedBy : 'N/A'}</b>
                              </div>
                            </div>
                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>

                            <div>
                              <table align='center' border='0' cellPadding='6' cellSpacing='0' role='presentation' width='100%'>
                                <thead>
                                  <tr style={{
                                    backgroundColor: '#dddddd',
                                    textAlign: 'center'
                                  }}>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>DOD Team Comments</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Warehouse Team Comments</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.editAllocArray.map((record, index) => {
                                    return (<tr key={index}>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 6px',
                                        fontSize: '12px',
                                        textAlign: 'center'
                                      }}>{record?.comm1}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 6px',
                                        fontSize: '12px',
                                        textAlign: 'center'
                                      }}>{record?.comm2}</td>
                                    </tr>
                                    )
                                  })
                                  }
                                </tbody>
                              </table>
                            </div>

                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>

                            <div style={{
                              fontSize: '14px',
                              lineHeight: '20px',
                              paddingTop: '30px',
                              textAlign: 'left',
                              color: '#525252'
                            }}>
                              Regards,<br /><br />
                              {cookies.get('name')}
                              <br />
                              Cargo Optimization Team<br />
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td style={{
                            fontSize: '0px',
                            padding: '20px 0'
                          }}></td>
                        </tr>

                      </tbody>
                    </table>

                  </td>
                </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
    )

  }
}

export default BuildPlan
